import PreviewAudienceContent from './PreviewAudienceContent';
import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { getBackendUrl } from "../../../utils/getBackendUrl";
import "../../../css/Influencer.css";
import "../../SelfServe/InfluencerStepper.css";
import "../../Influencer/Dashboard.css";
import "typeface-roboto";
import InfiniteScroll from "react-infinite-scroll-component";
//    RedditShareButton} from "react-share";
import { GridScrollContent } from "../../Home/GridScrollContent";
import { HubDesktopShellContext } from "../../Elements/HubDesktopShell";
import SectionPlaceholder from "../SectionPlaceholder";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import CreatorContentCard from "../../common/CreatorContentCard";
import { Grid, Button, IconButton, Tooltip, TextField, CircularProgress } from "@mui/material";
import { Box, Pagination, Typography, Select, MenuItem, FormControl } from "@mui/material";
import axios from "axios";
import Fade from "react-reveal/Fade";
import SwiperContent from "../SwiperContent";
import Community from "../Community/Community";
import Async from "../Async/Async";
import PaidDMs from "../PaidDms/PaidDMs";
import URLCard from "../InfluencerSubComponents/CreatorView/URLCard";
import URLProductPreview from "../DigitalProducts/URLProductPreview";
import MobileFrame from "../../common/MobileFrame";
import LeadCapture from "./CreatorView/LeadCapture";
// import {BiSolidBank} from "react-icons/bi";
// import NoCollections from "../Collections/NoCollections";
import MembershipOffering from "../Membership/MembershipOffering";
// import SelfServe6ASetupOffering from "../../SelfServe/OnboardingComponents/SelfServe6ASetupOffering";
import CreatePriceStr from "../../common/common/CreatePriceStr";
import { useApp } from '../../../context/AppContext';
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SelfServe6AYourOfferingModal from "../../SelfServe/OnboardingComponents/SelfServe6AYourOfferingModal";
import SetupPaidDMs from "../Membership/SetupPaidDMs";
import { styled } from "@mui/material/styles";
import ShareModal from "../../common/ShareModal";
import SnackbarAlert from "../../common/SnackbarAlert";
import { CgYinyang } from "react-icons/cg";
import CoursePreview from "../Collections/CoursePreview";
import { ReactSortable } from "react-sortablejs";
import { MdDragIndicator } from "react-icons/md";
import { FaFileAudio, FaFileImage, FaFileLines, FaFilePdf, FaFileVideo } from "react-icons/fa6";
import { BiBroadcast } from "react-icons/bi";
import NoPosts from "../Subscriptions/NoPosts";
import NoCollections from "../Subscriptions/NoCollections";
import { TbArrowsCross, TbPencil, TbTrash, TbChevronRight, TbPlus, TbClock } from "react-icons/tb";
import { FaRegCircleCheck, FaRegCircleXmark } from "react-icons/fa6";
import ShareEarnButton from "../../Affiliate/ShareEarnButton";
import { IoClose } from "react-icons/io5";
import goToBilling from '../../../utils/goToBilling';
import { usePreviewReadOnly } from '../PreviewReadOnlyContext';
const paths = require("../../../paths.json");

const BlueButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#3b55f3"),
  paddingLeft: "30px",
  paddingRight: "30px",
  backgroundColor: "#3b55f3",
  "&:hover": {
    backgroundColor: "#3b55f3",
  },
}));

const ContentTypeTag = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "fit-content",
  alignItems: "center",
  gap: "3px",
  backgroundColor: "#f5f9ff",
  padding: "7px 12px",
  borderRadius: "20px",
  color: "#6E89AF",
  fontSize: "12px",
  fontWeight: "600",
}));

const StyledPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPaginationItem-root": {
    fontWeight: 500,
    fontFamily: "Roboto",
    color: "black",
    backgroundColor: "var(--rebrandind-background-color)",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#e3e7fc",
      color: "var(--brand-color)",
    },
  },
  "& .Mui-selected": {
    backgroundColor: "#e3e7fc",
    color: "var(--brand-color)",
    borderRadius: "8px",
    fontWeight: 500,
    fontFamily: "Roboto",
  },
  "& .Mui-selected:hover": {
    backgroundColor: "#d7ddfc",
    color: "var(--brand-color)",
    borderRadius: "8px",
    fontWeight: 500,
    fontFamily: "Roboto",
  },
}));

const ReorderingCardList = ({ contentData, setContentData, isReordering, is_me, windowWidth }) => {
  const { t } = useTranslation();

  const getPostType = (type) => {
    switch (type) {
      case "txt":
        return <ContentTypeTag><FaFileLines /><p style={{margin: 0}}>{t('content.types.text')}</p></ContentTypeTag>;
      case "img":
        return <ContentTypeTag><FaFileImage /><p style={{margin: 0}}>{t('content.types.image')}</p></ContentTypeTag>;
      case "vid":
        return <ContentTypeTag><FaFileVideo /><p style={{margin: 0}}>{t('content.types.video')}</p></ContentTypeTag>;
      case "vey":
         return <ContentTypeTag><FaFileVideo /><p style={{margin: 0}}>{t('content.types.video')}</p></ContentTypeTag>;
      case "vel":
         return <ContentTypeTag><FaFileVideo /><p style={{margin: 0}}>{t('content.types.video')}</p></ContentTypeTag>;
      case "aud":
        return <ContentTypeTag><FaFileAudio /><p style={{margin: 0}}>{t('content.types.audio')}</p></ContentTypeTag>;
      case "pdf":
        return <ContentTypeTag><FaFilePdf /><p style={{margin: 0}}>{t('content.types.pdf')}</p></ContentTypeTag>;
      case "ivs":
        return <ContentTypeTag><BiBroadcast /><p style={{margin: 0}}>{t('content.types.live')}</p></ContentTypeTag>;
      default:
        return type;
    }
  }
  
  return contentData.length > 0 ? (
    <ReactSortable
      list={contentData || []}
      setList={setContentData}
      disabled={!isReordering}
      animation={150}
      handle=".drag-handle"
      className="grid-container"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: isReordering ? "column" : "row",
        flexWrap: isReordering ? "nowrap" : "wrap",
        gap: "20px",
      }}
    >
      {contentData.map((content, index) => (
        <Box
          sx={{
            backgroundColor: "white",
            border: '1px solid #E4EBF6',
            borderRadius: "10px",
            padding: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          <Box sx={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px', width: '90%'}}>
            <p style={{fontSize: windowWidth < 600 ? '14px' : '16px', fontWeight: 600, margin: 0}}>{content.name}</p>
            {getPostType(content.content_type)}
          </Box>
          <div className="drag-handle" style={{ cursor: "grab", height: "100%", display: "flex", alignItems: "center" }}>
            <MdDragIndicator style={{ color: "#6E89AF", fontSize: "20px" }} />
          </div> 
        </Box>
      ))}
    </ReactSortable>
  ) : null;
};

const InfluencerContentOriginal = function InfluencerContent(props) {
  const isCustomerPreview = props.previewRolloutOwner && props.isCustomerPreview;
  const isVisitorPreview = props.isLoggedOutView && !isCustomerPreview;
  // True when rendered inside the desktop hub shell's right column
  // (Elements/HubDesktopShell.jsx) - false at every width below 1280px.
  const isShellActive = useContext(HubDesktopShellContext);
  const isCollectionAccessBlocked = (collection, requirePaidCollection = false) => (
    isVisitorPreview || (!isCustomerPreview && (
      collection?.locked ||
      (!props.current_user && collection?.collection_price === 0 && (!requirePaidCollection || props.selected_tab === 'paid_collections')) ||
      (requirePaidCollection && props.influencer_bool && props.current_page_view === 'preview' && props.selected_tab === 'paid_collections' && props.view_type !== 'user-subscribed')
    ))
  );
  const { t } = useTranslation();
  const previewReadOnly = usePreviewReadOnly();
  const { currency: appCurrency } = useApp();
  // Dashboard Component Items for Membership
  const [intercomLoc, setIntercomLoc] = useState(false);
  const [isReorderChaptersMode, setIsReorderChaptersMode] = useState(false);
  const [reorderedChapters, setReorderedChapters] = useState([]);
  const [isSavingChapterOrder, setIsSavingChapterOrder] = useState(false);
  const [dragIdx, setDragIdx] = useState(null);
  const [mobileReorderModalOpen, setMobileReorderModalOpen] = useState(false);
  const [mobileChaptersExpanded, setMobileChaptersExpanded] = useState(false);
  const [addChapterModalOpen, setAddChapterModalOpen] = useState(false);
  const [newChapterName, setNewChapterName] = useState('');
  
  // Edit chapter modal state
  const [editChapterModalOpen, setEditChapterModalOpen] = useState(false);
  const [editingChapterId, setEditingChapterId] = useState(null);
  const [editingChapterName, setEditingChapterName] = useState('');
  const [editingChapterIndex, setEditingChapterIndex] = useState(null);
  const [isUpdatingChapterName, setIsUpdatingChapterName] = useState(false);
  const [deleteChapterModalOpen, setDeleteChapterModalOpen] = useState(false);
  const [deletingChapterId, setDeletingChapterId] = useState(null);
  const [deletingChapterName, setDeletingChapterName] = useState('');
  const [isDeletingChapter, setIsDeletingChapter] = useState(false);

  // When drip feed or progress stats mode is active, hide normal content (SinglePageCollection renders the panel)
  const isDripOrStatsMode = props.isDripFeedMode || props.state?.isDripFeedMode || props.isProgressStatsMode || props.state?.isProgressStatsMode;

  // Progress tracking - chapter + content completion data
  const [chapterCompletion, setChapterCompletion] = useState({});
  const [courseCompletion, setCourseCompletion] = useState(null);
  const [contentCompletion, setContentCompletion] = useState({});
  const [totalEnrolled, setTotalEnrolled] = useState(0);
  const [courseStats, setCourseStats] = useState(null);

  // Progress tracking completion handler
  const handleToggleComplete = (contentId, courseId) => {
    // Preview simulates course access, so ticking a lesson here would write
    // real progress against the owner's own account.
    if (previewReadOnly) return;
    const form_data = new FormData();
    form_data.append('content_id', contentId);
    form_data.append('course_id', courseId);
    axios.post(getBackendUrl() + 'api/influencer/community/toggle_lesson_completion', form_data, { withCredentials: true })
      .then(res => {
        if (res.data.error) return;
        if (props.influencer_content_list) {
          const updatedList = props.influencer_content_list.map(item =>
            item.id === contentId ? { ...item, is_completed: res.data.is_completed } : item
          );
          props.setState({ influencer_content_list: updatedList });
        }
        // Re-fetch completion data
        const selectedCol = collectionData?.[collectionIndex];
        if (selectedCol?.id) {
          const refetchForm = new FormData();
          refetchForm.append('course_id', selectedCol.id);
          axios.post(getBackendUrl() + 'api/influencer/load_course_chapters', refetchForm, { withCredentials: true })
            .then(refetchRes => {
              if (refetchRes.data.chapter_completion) setChapterCompletion(refetchRes.data.chapter_completion);
              if (refetchRes.data.course_completion) {
                setCourseCompletion(refetchRes.data.course_completion);
                props.setState({ _courseCompletionData: refetchRes.data.course_completion });
              }
              if (refetchRes.data.content_completion) setContentCompletion(refetchRes.data.content_completion);
              if (refetchRes.data.total_enrolled) setTotalEnrolled(refetchRes.data.total_enrolled);
            })
            .catch(() => {});
        }
      })
      .catch(() => {});
  };

  // Example course content (shown when course has no chapters/content)
  const courseExamplesDismissedKey = `courseExamplesDismissed_${props.single_view_collection || ''}`;
  const [courseExamplesDismissed, setCourseExamplesDismissed] = useState(false);
  useEffect(() => {
    if (props.single_view_collection && typeof props.single_view_collection === 'string' && props.single_view_collection.length > 0) {
      try {
        const key = `courseExamplesDismissed_${props.single_view_collection}`;
        setCourseExamplesDismissed(localStorage.getItem(key) === 'true');
      } catch { setCourseExamplesDismissed(false); }
    }
  }, [props.single_view_collection]);
  const dismissCourseExamples = () => {
    setCourseExamplesDismissed(true);
    try { localStorage.setItem(courseExamplesDismissedKey, 'true'); } catch {}
  };
  const [selectedExampleChapterId, _setSelectedExampleChapterId] = useState('ex-ch-1');
  const setSelectedExampleChapterId = (id) => {
    _setSelectedExampleChapterId(id);
    // Sync index to parent state for SinglePageCollection drip feed filtering
    const idx = exampleChapters.findIndex(ch => ch.id === id);
    props.setState && props.setState({ selectedExampleChapter: idx >= 0 ? idx : 0 });
  };
  const exampleInfluencerName = props.influencer_info?.influencer || props.influencer || props.influencer_name || '';
  const exampleDisplayName = props.display_name || props.influencer_display_name || exampleInfluencerName || 'Creator';
  const EX_CDN = 'https://openaccessimages.s3.eu-west-2.amazonaws.com/example_course_content';
  const exampleContentBase = {
    tier: 0, current_tier: 5, n_likes: 0, n_comments: 0, content_like: false, is_favourite: false,
    is_mine: true, is_example: true, influencer: exampleInfluencerName, influencer_name: exampleDisplayName,
    icon_image_file: props.influencer_icon || '', pinned: false, aspect_ratio: null, thumbnail_aspect_ratio: null,
    files: [], files_length: 0, content_price: 0, collection_price: 0, downloadable: false,
    content_settings: null, preview: null, description: '', scheduled_date: null, n_views: 0,
    thumbnail_overlay_text: '', course_number: 0, is_live: false,
  };
  const [exampleChapters, setExampleChapters] = useState([
    { id: 'ex-ch-1', name: t('course.examples.chapter1', 'Getting Started'), drip_delay_days: 0, drip_delay_unit: 'days', lessons: [
      { ...exampleContentBase, id: 'ex-1', name: t('course.examples.lesson1', 'Welcome & Introduction'), content_type: 'vid', drip_delay_days: 0, file: `${EX_CDN}/video_intro.mp4`, fileUrl: `${EX_CDN}/video_intro.mp4`, thumbnail: `${EX_CDN}/image_welcome.jpg`, text: t('course.examples.lesson1Text', '<p>Welcome to this course! Watch this intro video to learn what to expect and how to get the most out of the material.</p>'), added: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString() },
      { ...exampleContentBase, id: 'ex-2', name: t('course.examples.lesson2', 'Course Overview & Goals'), content_type: 'txt', drip_delay_days: 0, file: null, thumbnail: null, text: t('course.examples.lesson2Text', '<p><strong>Course Overview</strong></p><p>This lesson outlines the key objectives and milestones you\'ll achieve throughout this course.</p><p>Set your own goals and track your progress as you work through each chapter.</p>'), added: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString() },
    ]},
    { id: 'ex-ch-2', name: t('course.examples.chapter2', 'Core Concepts'), drip_delay_days: 3, drip_delay_unit: 'days', lessons: [
      { ...exampleContentBase, id: 'ex-3', name: t('course.examples.lesson3', 'Key Principles'), content_type: 'img', drip_delay_days: 3, file: `${EX_CDN}/image_concepts.jpg`, fileUrl: `${EX_CDN}/image_concepts.jpg`, thumbnail: `${EX_CDN}/image_concepts.jpg`, files: [`${EX_CDN}/image_concepts.jpg`, `${EX_CDN}/image_gallery1.jpg`, `${EX_CDN}/image_gallery2.jpg`], files_length: 3, text: t('course.examples.lesson3Text', '<p>Learn the fundamental principles that form the foundation of everything we cover in this course.</p>'), added: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString() },
      { ...exampleContentBase, id: 'ex-4', name: t('course.examples.lesson4', 'Practical Workbook'), content_type: 'pdf', drip_delay_days: 7, file: `${EX_CDN}/workbook.pdf`, fileUrl: `${EX_CDN}/workbook.pdf`, thumbnail: `${EX_CDN}/image_exercise.jpg`, text: t('course.examples.lesson4Text', '<p>Download and work through this practical workbook to reinforce the concepts from the previous lesson.</p>'), added: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() },
      { ...exampleContentBase, id: 'ex-5', name: t('course.examples.lesson5', 'Photo Gallery'), content_type: 'img', drip_delay_days: 10, file: `${EX_CDN}/image_gallery3.jpg`, fileUrl: `${EX_CDN}/image_gallery3.jpg`, thumbnail: `${EX_CDN}/image_gallery3.jpg`, files: [`${EX_CDN}/image_gallery3.jpg`, `${EX_CDN}/image_gallery4.jpg`], files_length: 2, text: t('course.examples.lesson5Text', '<p>Follow along with these visual guides step by step.</p>'), added: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString() },
    ]},
    { id: 'ex-ch-3', name: t('course.examples.chapter3', 'Advanced Topics'), drip_delay_days: 14, drip_delay_unit: 'days', lessons: [
      { ...exampleContentBase, id: 'ex-6', name: t('course.examples.lesson6', 'Deep Dive Session'), content_type: 'aud', drip_delay_days: 14, file: `${EX_CDN}/audio_deepdive.mp3`, fileUrl: `${EX_CDN}/audio_deepdive.mp3`, thumbnail: `${EX_CDN}/image_advanced.jpg`, text: t('course.examples.lesson6Text', '<p>An in-depth audio session exploring advanced techniques and strategies you can apply immediately.</p>'), added: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString() },
      { ...exampleContentBase, id: 'ex-7', name: t('course.examples.lesson7', 'Video Masterclass'), content_type: 'vid', drip_delay_days: 21, file: `${EX_CDN}/video_masterclass.mp4`, fileUrl: `${EX_CDN}/video_masterclass.mp4`, thumbnail: `${EX_CDN}/image_casestudy.jpg`, text: t('course.examples.lesson7Text', '<p>Watch this masterclass video covering advanced strategies.</p>'), added: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString() },
      { ...exampleContentBase, id: 'ex-8', name: t('course.examples.lesson8', 'Case Study'), content_type: 'txt', drip_delay_days: 28, file: null, thumbnail: null, text: t('course.examples.lesson8Text', '<p><strong>Case Study</strong></p><p>Review this real-world case study to see how the concepts from this course are applied in practice.</p>'), added: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString() },
    ]},
  ]);
  const selectedExampleChapter = Math.max(0, exampleChapters.findIndex(ch => ch.id === selectedExampleChapterId));
  const showCourseExamples = props.is_me && !courseExamplesDismissed &&
    !props.contentIsLoading && !props.loading_page_change &&
    props.single_view_collection !== '' &&
    (props.selected_tab === 'paid_collections' || props.selected_tab === 'collections' || props.selected_tab === 'courses') &&
    (!props.course_chapters || props.course_chapters.length === 0 || (props.course_chapters.length === 1 && props.course_chapters[0]?.[0] === '_-_-other_-_-')) &&
    (!props.influencer_content_list || props.influencer_content_list.length === 0);

  // Populate example progress data when examples are showing
  React.useEffect(() => {
    if (showCourseExamples) {
      setChapterCompletion({
        'ex-ch-1': { completion_rate: 75, completed: 3, total: 2, enrolled: 4 },
        'ex-ch-2': { completion_rate: 25, completed: 1, total: 3, enrolled: 4 },
        'ex-ch-3': { completion_rate: 0, completed: 0, total: 3, enrolled: 4 },
      });
      setContentCompletion({
        'ex-1': { completions: 4, completion_rate: 100 },
        'ex-2': { completions: 3, completion_rate: 75 },
        'ex-3': { completions: 3, completion_rate: 75 },
        'ex-4': { completions: 2, completion_rate: 50 },
        'ex-5': { completions: 1, completion_rate: 25 },
        'ex-6': { completions: 1, completion_rate: 25 },
        'ex-7': { completions: 0, completion_rate: 0 },
        'ex-8': { completions: 0, completion_rate: 0 },
      });
      setTotalEnrolled(4);
    }
  }, [showCourseExamples]);

  // Handler to update chapter name
  const handleUpdateChapterName = async () => {
    if (!editingChapterName.trim() || !editingChapterId || editingChapterIndex === null) {
      return;
    }

    setIsUpdatingChapterName(true);
    try {
      const form_data = new FormData();
      form_data.append('chapter_id', editingChapterId);
      form_data.append('chapter_name', editingChapterName.trim());
      form_data.append('course_name', props.single_view_collection);

      const response = await axios({
        method: 'post',
        url: paths.BACKEND_URL + 'api/influencer/community/update_course_chapter_name',
        data: form_data,
        headers: {
          'Content-type': 'application/json',
        },
        withCredentials: true,
      });

      if (response.data.success && !response.data.error) {
        // Update the chapter list in state
        const chapterList = props.course_chapters || [];
        const updatedChapterList = chapterList.map((chapter, idx) => {
          if (idx === editingChapterIndex) {
            // Update the chapter name while preserving the ID
            if (Array.isArray(chapter)) {
              return [editingChapterName.trim(), chapter[1]]; // [name, id]
            } else if (typeof chapter === 'object') {
              return { ...chapter, chapter_name: editingChapterName.trim(), name: editingChapterName.trim() };
            } else {
              return editingChapterName.trim();
            }
          }
          return chapter;
        });
        
        // Update state with new chapter list
        if (props.setState) {
          props.setState({ course_chapters: updatedChapterList });
        }

        // Also update selected_chapter if it matches the old name
        const oldChapterName = chapterList[editingChapterIndex];
        const getChapterName = (chapter) => {
          if (Array.isArray(chapter)) return chapter[0];
          if (typeof chapter === 'object') return chapter.chapter_name || chapter.name || '';
          return chapter;
        };
        const oldName = getChapterName(oldChapterName);
        if (props.selected_chapter === oldName && props.handleCollectionTabChange) {
          props.handleCollectionTabChange(null, props.single_view_collection, props.selected_tab, null, null, null, editingChapterName.trim());
        }

        setEditChapterModalOpen(false);
        setEditingChapterId(null);
        setEditingChapterName('');
        setEditingChapterIndex(null);
      } else {
        alert(response.data.error || 'Failed to update chapter name');
      }
    } catch (error) {
      console.error('Error updating chapter name:', error);
      alert(t('influencer.snackbar.chapterUpdateError'));
    } finally {
      setIsUpdatingChapterName(false);
    }
  };
  
  // Helper function to process chapters: separate "other" chapter and format display name
  const processChapters = (chapters) => {
    if (!chapters || chapters.length === 0) return { regularChapters: [], otherChapter: null };
    
    const regularChapters = [];
    let otherChapter = null;
    
    chapters.forEach(ch => {
      let chapterName;
      let chapterData;
      
      // Normalize to [name, id] format
      if (Array.isArray(ch)) {
        chapterName = ch[0];
        chapterData = ch;
      } else if (typeof ch === 'string') {
        chapterName = ch;
        chapterData = [ch, null];
      } else {
        chapterName = ch.chapter_name || ch.name || '';
        chapterData = [chapterName, ch.id || ch.chapter_id || null];
      }
      
      // Check if it's the "other" chapter
      if (chapterName === '_-_-other_-_-') {
        otherChapter = chapterData;
      } else {
        regularChapters.push(chapterData);
      }
    });
    
    return { regularChapters, otherChapter };
  };
  
  // Helper function to format chapter name for display (convert "_-_-other_-_-" to "Other")
  const formatChapterName = (chapterName) => {
    return chapterName === '_-_-other_-_-' ? 'Other' : chapterName;
  };
  
  // Initialize reorderedChapters when modal opens (for cases where it wasn't set before modal opened)
  useEffect(() => {
    if (mobileReorderModalOpen && props.course_chapters && props.course_chapters.length > 0) {
      // Always ensure reorderedChapters is initialized when modal opens
      const { regularChapters } = processChapters(props.course_chapters || []);
      if (reorderedChapters.length === 0 || reorderedChapters.length !== regularChapters.length) {
        // Filter out "other" chapter and normalize to [name, id] format
        const normalizedChapters = regularChapters.map(ch => Array.isArray(ch) ? [...ch] : ch);
        setReorderedChapters(normalizedChapters);
      }
    }
  }, [mobileReorderModalOpen, props.course_chapters]);
  
  // TODO add loader and set to null so we load correct dashboard page without flashing
  const handleOpenWhatsThis = () => props.setState({ whatsThisModal: true });
  const handleCloseWhatsThis = () => props.setState({ whatsThisModal: false });
  const handleOpenTiers = () => props.setState({ tiersModal: true });
  const handleOpenStripe = () => props.setStripeModal(true);
  const handleCloseStripe = () => props.setStripeModal(false);
  const handleFirstTimeView = () => props.setState({ confettiModal: false });

  // offering
  const [newTierModal, setNewTierModal] = useState(false);
  const [offeringError, setOfferingError] = useState(false);
  const [editOffering, setEditOffering] = useState(false);
  const [paidDMsModal, setPaidDMsModal] = useState(false);
  const [paidDMsActiveSettings, setPaidDMsActiveSettings] = useState(false);
  const [paidDMsMinimumPrice, setPaidDMsMinimumPrice] = useState(200);
  const [paidDMsMinimumPriceStr, setPaidDMsMinimumPriceStr] = useState("2.00");
  const [paidDMsMaximumMessageLength, setPaidDMsMaximumMessageLength] = useState(10000);
  const [priceOfDMsError, setPriceOfDMsError] = useState("");

  const [updatedTierNameInput, setUpdatedTierNameInput] = useState(false);
  const [updatedMonthlyInput, setUpdatedMonthlyInput] = useState(false);
  const [updatedAnnualInput, setUpdatedAnnualInput] = useState(false);
  const [showInitialSlide, setShowInitialSlide] = useState(0);
  // all perks info
  const [freeActive, setFreeActive] = useState(false);
  const [bronzeActive, setBronzeActive] = useState(false);
  const [silverActive, setSilverActive] = useState(false);
  const [goldActive, setGoldActive] = useState(false);
  const [asyncActive, setAsyncActive] = useState(false);
  const [bronzeTierName, setBronzeTierName] = useState("");
  const [bronzePerksTextNum, setBronzePerksTextNum] = useState(0);
  const [bronzePerksText, setBronzePerksText] = useState([]);
  const [bronzeMonthlyPrice, setBronzeMonthlyPrice] = useState("");
  const [bronzeYearlyPrice, setBronzeYearlyPrice] = useState("");
  const [bronzeAnnualActive, setBronzeAnnualActive] = useState(false);
  const [bronzeMonthlyActive, setBronzeMonthlyActive] = useState(false);
  const [bronzeNMessages, setBronzeNMessages] = useState(0);
  const [silverTierName, setSilverTierName] = useState("");
  const [silverPerksText, setSilverPerksText] = useState([]);
  const [silverPerksTextNum, setSilverPerksTextNum] = useState(0);
  const [silverMonthlyPrice, setSilverMonthlyPrice] = useState("");
  const [silverYearlyPrice, setSilverYearlyPrice] = useState("");
  const [silverAnnualActive, setSilverAnnualActive] = useState(false);
  const [silverMonthlyActive, setSilverMonthlyActive] = useState(false);
  const [silverNMessages, setSilverNMessages] = useState(0);
  const [goldTierName, setGoldTierName] = useState("");
  const [goldPerksText, setGoldPerksText] = useState([]);
  const [goldPerksTextNum, setGoldPerksTextNum] = useState(0);
  const [goldMonthlyPrice, setGoldMonthlyPrice] = useState("");
  const [goldYearlyPrice, setGoldYearlyPrice] = useState("");
  const [goldAnnualActive, setGoldAnnualActive] = useState(false);
  const [goldMonthlyActive, setGoldMonthlyActive] = useState(false);
  const [goldNMessages, setGoldNMessages] = useState(0);
  const [asyncTierName, setAsyncTierName] = useState("");
  const [asyncPerksText, setAsyncPerksText] = useState([]);
  const [asyncPerksTextNum, setAsyncPerksTextNum] = useState(0);
  const [asyncMonthlyPrice, setAsyncMonthlyPrice] = useState("");
  const [asyncYearlyPrice, setAsyncYearlyPrice] = useState("");
  const [asyncAnnualActive, setAsyncAnnualActive] = useState(false);
  const [asyncMonthlyActive, setAsyncMonthlyActive] = useState(false);
  const [asyncPrice2Rebill, setAsyncPrice2Rebill] = useState(false);
  const [asyncTierHidden, setAsyncTierHidden] = useState(false);
  const [asyncTierApply, setAsyncTierApply] = useState(false);
  const [asyncPrice2Time, setAsyncPrice2Time] = useState("1 year");
  const [currency, setCurrency] = useState(appCurrency || "GBP");
  const [currencySymbol, setCurrencySymbol] = useState("£");
  const [currencySymbolPost, setCurrencySymbolPost] = useState("");
  const [asyncTier, setAsyncTier] = useState(false);
  // tier modal info
  const [tierNum, setTierNum] = useState("");
  const [showSlider, setShowSlider] = useState();
  const [tierName, setTierName] = useState("");
  const [perksText, setPerksText] = useState([]);
  const [monthlyPrice, setMonthlyPrice] = useState("");
  const [yearlyPrice, setYearlyPrice] = useState("");
  const [perksTextNum, setPerksTextNum] = useState(0);
  const [annualActive, setAnnualActive] = useState(true);
  const [monthlyActive, setMonthlyActive] = useState(true);
  const [tierHidden, setTierHidden] = useState(true);
  const [tierApply, setTierApply] = useState(true);
  const [monthlyPriceStr, setMonthlyPriceStr] = useState("");
  const [price2Rebill, setPrice2Rebill] = useState(false);
  const [price2Time, setPrice2Time] = useState("1 year");
  const [yearlyPriceStr, setYearlyPriceStr] = useState("");
  const [monthlyPriceError, setMonthlyPriceError] = useState("");
  const [yearlyPriceError, setYearlyPriceError] = useState("");
  const [newTierBenefitsModal, setNewTierBenefitsModal] = useState(false);
  const [deleteTierModal, setDeleteTierModal] = useState(false);
  const [blankLoading, setBlankLoading] = useState(false);
  const [nMessages, setNMessages] = useState(0);
  // Paid DMs
  const [paidDMsActive, setPaidDMsActive] = useState(false);
  const [remainingPaidDMsCount, setRemainingPaidDMsCount] = useState(0);
  const [paidDMsOrderCount, setPaidDMsOrderCount] = useState(0);
  const [waitingListShareLoc, setWaitingListShareLoc] = useState(false);
  const [copySnackbar, setCopySnackbar] = useState(false);
  const [contentData, setContentData] = useState([]);

  // share modal
  const [shareOpen, setShareOpen] = useState(false);
  const [shareId, setShareId] = useState("");
  const [shareName, setShareName] = useState("");
  const [shareInfluencer, setShareInfluencer] = useState("");
  const [buyCollectionId, setBuyCollectionId] = useState(null);
  const [buyCollectionPrice, setBuyCollectionPrice] = useState(0);
  const [buyCollectionCompareAtPrice, setBuyCollectionCompareAtPrice] = useState(0);
  const [buyCollectionName, setBuyCollectionName] = useState("");

  // comment snack bar
  const [comment_snackbar, set_comment_snackbar] = useState(false);
  const [comment_snackbar_message, set_comment_snackbar_message] = useState("");
  const [comment_snackbar_type, set_comment_snackbar_type] = useState("");
  const [comment_snackbar_background, set_comment_snackbar_background] = useState("");
  const [comment_snackbar_autohide, set_comment_snackbar_autohide] = useState("");
  const [nPages, setNPages] = useState(1);
  const [isContentLoading, setIsContentLoading] = useState(true);

  const [collectionData, setCollectionData] = useState("");
  const [collectionIndex, setCollectionIndex] = useState(0);

  const getBrandColor = () => {
    const customBrandColor =
      props.designProperties?.brandColorUpdated || props.designProperties?.brandColor;
    if (customBrandColor && customBrandColor !== "" && customBrandColor !== null) {
      return customBrandColor;
    }
    return "var(--brand-color)";
  };

  const lockedCollectionCoursePreviewData = useMemo(() => {
    if (!Array.isArray(collectionData) || collectionIndex < 0) return null;
    const col = collectionData[collectionIndex];
    if (!col) return null;
    return {
      ...col,
      course_name: col.course_name || col.name || "",
      name: col.course_name || col.name || "",
      description: col.description || col.product_sales_description || col.subtitle || "",
      subtitle: col.subtitle || col.description || col.product_sales_description || "",
      collection_price: col.collection_price ?? col.price ?? 0,
      price: col.collection_price ?? col.price ?? 0,
      compare_at_price: col.compare_at_price || 0,
      compare_at_price_2: col.compare_at_price_2 || 0,
      files: col.files || col.sales_files || [],
      sales_files: col.sales_files || col.files || [],
      files_type: col.files_type || col.sales_file_types || [],
      sales_file_types: col.sales_file_types || col.files_type || [],
      collection_thumbnail: col.collection_thumbnail || col.thumbnail || col.product_thumbnail,
      thumbnail: col.thumbnail || col.collection_thumbnail || col.product_thumbnail,
      product_thumbnail: col.product_thumbnail || col.collection_thumbnail,
      content_count: col.content_count ?? 0,
      content_list: Array.isArray(col.content_list) ? col.content_list : [],
      access: false,
      access_duration: col.access_duration,
      access_duration_type: col.access_duration_type,
      cta_button_text: col.cta_button_text || col.button_text || "",
      password_required: col.password_required || false,
    };
  }, [collectionData, collectionIndex]);


  useEffect(() => {
    if (props.collection_data) {

      if (props.selected_tab === 'paid_collections' && (props.mobilePreview || (isVisitorPreview && props.previewRolloutOwner))) {
        setCollectionData([...props.collection_data.map(collection => ({ ...collection, locked: true }))]);
      } else {
        setCollectionData([...props.collection_data]);
      }
    }
  }, [props.collection_data, props.single_view_collection, props.selected_tab, props.mobilePreview, isVisitorPreview, props.previewRolloutOwner]);

  useEffect(() => {
    if (props.influencer_content_list && props.influencer_content_list.length > 0) {
      if (isVisitorPreview && props.previewRolloutOwner) {
        // Owner responses retain real entitlements. Downgrade only the card
        // presentation for Not a customer, including after tab/filter fetches.
        setContentData(props.influencer_content_list.map(content => ({
          ...content,
          current_tier: -1,
          is_mine: false,
          access: false,
        })));
      } else if (props.mobilePreview) {
        const modifiedContentList = props.influencer_content_list.map(content => ({
          ...content,
          current_tier: -1
        }));
        setContentData(modifiedContentList);
      } else {
        setContentData(props.influencer_content_list);
      }
      setIsContentLoading(false);
    } else {
      setIsContentLoading(true);
      setContentData([]);
    }
  }, [props.influencer_content_list, isVisitorPreview, props.previewRolloutOwner, props.mobilePreview]);
  
  useEffect(() => {
    props.setState({ collectionContentReorderData: contentData.map((item) => item.id) });
  }, [contentData]);

  useEffect(() => {
    const collectionIndexPre = Array.isArray(collectionData)
      ? collectionData.findIndex((collection) => 
          collection.course_name === props.single_view_collection ||
          collection.name === props.single_view_collection ||
          String(collection.id) === String(props.single_view_collection)
        )
      : -1;
    setCollectionIndex(collectionIndexPre);
    const selectedCollection = collectionData[collectionIndexPre];
    
    
    setBuyCollectionId(selectedCollection?.id);
    // Backend returns 'price' not 'collection_price' - check both
    setBuyCollectionPrice(selectedCollection?.price || selectedCollection?.collection_price || 0);
    setBuyCollectionCompareAtPrice(selectedCollection?.compare_at_price || 0);
    setBuyCollectionName(selectedCollection?.course_name || selectedCollection?.name);
  }, [collectionData, props.single_view_collection]);

  // Fetch progress completion data when course is selected and progress tracking is enabled
  useEffect(() => {
    if (showCourseExamples) return;
    const selectedCol = collectionData?.[collectionIndex];
    if (selectedCol?.id && props.single_view_collection) {
      const form_data = new FormData();
      form_data.append('course_id', selectedCol.id);
      axios.post(getBackendUrl() + 'api/influencer/load_course_chapters', form_data, { withCredentials: true })
        .then(res => {
          if (res.data.chapter_completion) setChapterCompletion(res.data.chapter_completion);
          if (res.data.course_completion) {
            setCourseCompletion(res.data.course_completion);
            props.setState({ _courseCompletionData: res.data.course_completion });
          }
          if (res.data.content_completion) setContentCompletion(res.data.content_completion);
          if (res.data.total_enrolled) setTotalEnrolled(res.data.total_enrolled);
        })
        .catch(() => {});
    }
  }, [collectionData, collectionIndex, showCourseExamples]);

  // Load course stats for creator POV (completion rate metric)
  useEffect(() => {
    if (showCourseExamples) return;
    const selectedCol = collectionData?.[collectionIndex];
    if (props.is_me && selectedCol?.id && props.single_view_collection && selectedCol?.progress_tracking_enabled) {
      const form_data = new FormData();
      form_data.append('course_id', selectedCol.id);
      axios.post(getBackendUrl() + 'api/influencer/community/load_progress_stats', form_data, { withCredentials: true })
        .then(res => {
          if (res.data.success && res.data.course_stats) {
            setCourseStats(res.data.course_stats);
          }
        })
        .catch(() => {});
    }
  }, [collectionData, collectionIndex, props.single_view_collection]);

  const normalizeProductIdOriginal = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const isViewingSpecificCourseOriginal = Boolean(
    props.single_view_collection !== "" &&
    props.single_view_collection !== null &&
    props.single_view_collection !== undefined
  );

  // Whether the viewer has purchased/has access to the membership (for gating Share & Earn on posts tab).
  const hasMembershipAccessOriginal = !isVisitorPreview && Boolean(
    isCustomerPreview || props.is_me ||
    props.influencer_info?.access === true ||
    (typeof props.current_tier === "number" && props.current_tier >= 0) ||
    (typeof props.influencer_info?.current_tier === "number" && props.influencer_info.current_tier >= 0)
  );

  const classicPostsShareConfigOriginal = (() => {
    if (props.is_me) return null;

    const influencerUsername =
      props.influencer_info?.influencer ||
      props.influencer ||
      props.influencer_name ||
      (typeof window !== "undefined"
        ? window.location.pathname.split("/").filter(Boolean)[0]
        : "");
    if (!influencerUsername) return null;

    if (
      props.selected_tab === "sub_posts" ||
      props.selected_tab === "posts" ||
      props.selected_tab === "membership" ||
      props.selected_tab === "all"
    ) {
      const fromSingleView =
        props.single_view_membership &&
        typeof props.single_view_membership === "object";
      // `??`, not a bare read: the object being present does not guarantee it
      // carries this field. The banner's tier switcher sets
      // single_view_membership from a tier row, which is narrower than the
      // storefront payload, and `undefined !== false` — so a bare read let the
      // affiliate CTA render on a tier whose creator had switched affiliates
      // OFF. Falling back to the creator-level default is what the sibling in
      // InfluencerContent.js already does for the same flag.
      const membershipAffiliateEnabled = fromSingleView
        ? (props.single_view_membership.affiliate_enabled
           ?? props.influencer_info?.membership_affiliate_enabled)
        : props.influencer_info?.membership_affiliate_enabled;
      if (membershipAffiliateEnabled === false) return null;
      if (!fromSingleView && membershipAffiliateEnabled !== true) return null;
      // Determine the user's actual paid membership tier (1-3).
      // props.current_tier is subscribe_popup_current_tier which starts as "" (empty string),
      // and influencer_info.current_tier may be inflated to 3 for free-trial users.
      // We prefer influencer_info.current_tier when it's a paid tier (1-3), then
      // single_view_membership.tier, then any numeric popup tier, then fallback 1.
      const _infoTier = typeof props.influencer_info?.current_tier === 'number'
        ? props.influencer_info.current_tier
        : null;
      const _userPaidTier =
        (_infoTier !== null && _infoTier >= 1 && _infoTier <= 3) ? _infoTier : null;
      const _svTier = props.single_view_membership?.tier != null
        ? props.single_view_membership.tier
        : null;
      const _popupTier = typeof props.current_tier === 'number' && props.current_tier >= 1 && props.current_tier <= 3
        ? props.current_tier
        : typeof props.subpopup_tier_overwrite === 'number' && props.subpopup_tier_overwrite >= 1 && props.subpopup_tier_overwrite <= 3
          ? props.subpopup_tier_overwrite
          : null;
      return {
        productType: "membership",
        productId: _userPaidTier ?? _svTier ?? _popupTier ?? 1,
        productName: props.posts_name || "Membership",
        influencer: influencerUsername,
      };
    }

    if (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products") {
      const fallbackDigitalProduct = Array.isArray(contentData)
        ? contentData.find((item) => normalizeProductIdOriginal(item?.id) !== null)
        : null;
      const selectedDigitalProductId = normalizeProductIdOriginal(
        props.single_view_digital_product ?? fallbackDigitalProduct?.id
      );
      if (selectedDigitalProductId === null) return null;
      const selectedDigitalProductFromContent = Array.isArray(contentData)
        ? contentData.find((item) => normalizeProductIdOriginal(item?.id) === selectedDigitalProductId)
        : null;
      const digitalProductCandidates = [
        selectedDigitalProductFromContent,
        fallbackDigitalProduct,
      ].filter(Boolean);
      const selectedDigitalProduct = digitalProductCandidates[0] || null;
      if (!selectedDigitalProduct) return null;
      const digitalProductWithAffiliateFlag = digitalProductCandidates.find((item) =>
        Object.prototype.hasOwnProperty.call(item, "affiliate_enabled")
      );
      if (digitalProductWithAffiliateFlag?.affiliate_enabled === false) return null;

      return {
        productType: "digital_product",
        productId: selectedDigitalProductId,
        productName:
          selectedDigitalProduct?.name ||
          selectedDigitalProduct?.title ||
          props.digital_products_name ||
          "Digital Product",
        influencer: influencerUsername,
      };
    }

    if (
      (props.selected_tab === "paid_collections" ||
        props.selected_tab === "collections" ||
        props.selected_tab === "courses") &&
      isViewingSpecificCourseOriginal
    ) {
      const activeCollection = Array.isArray(collectionData) && collectionIndex >= 0
        ? collectionData[collectionIndex]
        : null;
      const fallbackCollection = Array.isArray(collectionData)
        ? collectionData.find((item) => normalizeProductIdOriginal(item?.id) !== null)
        : null;
      const selectedCollection = activeCollection || fallbackCollection;
      const selectedCollectionId = normalizeProductIdOriginal(
        props.collection_id ?? selectedCollection?.id
      );
      if (selectedCollectionId === null) return null;
      if (!selectedCollection) return null;
      if (selectedCollection.affiliate_enabled !== true) return null;

      return {
        productType: "course",
        productId: selectedCollectionId,
        productName:
          selectedCollection?.course_name ||
          selectedCollection?.name ||
          props.courses_name ||
          "Course",
        influencer: influencerUsername,
      };
    }

    return null;
  })();

  const showClassicPostsShareLayoutOriginal = Boolean(
    !props.is_me &&
    props.windowWidth >= 1280 &&
    (
      props.selected_tab === "sub_posts" ||
      props.selected_tab === "posts" ||
      props.selected_tab === "membership" ||
      props.selected_tab === "all" ||
      (
        (props.selected_tab === "paid_collections" ||
          props.selected_tab === "collections" ||
          props.selected_tab === "courses") &&
        isViewingSpecificCourseOriginal
      )
    ) &&
    classicPostsShareConfigOriginal?.influencer &&
    // Only show Share & Earn on posts/membership tabs when user has purchased membership
    (classicPostsShareConfigOriginal?.productType !== "membership" || hasMembershipAccessOriginal)
  );
  const classicTabsInlineDigitalShareConfigOriginal = (() => {
    if (props.is_me || props.isLoggedOutView) return null;

    if (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products") {
      const influencerUsername =
        props.influencer_info?.influencer ||
        props.influencer ||
        props.influencer_name ||
        (typeof window !== "undefined"
          ? window.location.pathname.split("/").filter(Boolean)[0]
          : "");
      if (!influencerUsername) return null;
      return {
        productType: "digital_product",
        influencer: influencerUsername,
        productName: props.digital_products_name || "Digital Product",
      };
    }

    const isClassicLayoutType =
      props.pageLayoutType !== "storefront" &&
      props.pageLayoutTypeUpdated !== "storefront";
    const isMembershipTab =
      props.selected_tab === "sub_posts" ||
      props.selected_tab === "sub_collections" ||
      props.selected_tab === "membership" ||
      props.selected_tab === "posts" ||
      props.selected_tab === "all";
    if (
      isClassicLayoutType &&
      isMembershipTab &&
      classicPostsShareConfigOriginal?.productType === "membership" &&
      classicPostsShareConfigOriginal?.influencer
    ) {
      return {
        productType: classicPostsShareConfigOriginal.productType,
        productId: classicPostsShareConfigOriginal.productId,
        influencer: classicPostsShareConfigOriginal.influencer,
        productName: classicPostsShareConfigOriginal.productName || props.posts_name || "Membership",
      };
    }

    const isCourseTab =
      props.selected_tab === "paid_collections" ||
      props.selected_tab === "collections" ||
      props.selected_tab === "courses";
    if (
      isClassicLayoutType &&
      isCourseTab &&
      isViewingSpecificCourseOriginal &&
      classicPostsShareConfigOriginal?.productType === "course" &&
      classicPostsShareConfigOriginal?.influencer
    ) {
      return {
        productType: classicPostsShareConfigOriginal.productType,
        productId: classicPostsShareConfigOriginal.productId,
        influencer: classicPostsShareConfigOriginal.influencer,
        productName: classicPostsShareConfigOriginal.productName || props.courses_name || "Course",
      };
    }

    return null;
  })();

  useEffect(() => {
    setNPages(Math.ceil(props.content_list_length / 20));
  }, [props.content_list_length]);

  const handleCommentSnackBarClose = () => {
    set_comment_snackbar(false);
  };

  useEffect(() => {
    if (props.selected_tab === "membership") {
      loadTierInfo();
    }
  }, [props.selected_tab]);

  const [contentFiltered, setContentFiltered] = useState(false);
   useEffect(() => {
      if (((props.selected_tab === 'all') || (props.selected_tab === 'sub_posts') || (props.selected_tab === 'paid_posts')) && (props.category_filter !== 'all' || props.sort_filter !== 'latest' || props.content_filter !== 'all' || props.tier_filter !== -1)){
         setContentFiltered(true);
      } else if (props.category_filter !== 'all' || props.sort_filter !== 'latest' || props.content_filter !== 'all') {
         setContentFiltered(true);
      } else {
         setContentFiltered(false);
      }
   }, [props.category_filter, props.sort_filter, props.content_filter, props.tier_filter, props.selected_tab])

  const updateFreeActive = (value) => {
    const form_data = new FormData();
    form_data.append("value", value);
    axios({
      method: "post",
      url: paths.BACKEND_URL + "api/influencer/update_free_active",
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (!res.data.error) {
        setFreeActive(value);
        let copy_influencer_info = { ...props.influencer_info };
        copy_influencer_info.free_active = value;
        props.setState({ influencer_info: copy_influencer_info });
      }
    });
  };

  const setupPaidDMs = () => {
    // Load data from backend
    setCurrency(currency);
    const form_data = new FormData();
    form_data.append("currency", currency);
    axios({
      method: "post",
      url: paths.BACKEND_URL + "api/influencer/load_dm_settings",
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (!res.data.error) {
        setPaidDMsActiveSettings(res.data.active);
        setPaidDMsMinimumPrice(res.data.minimum_price);
        setPaidDMsMinimumPriceStr(CreatePriceStr(res.data.minimum_price, currency, false));
        setPaidDMsMaximumMessageLength(res.data.maximum_message_length);
        setPaidDMsModal(true);
        if (currency == "GBP") {
          setCurrencySymbol("£");
          setCurrencySymbolPost("");
        } else if (currency == "EUR") {
          setCurrencySymbol("€");
          setCurrencySymbolPost("");
        } else if (currency == "USD") {
          setCurrencySymbol("$");
          setCurrencySymbolPost("");
        } else if (currency == "SEK") {
          setCurrencySymbol("");
          setCurrencySymbolPost(" kr");
        } else if (currency == "AUD") {
          setCurrencySymbol("AU$");
          setCurrencySymbolPost("");
        } else if (currency == "CAD") {
          setCurrencySymbol("CA$");
          setCurrencySymbolPost("");
        } else if (currency == "NZD") {
          setCurrencySymbol("NZ$");
          setCurrencySymbolPost("");
        }
      }
    });
  };

  const openAddNewTier = (async_tier = false) => {
    setEditOffering(false);
    if (async_tier === true) {
      setTierNum(4);
      setShowSlider(3);
      setTierName(asyncTierName);
      setPerksText(asyncPerksText);
      setPerksTextNum(asyncPerksTextNum);
      setMonthlyPrice(asyncMonthlyPrice);
      setYearlyPrice(asyncYearlyPrice);
      setAnnualActive(asyncAnnualActive);
      setMonthlyActive(asyncMonthlyActive);
      setTierHidden(asyncTierHidden);
      setTierApply(asyncTierApply);
      setPrice2Rebill(asyncPrice2Rebill);
      setPrice2Time(asyncPrice2Time);
      setMonthlyPriceStr(CreatePriceStr(asyncMonthlyPrice, currency, false));
      setYearlyPriceStr(CreatePriceStr(asyncYearlyPrice, currency, false));
      setMonthlyPriceError("");
      setYearlyPriceError("");
    } else {
      if (bronzeActive == false) {
        setTierNum(1);
        setShowSlider(0);
        setTierName(bronzeTierName);
        setPerksText(bronzePerksText);
        setPerksTextNum(bronzePerksTextNum);
        setMonthlyPrice(bronzeMonthlyPrice);
        setYearlyPrice(bronzeYearlyPrice);
        setAnnualActive(bronzeAnnualActive);
        setMonthlyActive(bronzeMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(bronzeMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(bronzeYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(bronzeNMessages);
      } else if (silverActive == false) {
        setTierNum(2);
        setShowSlider(1);
        setTierName(silverTierName);
        setPerksText(silverPerksText);
        setPerksTextNum(silverPerksTextNum);
        setMonthlyPrice(silverMonthlyPrice);
        setYearlyPrice(silverYearlyPrice);
        setAnnualActive(silverAnnualActive);
        setMonthlyActive(silverMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(silverMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(silverYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(silverNMessages);
      } else if (goldActive == false) {
        setTierNum(3);
        setShowSlider(2);
        setTierName(goldTierName);
        setPerksText(goldPerksText);
        setPerksTextNum(goldPerksTextNum);
        setMonthlyPrice(goldMonthlyPrice);
        setYearlyPrice(goldYearlyPrice);
        setAnnualActive(goldAnnualActive);
        setMonthlyActive(goldMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(goldMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(goldYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(goldNMessages);
      }
    }
    setNewTierModal(true);
  };

  const openEditTier = (tier_num) => {
    setEditOffering(true);
    if (tier_num === 4) {
      setTierNum(4);
      setShowSlider(3);
      setTierName(asyncTierName);
      setPerksText(asyncPerksText);
      setPerksTextNum(asyncPerksTextNum);
      setMonthlyPrice(asyncMonthlyPrice);
      setYearlyPrice(asyncYearlyPrice);
      setAnnualActive(asyncAnnualActive);
      setMonthlyActive(asyncMonthlyActive);
      setTierHidden(asyncTierHidden);
      setTierApply(asyncTierApply);
      setPrice2Rebill(asyncPrice2Rebill);
      setPrice2Time(asyncPrice2Time);
      setMonthlyPriceStr(CreatePriceStr(asyncMonthlyPrice, currency, false));
      setYearlyPriceStr(CreatePriceStr(asyncYearlyPrice, currency, false));
      setMonthlyPriceError("");
      setYearlyPriceError("");
    } else {
      if (tier_num === 1) {
        setTierNum(1);
        setShowSlider(0);
        setTierName(bronzeTierName);
        setPerksText(bronzePerksText);
        setPerksTextNum(bronzePerksTextNum);
        setMonthlyPrice(bronzeMonthlyPrice);
        setYearlyPrice(bronzeYearlyPrice);
        setAnnualActive(bronzeAnnualActive);
        setMonthlyActive(bronzeMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(bronzeMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(bronzeYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(bronzeNMessages);
      } else if (tier_num === 2) {
        setTierNum(2);
        setShowSlider(1);
        setTierName(silverTierName);
        setPerksText(silverPerksText);
        setPerksTextNum(silverPerksTextNum);
        setMonthlyPrice(silverMonthlyPrice);
        setYearlyPrice(silverYearlyPrice);
        setAnnualActive(silverAnnualActive);
        setMonthlyActive(silverMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(silverMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(silverYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(silverNMessages);
      } else if (tier_num === 3) {
        setTierNum(3);
        setShowSlider(2);
        setTierName(goldTierName);
        setPerksText(goldPerksText);
        setPerksTextNum(goldPerksTextNum);
        setMonthlyPrice(goldMonthlyPrice);
        setYearlyPrice(goldYearlyPrice);
        setAnnualActive(goldAnnualActive);
        setMonthlyActive(goldMonthlyActive);
        setMonthlyPriceStr(CreatePriceStr(goldMonthlyPrice, currency, false));
        setYearlyPriceStr(CreatePriceStr(goldYearlyPrice, currency, false));
        setMonthlyPriceError("");
        setYearlyPriceError("");
        setNMessages(goldNMessages);
      }
    }
    setNewTierModal(true);
  };

  const updatePerks = (new_str, index) => {
    let new_tier_perks = [...perksText];
    new_tier_perks[index] = new_str;
    setPerksText(new_tier_perks);
    setPerksTextNum(new_tier_perks.filter((text) => text !== "").length);
  };

  function pluralize(count, singular, plural) {
    return count === 1 ? `${count} ${singular}` : `${count} ${plural}`;
  }

  const updateTier = (event, benefitList, paidMessagesTotal) => {
    if (tierNum === 1 && props.waiting_list_influencer) {
      const url = new URL(window.location.href);
      if (!url.searchParams.has("new_membership")) {
        url.searchParams.set("new_membership", "true");
        window.history.pushState({}, "", url); // This updates the URL without reloading the page
      }
    }

    let newBenefits = benefitList.filter((benefit) => benefit.name !== undefined);
    event.preventDefault();
    setBlankLoading(true);
    const form_data = new FormData();
    form_data.append("tier_num", tierNum);
    form_data.append("tier_name", tierName);
    form_data.append("month_price", monthlyPrice);
    form_data.append("annual_price", yearlyPrice);
    form_data.append("month_active", monthlyActive);
    form_data.append("annual_active", annualActive);

    if (tierNum === 4) {
      form_data.append("async_price_2_rebill", price2Rebill);
      form_data.append("async_price_2_time", price2Time);
      form_data.append("tier_hidden", tierHidden);
      form_data.append("tier_apply", tierApply);
    }

    form_data.append("currency", currency);

    // fixes '&' issue
    const decodeHTML = (html) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    // Dynamically append new benefits
    for (let i = 0; i < 4; i++) {
      if (i < newBenefits.length) {
        if (newBenefits[i].name === "Custom benefit - write your own") {
          form_data.append(`perksText${i + 1}`, decodeHTML(newBenefits[i].customBenefitName));
        } else if (newBenefits[i].name === "Paid messages") {
          form_data.append(
            `perksText${i + 1}`,
            decodeHTML(paidMessagesTotal + " " + newBenefits[i].paidMessagesTitleType)
          );
        } else {
          form_data.append(`perksText${i + 1}`, decodeHTML(newBenefits[i].name));
        }
      } else {
        form_data.append(`perksText${i + 1}`, "");
      }
    }

    form_data.append("n_messages", paidMessagesTotal);
    let url = "api/update_tier_info_v2";
    axios({
      method: "post",
      url: paths.BACKEND_URL + url,
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (!res.data.access_denied) {
        if (!res.data.error) {
          loadTierInfo();
          setNewTierModal(false);
          setNewTierBenefitsModal(false);
          props.handleCloseTiers();
          setOfferingError(false);
        }
      }
    });
    setBlankLoading(false);
  };

  const updateTrialLength = (event, trialLength) => {
    event.preventDefault();
    const form_data = new FormData();
    form_data.append("trial_length", trialLength);

    axios({
      method: "post",
      url: paths.BACKEND_URL + "api/settings_update_trial_length",
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (!res.data.access_denied && !res.data.error) {
        //  props.setSnackbarUpload(true);
        //  props.setErrorMsgUpload('Trial Length Updated');
        //  props.setSnackColor('var(--brand-color)');
      }
    });
  };

  const updatePerksRemove = (index) => {
    let new_tier_perks = [...perksText];
    new_tier_perks.splice(index, 1);
    new_tier_perks.push("");
    setPerksText(new_tier_perks);
    setPerksTextNum(new_tier_perks.filter((text) => text !== "").length);
  };
  const deleteTier = (event) => {
    setBlankLoading(true);
    event.preventDefault();
    const form_data = new FormData();
    form_data.append("tier_num", tierNum);
    axios({
      method: "post",
      url: paths.BACKEND_URL + "api/make_influencer_tier_inactive",
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (!res.data.access_denied) {
        if (!res.data.error) {
          loadTierInfo();
          setNewTierModal(false);
          setNewTierBenefitsModal(false);
          setDeleteTierModal(false);
          props.handleCloseTiers();
          setOfferingError(false);
        }
      }
    });
    setBlankLoading(false);
  };

  function loadTierInfo() {
    setBlankLoading(true);
    // get the currency
    setCurrency(currency);
    let form_data = new FormData();
    form_data.append("currency", currency);
    axios({
      method: "post",
      url: paths.BACKEND_URL + "api/get_influencer_tier_info",
      data: form_data,
      headers: {
        "Content-type": "application/json",
      },
      withCredentials: true,
    }).then((res) => {
      if (res.data.free_tier_active) {
        setFreeActive(true);
      } else {
        setFreeActive(false);
      }
      if (res.data.bronze_tier_active) {
        setBronzeActive(true);
      } else {
        setBronzeActive(false);
      }
      if (res.data.silver_tier_active) {
        setSilverActive(true);
      } else {
        setSilverActive(false);
      }
      if (res.data.gold_tier_active) {
        setGoldActive(true);
      } else {
        setGoldActive(false);
      }
      if (res.data.async_tier_active) {
        setAsyncActive(true);
      } else {
        setAsyncActive(false);
      }
      props.setTrialLength(res.data.trial_length);
      setBronzeTierName(res.data.bronze_tier_name);
      setBronzePerksText(res.data.bronze_perks_text.map((item) => (item === "" ? undefined : item)));
      setBronzePerksTextNum(res.data.bronze_perks_text.filter((text) => text !== "").length);
      setBronzeMonthlyPrice(res.data.bronze_price);
      setBronzeYearlyPrice(res.data.bronze_annual_price);
      setBronzeAnnualActive(res.data.bronze_annual_active);
      setBronzeMonthlyActive(res.data.bronze_monthly_active);
      setBronzeNMessages(res.data.bronze_n_messages);
      setSilverTierName(res.data.silver_tier_name);
      setSilverPerksTextNum(res.data.silver_perks_text.filter((text) => text !== "").length);
      setSilverPerksText(res.data.silver_perks_text.map((item) => (item === "" ? undefined : item)));
      setSilverMonthlyPrice(res.data.silver_price);
      setSilverYearlyPrice(res.data.silver_annual_price);
      setSilverAnnualActive(res.data.silver_annual_active);
      setSilverMonthlyActive(res.data.silver_monthly_active);
      setSilverNMessages(res.data.silver_n_messages);
      setGoldTierName(res.data.gold_tier_name);
      setGoldPerksText(res.data.gold_perks_text.map((item) => (item === "" ? undefined : item)));
      setGoldPerksTextNum(res.data.gold_perks_text.filter((text) => text !== "").length);
      setGoldMonthlyPrice(res.data.gold_price);
      setGoldYearlyPrice(res.data.gold_annual_price);
      setGoldAnnualActive(res.data.gold_annual_active);
      setGoldMonthlyActive(res.data.gold_monthly_active);
      setGoldNMessages(res.data.gold_n_messages);
      setAsyncTierName(res.data.async_tier_name);
      setAsyncPerksText(res.data.async_perks_text.map((item) => (item === "" ? undefined : item)));
      setAsyncPerksTextNum(res.data.async_perks_text.filter((text) => text !== "").length);
      setAsyncMonthlyPrice(res.data.async_price);
      setAsyncYearlyPrice(res.data.async_annual_price);
      setAsyncAnnualActive(res.data.async_annual_active);
      setAsyncMonthlyActive(res.data.async_monthly_active);
      setAsyncTierHidden(res.data.async_tier_hidden);
      setAsyncTierApply(res.data.async_tier_apply);
      setAsyncPrice2Rebill(res.data.async_price_2_rebill);
      if (currency == "GBP") {
        setCurrencySymbol("£");
        setCurrencySymbolPost("");
      } else if (currency == "EUR") {
        setCurrencySymbol("€");
        setCurrencySymbolPost("");
      } else if (currency == "USD") {
        setCurrencySymbol("$");
        setCurrencySymbolPost("");
      } else if (currency == "SEK") {
        setCurrencySymbol("");
        setCurrencySymbolPost(" kr");
      } else if (currency == "AUD") {
        setCurrencySymbol("AU$");
        setCurrencySymbolPost("");
      } else if (currency == "CAD") {
        setCurrencySymbol("CA$");
        setCurrencySymbolPost("");
      } else if (currency == "NZD") {
        setCurrencySymbol("NZ$");
        setCurrencySymbolPost("");
      }
      props.setState({ tiersModal: true });
      if (res.data.async_price_2_time_length === 1 && res.data.async_price_2_time_type === "year") {
        setAsyncPrice2Time("1 year");
      } else if (res.data.async_price_2_time_length === 1 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("1 week");
      } else if (res.data.async_price_2_time_length === 2 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("2 weeks");
      } else if (res.data.async_price_2_time_length === 3 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("3 weeks");
      } else if (res.data.async_price_2_time_length === 4 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("4 weeks");
      } else if (res.data.async_price_2_time_length === 6 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("6 weeks");
      } else if (res.data.async_price_2_time_length === 8 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("8 weeks");
      } else if (res.data.async_price_2_time_length === 10 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("10 weeks");
      } else if (res.data.async_price_2_time_length === 12 && res.data.async_price_2_time_type === "week") {
        setAsyncPrice2Time("12 weeks");
      } else if (res.data.async_price_2_time_length === 1 && res.data.async_price_2_time_type === "month") {
        setAsyncPrice2Time("1 month");
      } else if (res.data.async_price_2_time_length === 2 && res.data.async_price_2_time_type === "month") {
        setAsyncPrice2Time("2 months");
      } else if (res.data.async_price_2_time_length === 3 && res.data.async_price_2_time_type === "month") {
        setAsyncPrice2Time("3 months");
      } else if (res.data.async_price_2_time_length === 6 && res.data.async_price_2_time_type === "month") {
        setAsyncPrice2Time("6 months");
      } else if (res.data.async_price_2_time_length === 100 && res.data.async_price_2_time_type === "year") {
        setAsyncPrice2Time("forever");
      }
    });
    setBlankLoading(false);
  }

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        // props.setOpenProfileWhatsThis(false);
        props.setState({ openProfileWhatsThis: false });
        props.setState({ openOfferingWhatsThis: false });
        props.setState({ openWaitingListWhatsThis: false });
        props.setState({ openCallWhatsThis: false });
        props.setState({ openContentWhatsThis: false });
        props.setState({ openStripeWhatsThis: false });
        props.setState({ openUrlWhatsThis: false });
        props.setState({ openEditUrl: false });
        props.setState({ openRefCalcWhatsThis: false });
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  // useEffect(() => {}, [props.uploadedContent]);

  useEffect(() => {
    if (waitingListShareLoc === true) {
      window.location.assign(window.location.href.split("#")[0] + "#checklist_waitlist");
      // props.setDashboardExpanded('dashboard');
      props.setState({ expandedDashboard: "dashboard" });
      setWaitingListShareLoc(false);
    }
  }, [waitingListShareLoc]);

  useEffect(() => {
    let progress_count = 0;
    if (props.missingProfiles !== null) {
      if (props.missingProfiles.length === 0) {
        progress_count += 1;
      }
    }
    // if (props.sharedWaitingList === true){
    //    progress_count += 1
    // }
    if (props.updatedPerks === true) {
      progress_count += 1;
    }
    if (props.uploadedContent === true) {
      progress_count += 1;
    }
    if (props.setupStripe === true) {
      progress_count += 1;
    }
    // props.setProgressCount(progress_count);
    props.setState({ progressCount: progress_count });
  }, [props.setupStripe, props.updatedPerks, props.uploadedContent, props.sharedWaitingList, props.missingProfiles]);

  useEffect(() => {
    if (props.tierChangeOptions.length === 0) {
      // props.setTierText('');
      props.setState({ tierText: "" });
    } else {
      if (props.windowWidth <= 1200) {
        // props.setTierText('Setup your tiers and perks');
        props.setState({ tierText: "Setup your tiers and perks" });
      } else {
        let tier_text_pre = "";
        for (let i = 0; i < props.tierChangeOptions.length; i++) {
          if (i === 0) {
            tier_text_pre = "You can still " + props.tierChangeOptions[0];
          } else if (i === props.tierChangeOptions.length - 1) {
            tier_text_pre = tier_text_pre + " and " + props.tierChangeOptions[i];
          } else {
            tier_text_pre = tier_text_pre + ", " + props.tierChangeOptions[i];
          }
        }
        // props.setTierText(tier_text_pre);
        props.setState({ tierText: tier_text_pre });
      }
    }
  }, [props.missingProfiles]);

  useEffect(() => {
    if (props.missingProfiles !== null) {
      if (props.missingProfiles.length === 0) {
        // props.setMissingText('');
        props.setState({ missingText: "" });
      } else {
        let missing_text_pre = "";
        if (props.windowWidth <= 1200) {
          props.setState({ missingText: t('dashboard.home.makeProfileStandOut') });
          // props.setMissingText('Make your profile stand out');
        } else {
          let missing_text_pre = "";
          // Map profile field names to translation keys
          const getProfileFieldTranslation = (fieldName) => {
            const fieldMap = {
              'profile photo': 'dashboard.home.profilePhoto',
              'header photo': 'dashboard.home.headerPhoto',
              'Short Bio': 'dashboard.home.shortBio',
              'Display Name': 'dashboard.home.displayName'
            };
            return t(fieldMap[fieldName] || fieldName);
          };
          for (let i = 0; i < props.missingProfiles.length; i++) {
            if (i === 0) {
              missing_text_pre = t('dashboard.home.addYour') + " " + getProfileFieldTranslation(props.missingProfiles[0]);
            } else if (i === props.missingProfiles.length - 1) {
              missing_text_pre = missing_text_pre + " " + t('dashboard.home.and') + " " + getProfileFieldTranslation(props.missingProfiles[i]);
            } else {
              missing_text_pre = missing_text_pre + ", " + getProfileFieldTranslation(props.missingProfiles[i]);
            }
          }
          // props.setMissingText(missing_text_pre);
          props.setState({ missingText: missing_text_pre });
        }
      }
    }
  }, [props.missingProfiles, t]);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        props.setRewatchVideoModal(false);
        props.setState({ tiersModal: false });
        props.setState({ publishModal: false });
        props.setStripeModal(false);
        props.setState({ confettiModal: false });
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  // const [windowWidth, setWindowWidth] = useState(props.windowWidth);

  const [n_cols, set_n_cols] = useState(0);
  const [tiers, setTiers] = useState([
    "Free",
    props.subscribe_popup_bronze_name,
    props.subscribe_popup_silver_name,
    props.subscribe_popup_gold_name,
    props.subscribe_popup_async_name,
  ]);

  const TOP_CONTENT_PADDING = props.is_me === true ? "0px" : "62px";

  const [activeTiers, setActiveTiers] = useState(["Free"]);
  const [activeTiersNoAsync, setActiveTiersNoAsync] = useState(["Free"]);

  useEffect(() => {
    if (props.isExtraSmallDevice) {
      set_n_cols(1);
    } else if (props.isSmallDevice) {
      set_n_cols(2);
    } else if (props.isMediumDevice) {
      set_n_cols(2);
    } else if (props.isLargeDevice) {
      set_n_cols(3);
    } else if (props.isXLargeDevice) {
      set_n_cols(4);
    }
  }, [props.isExtraSmallDevice, props.isSmallDevice, props.isMediumDevice, props.isLargeDevice, props.isXLargeDevice]);

  useEffect(() => {
    let active_tiers = ["Free"];
    let active_tiers_no_async = ["Free"];
    if (props.subscribe_popup_bronze_active === true) {
      active_tiers.push(props.subscribe_popup_bronze_name);
      active_tiers_no_async.push(props.subscribe_popup_bronze_name);
    }
    if (props.subscribe_popup_silver_active === true) {
      active_tiers.push(props.subscribe_popup_silver_name);
      active_tiers_no_async.push(props.subscribe_popup_silver_name);
    }
    if (props.subscribe_popup_gold_active === true) {
      active_tiers.push(props.subscribe_popup_gold_name);
      active_tiers_no_async.push(props.subscribe_popup_gold_name);
    }
    if (props.subscribe_popup_async_active === true) {
      active_tiers.push(props.subscribe_popup_async_name);
    }
    setActiveTiers(active_tiers);
    setActiveTiersNoAsync(active_tiers_no_async);
    setTiers([
      "Free",
      props.subscribe_popup_bronze_name,
      props.subscribe_popup_silver_name,
      props.subscribe_popup_gold_name,
      props.subscribe_popup_async_name,
    ]);
  }, [
    props.subscribe_popup_bronze_active,
    props.subscribe_popup_silver_active,
    props.subscribe_popup_gold_active,
    props.subscribe_popup_async_active,
    props.subscribe_popup_bronze_name,
    props.subscribe_popup_silver_name,
    props.subscribe_popup_gold_name,
    props.subscribe_popup_async_name,
  ]);

  // single_view_collection / previously used selected_collection_index
  useEffect(() => {
    // if (collectionData && collectionData[props.single_view_collection]){
    //    setIsContentLoading(false);
    // }
    if (collectionData) {
      setIsContentLoading(false);
    }
  }, [collectionData, props.single_view_collection]);

  // Ref to track the last URL product ID we fetched to prevent duplicate API calls
  const fetchedURLProductIdRef = useRef(null);
  const isFetchingURLProductRef = useRef(false);

  // Fetch URL product sales_files and product_sales_description from storefront API when in app view
  // This ensures sales data is loaded when single_view_url_product_item doesn't have it
  useEffect(() => {
    const isAppView = props.pageLayoutType === 'app' || props.pageLayoutTypeUpdated === 'app';
    const hasURLProductId = props.single_view_url_product && props.selected_tab === 'urls';
    
    // Get the current product ID
    const currentProductId = props.single_view_url_product ? Number(props.single_view_url_product) : null;
    
    if (!currentProductId || !isAppView || !hasURLProductId) {
      // Reset ref if no product ID or not in app view
      if (!currentProductId) {
        fetchedURLProductIdRef.current = null;
      }
      return;
    }
    
    // If we've already fetched for this product ID, don't fetch again
    if (fetchedURLProductIdRef.current === currentProductId || isFetchingURLProductRef.current) {
      return;
    }
    
    // Check if single_view_url_product_item has sales_files and product_sales_description
    // We fetch if either is missing to ensure we have complete data
    const itemMatches = props.single_view_url_product_item && 
      Number(props.single_view_url_product_item.id) === currentProductId;
    
    const hasSalesFiles = itemMatches &&
      props.single_view_url_product_item.sales_files && 
      Array.isArray(props.single_view_url_product_item.sales_files) && 
      props.single_view_url_product_item.sales_files.length > 0;
    
    const hasSalesDescription = itemMatches &&
      props.single_view_url_product_item.product_sales_description &&
      props.single_view_url_product_item.product_sales_description.trim() !== '';
    
    // Fetch if we don't have the item at all, or if we're missing either sales_files or product_sales_description
    const shouldFetch = !itemMatches || !hasSalesFiles || !hasSalesDescription;
    
    if (shouldFetch) {
      // Mark as fetching to prevent duplicate calls
      isFetchingURLProductRef.current = true;
      
      const form_data = new FormData();
      form_data.append("currency", props.currency || 'USD');
      const influencerStr = props.influencer || props.influencer_info?.influencer || props.influencer_name;
      
      axios({
        method: "post",
        url: getBackendUrl() + 'api/influencer/storefront_initial_data/' + influencerStr,
        data: form_data,
        headers: {
          "Content-type": "application/json",
        },
        withCredentials: true,
      }).then((res) => {
        // Find the URL product with matching ID
        // URLs are in res.data.data.urls (array of URL products)
        const urlsList = res.data.data?.urls || [];
        const matchingProduct = urlsList.find(p => Number(p.id) === currentProductId);
        
        if (matchingProduct && props.setState) {
          // Process sales_files URLs (same as Storefront.jsx does)
          const processedProduct = { ...matchingProduct };
          if (processedProduct.sales_files && Array.isArray(processedProduct.sales_files) && processedProduct.sales_files.length > 0) {
            const baseUrl = paths.CONTENT_CLOUDFRONT || (window.location.hostname === 'localhost' ? 'http://localhost:4566/fitwith/' : 'https://cdn.withme.so/');
            const processedFiles = processedProduct.sales_files.map(fileUrl => {
              if (!fileUrl || typeof fileUrl !== 'string') return fileUrl;
              const trimmed = fileUrl.trim();
              // If already a full URL, return as-is
              if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
                return trimmed;
              }
              // If starts with "null", replace with correct base URL
              if (trimmed.startsWith('null')) {
                const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:4566/fitwith/' : 'https://cdn.withme.so/';
                return trimmed.replace(/^null/, baseUrl);
              }
              // Otherwise, treat as filename and prepend base URL
              return baseUrl + (baseUrl.endsWith('/') ? '' : '/') + trimmed;
            });
            processedProduct.sales_files = processedFiles;
          }
          
          // Update single_view_url_product_item with the fetched data
          props.setState({
            single_view_url_product_item: processedProduct
          });
        }
        
        // Mark as fetched for this product ID
        fetchedURLProductIdRef.current = currentProductId;
        isFetchingURLProductRef.current = false;
      }).catch((err) => {
        console.error('Error fetching URL product data for app view:', err);
        isFetchingURLProductRef.current = false;
      });
    } else {
      // If we already have the data, mark as fetched
      fetchedURLProductIdRef.current = currentProductId;
    }
    
    // Reset ref if product ID changes
    if (fetchedURLProductIdRef.current !== null && fetchedURLProductIdRef.current !== currentProductId) {
      fetchedURLProductIdRef.current = null;
    }
  }, [props.single_view_url_product, props.selected_tab, props.pageLayoutType, props.pageLayoutTypeUpdated, props.currency, props.influencer, props.influencer_info?.influencer, props.influencer_name, props.single_view_url_product_item?.id, props.setState]);

  // --- URL Product Preview ---
  // When a specific URL product is selected (paid URL clicked), show URLProductPreview
  const urlProductItemFromList = (props.single_view_url_product && props.influencer_content_list)
    ? props.influencer_content_list.find(c => Number(c.id) === Number(props.single_view_url_product))
    : null;
  // Fallback: storefront URL items aren't in influencer_content_list (different API), so use directly passed item
  const urlProductItemFallback = (!urlProductItemFromList && props.single_view_url_product_item)
    ? {
        ...props.single_view_url_product_item,
        text: props.single_view_url_product_item.text || props.single_view_url_product_item.url,
        content_price: props.single_view_url_product_item.content_price !== undefined
          ? props.single_view_url_product_item.content_price
          : props.single_view_url_product_item.price,
      }
    : null;
  const baseUrlProductItem = urlProductItemFromList || urlProductItemFallback;
  // Enrich with storefront item (single_view_url_product_item) which has sales_files, product_sales_description, etc.
  // Content list items only have basic fields; storefront items have the full sales data.
  const storefrontEnrichment = props.single_view_url_product_item && Number(props.single_view_url_product_item.id) === Number(props.single_view_url_product)
    ? props.single_view_url_product_item
    : null;
  const urlProductItem = baseUrlProductItem ? {
    ...baseUrlProductItem,
    sales_files: storefrontEnrichment?.sales_files || baseUrlProductItem.sales_files,
    sales_file_types: storefrontEnrichment?.sales_file_types || baseUrlProductItem.sales_file_types,
    product_sales_description: storefrontEnrichment?.product_sales_description || baseUrlProductItem.product_sales_description,
    subtitle: storefrontEnrichment?.subtitle || baseUrlProductItem.subtitle,
    thumbnail: storefrontEnrichment?.button_image || storefrontEnrichment?.product_thumbnail || baseUrlProductItem.thumbnail,
  } : null;
  const showURLProductPreview = !!urlProductItem && !props.is_me;

  if (showURLProductPreview) {
    const brandColor = props.designProperties?.brandColorUpdated || props.designProperties?.brandColor || 'var(--brand-color)';
    // Show back button if we're NOT in storefront view
    // Default to app view unless explicitly storefront
    const isStorefront = props.pageLayoutType === 'storefront' || props.pageLayoutTypeUpdated === 'storefront';
    const isAppView = !isStorefront; // If not storefront, assume app view

    const urlProductPreview = (
      <URLProductPreview
        windowWidth={props.windowWidth}
        influencer={props.influencer}
        influencer_icon={props.influencer_icon}
        currency={props.currency}
        current_user={props.current_user}
        display_name={props.display_name}
        influencer_name={props.influencer_name}
        connected_stripe_account_id={props.connected_stripe_account_id || props.influencer_info?.connected_stripe_account_id}
        stripe_direct_charge_account_id={props.stripe_direct_charge_account_id || props.influencer_info?.stripe_direct_charge_account_id}
        setState={props.setState}
        productName={urlProductItem.name}
        productId={urlProductItem.id}
        productUrl={urlProductItem.text}
        currentProductInfo={{
          ...urlProductItem,
          files: urlProductItem.sales_files || urlProductItem.files || [],
          files_type: urlProductItem.sales_file_types || urlProductItem.files_type || [],
          description: urlProductItem.product_sales_description || urlProductItem.description || urlProductItem.subtitle || urlProductItem.content || '',
          free: urlProductItem.content_price === 0,
          access_duration: urlProductItem.access_duration || null,
          access_duration_type: urlProductItem.access_duration_type || null,
          is_coaching_call: urlProductItem.content_type === 'urc' || urlProductItem.content_type === 'urw',
        }}
        accessToCurrentProduct={!isVisitorPreview && Number(urlProductItem.id) === Number(props.single_view_url_product) && (
          isCustomerPreview || urlProductItem.current_tier === 5 || urlProductItem.access === true || storefrontEnrichment?.access === true
        )}
        productPrice={urlProductItem.content_price}
        real_checkout={!props.previewRolloutOwner}
        late_payment={props.late_payment || false}
        getBrandColor={() => brandColor}
        designProperties={props.designProperties}
        showBackOnMobile={isAppView}
        handleBack={() => {
          if (props.setState) {
            props.setState({
              single_view_url_product: '',
              single_view_url_product_item: null,
              selected_tab: 'urls'
            });
          }
          window.scrollTo({ top: 0, behavior: 'instant' });
        }}
      />
    );

    // Return URLProductPreview directly (no MobileFrame wrapper)
    return urlProductPreview;
  }

  const isLockedCoursePreview =
    props.selected_tab === "paid_collections" &&
    props.pageLayoutType !== "storefront" &&
    collectionData &&
    collectionData[collectionIndex] &&
    isCollectionAccessBlocked(collectionData[collectionIndex], true);

  let content_block = (
    <Grid
      container
      style={{
        marginTop: "0px",
        width: isLockedCoursePreview ? "1200px" : props.windowWidth <= 600 ? props.mobilePreview === true ? "350px" : "100vw" : (isShellActive ? "min(600px, 100%)" : "600px"),
        // maxWidth: '600px',
        minWidth: props.windowWidth > 1500 ? "600px" : "auto",
        // OVERFLOW HIDDEN ON MOBILE TO PREVENT SLIDING WHEN SCROLLING. VISIBLE ON DESKTOP BECAUSE SLIDING IS A NON-ISSUE AND IT WILL HIDE BORDERS OTHERWISE (NO BORDERS ON MOBILE)
        overflow: props.windowWidth < 600 ? "hidden" : "visible",
        maxWidth: "100%",
        display: "block",
      }}
    >
      {/* <span> {'props.selected_tab: ' + props.selected_tab}</span> */}
      {props.contentIsLoading ||
      props.loading_page_change ||
      (isContentLoading &&
        (props.selected_tab === "sub_collections" ||
          props.selected_tab === "paid_collections" ||
          props.selected_tab === "collections")) ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            // height: '50vh',
            // backgroundColor: 'pink',
            width: "100%",
          }}
        >
          {/* <CircularProgress style={{color: 'var(--brand-color)', margin: 'auto',}}/> */}
        </div>
      ) : (
        <>
          {contentData.length > 0 ||
          collectionData.length > 0 ||
          props.is_me ||
          ((props.view_type === "user-subscribed" ||
            props.view_type === "user-waitlist" ||
            props.view_type === "user") &&
            props.single_view_collection === "") ? (
            <>
              {(props.selected_tab === "sub_collections" ||
                props.selected_tab === "paid_collections" ||
                props.selected_tab === "collections" ||
                props.selected_tab === "courses") &&
              props.single_view_collection !== "" &&
              contentData.length > 0 ? (
                collectionData && collectionData[collectionIndex] && isCollectionAccessBlocked(collectionData[collectionIndex]) ? (
                  <></>
                ) : (
                  <>
                    {" "}
                    {nPages > 1 && props.isCollectionContentReorder !== true ? (
                      <Grid
                        container
                        xs={12}
                        alignItems={"center"}
                        justifyContent={"center"}
                        sx={{
                          margin: { xs: "20px auto 50px auto", lg: "20px auto 70px auto" },
                        }}
                      >
                        <StyledPagination
                          id="top_pages"
                          count={nPages}
                          page={props.page_n}
                          onChange={(event, page) => props.setPageN(page)}
                        />
                      </Grid>
                    ) : null}
                  </>
                )
              ) : null}

              {(props.selected_tab === "sub_collections" ||
                props.selected_tab === "paid_collections" ||
                props.selected_tab === "collections" ||
                props.selected_tab === "courses" ||
                props.selected_tab === "paid_posts" ||
                props.selected_tab === "paid_posts" ||
                props.selected_tab === "urls" ) &&
              props.single_view_collection !== "" &&
              contentData.length > 0 ? (
                (collectionData 
                  && collectionData[collectionIndex] 
                  && isCollectionAccessBlocked(collectionData[collectionIndex], true)) ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <>
                      {props.pageLayoutType === "storefront" ||
                      props.pageLayoutTypeUpdated === "storefront" ? (
                        <>
                          {/* Sales page via CoursePreview on storefront; empty here when locked */}
                        </>
                      ) : (
                        <>
                          {lockedCollectionCoursePreviewData ? (
                            <CoursePreview
                              windowWidth={props.windowWidth}
                              influencer={
                                props.influencer || props.influencer_info?.influencer
                              }
                              influencer_icon={props.influencer_icon}
                              currency={props.currency}
                              designProperties={props.designProperties}
                              current_user={props.current_user}
                              selected_tab={props.selected_tab}
                              display_name={props.display_name || props.influencer_name}
                              influencer_name={props.influencer_name}
                              connected_stripe_account_id={
                                props.connected_stripe_account_id ||
                                props.influencer_info?.connected_stripe_account_id
                              }
                              setState={props.setState}
                              courseId={
                                lockedCollectionCoursePreviewData.id || buyCollectionId
                              }
                              courseData={lockedCollectionCoursePreviewData}
                              getBrandColor={getBrandColor}
                              openBuyCollectionCheckout={props.openBuyCollectionCheckout}
                              openFreeCollection={props.openFreeCollection}
                              handleProfileTabChange={props.handleProfileTabChange}
                              onCourseUnlocked={() => {}}
                              handleBack={() => {}}
                              real_checkout={!props.previewRolloutOwner}
                              embeddedInTabView={true}
                            />
                          ) : null}
                        </>
                      )}
                    </>
                  </div>
                ) : contentData.length < 4 ? (
                  <>
                    {(props.isCollectionContentReorder || isDripOrStatsMode) ? (
                      // Component located inside of Collections/SinglePageCollection.js
                      <></>
                    ) : (
                      contentData.map((individual_content_info, index) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            key={individual_content_info?.id}
                            style={{
                              paddingTop: "0px",
                              
                              marginTop: "0px",
                              paddingBottom: props.selected_tab === "urls" ? "0px" : "30px",
                              // width: '100%',
                              width: props.windowWidth <= 600 ? props.mobilePreview === true ? '350px' :  "100vw" : (isShellActive ? "min(600px, 100%)" : "600px"),
                              maxWidth: "600px",
                              minWidth: props.windowWidth > 1500 ? "600px" : "auto",
                              display: "block",
                              margin: "0px auto",
                              paddingLeft: "0px",
                            }}
                          >
                              {individual_content_info?.content_type === 'url' || individual_content_info?.content_type === 'urc' || individual_content_info?.content_type === 'urw' || individual_content_info?.content_type === 'dm_url' || individual_content_info?.type === 'url' ? (
                                <URLCard
                                  item={individual_content_info}
                                  windowWidth={props.windowWidth}
                                  openBuyNowCheckout={props.openBuyNowCheckout}
                                  openURLProductView={props.openURLProductView}
                                  influencer={props.influencer}
                                  currency={props.currency}
                                  current_user={props.current_user}
                                  mobilePreview={props.mobilePreview}
                                />
                              ) : (
                                <CreatorContentCard
                                setState={props.setState}
                                unlockFreeContent={props.unlockFreeContent}
                              handleContentModalOpen={props.handleContentModalOpen}
                              handleContentModalClose={props.handleContentModalClose}
                              is_me={props.is_me}
                              windowWidth={props.windowWidth}
                              view_type={props.view_type}
                              handleRemoveSavedContent={props.handleRemoveSavedContent}
                              handleSavedContent={props.handleSavedContent}
                              currency={props.currency}
                              like_button_click_post={props.like_button_click_post}
                              share_button_click={props.share_button_click}
                              bookmark_button_post={props.bookmark_button_post}
                              bookmark_button_click={props.bookmark_button_click}
                              pinned_post_process={props.pinned_post_process}
                              like_button_click={props.like_button_click}
                              setShareId={setShareId}
                              setShareInfluencer={setShareInfluencer}
                              setShareName={setShareName}
                              setShareOpen={setShareOpen}
                              django_data_func={props.get_and_post_data_skeleton}
                              openTippingCheckout={props.openTippingCheckout}
                              current_user={props.current_user}
                              current_user_icon={props.current_user_icon}
                              username={props.current_user}
                              influencer={props.influencer}
                              display_name={props.display_name}
                              setCommentCount={props.setCommentCount}
                              OpenSubscribePopup={props.OpenSubscribePopup}
                              openBuyNowCheckout={props.openBuyNowCheckout}
                              collectionsContentEdit={props.collectionsContentEdit}
                              handleCollectionTabChange={props.handleCollectionTabChange}
                              openBuyCollectionCheckout={props.openBuyCollectionCheckout}
                              set_comment_snackbar={set_comment_snackbar}
                              set_comment_snackbar_message={set_comment_snackbar_message}
                              set_comment_snackbar_type={set_comment_snackbar_type}
                              set_comment_snackbar_background={set_comment_snackbar_background}
                              handleBuyNowCheckoutData={props.handleBuyNowCheckoutData}
                              buyNowThumbnailUrl={props.buyNowThumbnailUrl}
                              buyNowTitle={props.buyNowTitle}
                              buyNowContentType={props.buyNowContentType}
                              buyNowContentId={props.buyNowContentId}
                              {...props}
                              {...individual_content_info}
                              compare_at_price={individual_content_info.compare_at_price || buyCollectionCompareAtPrice}
                              onToggleComplete={Object.keys(chapterCompletion).length > 0 ? handleToggleComplete : undefined}
                              content_completion_stats={contentCompletion}
                              total_enrolled={totalEnrolled}
                              affiliate_enabled={
                                (props.selected_tab === "paid_collections" || props.selected_tab === "collections" || props.selected_tab === "courses") &&
                                collectionData[collectionIndex] != null
                                  ? collectionData[collectionIndex].affiliate_enabled
                                  : (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products")
                                  ? individual_content_info?.affiliate_enabled
                                  : undefined
                              }
                              inlineShareEarnConfig={classicTabsInlineDigitalShareConfigOriginal}
                            />
                              )}
                            </Grid>
                          );
                        })
                      )}
                    {nPages > 1 && props.update_inf_scroll === false && props.isCollectionContentReorder !== true ? (
                      <Grid
                        container
                        xs={12}
                        alignItems={"center"}
                        justifyContent={"center"}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        <StyledPagination
                          count={nPages}
                          page={props.page_n}
                          onChange={(event, page) => {
                            setTimeout(() => {
                              try {
                                var container = document.getElementById("main_div");
                                var containerRect = container.getBoundingClientRect();
                                var child = document.getElementById("top_pages");
                                var childRect = child.getBoundingClientRect();
                                var localTop = childRect.top - containerRect.top;
                                window.scrollTo(50, localTop - window.innerHeight / 2);
                                props.setPageN(page);
                              } catch (error) {}
                            }, 1000);
                          }}
                        />
                      </Grid>
                    ) : null}
                  </>
                ) : (
                  <InfiniteScroll
                    dataLength={contentData.length} //This is important field to render the next data
                    next={props.handleObserver}
                    hasMore={props.update_inf_scroll}
                    loader={
                      <Box sx={{ display: "flex", width: "100%" }}>
                        {contentData.length === 0 ? (
                          <CircularProgress sx={{ margin: "auto auto auto auto", color: "var(--brand-color)" }} />
                        ) : (
                          <CircularProgress sx={{ margin: "auto", color: "var(--brand-color)" }} />
                        )}
                      </Box>
                    }
                    endMessage={""}
                    style={{
                      top: "0px",
                      overflow: "visible",
                      backgroundColor: "var(--rebranding-background-color)",
                    }}
                    scrollableTarget={
                      (props.pageLayoutType === 'app' || props.pageLayoutTypeUpdated === 'app') 
                        ? "mobile-frame-scroll-container" 
                        : undefined
                    }
                  >
                    {/* <span>contentData.length: {contentData.length}</span> */}
                    {/* TODO add fix here */}
                    <Grid
                      container
                      xs={12}
                      lg={12}
                      sx={{
                        width: "100%",
                        maxWidth: "100%",
                        // width: props.width >= 1280 && props.is_me ? 'calc(83.5vw - 25px)' : 'calc(100vw - 25px)',
                        // maxWidth: props.width >= 1280 && props.is_me ? 'calc(83.5vw - 25px) !important' : 'calc(100vw - 25px) !important',
                      }}
                    >
                      {props.isCollectionContentReorder ? (
                        // Component located inside of Collections/SinglePageCollection.js
                        <></>
                        
                      ) : (
                        contentData.map((individual_content_info, index) => {
                          const currentChapter = individual_content_info?.chapter || '';
                          const previousChapter = index > 0 ? (contentData[index - 1]?.chapter || '') : '';
                          const showChapterHeader = props.selected_tab === "paid_collections" && 
                            (index === 0 || currentChapter !== previousChapter) && 
                            currentChapter !== '';
                          
                          // Find chapter index for ID
                          const chapterIndex = props.course_chapters && props.course_chapters.length > 0
                            ? props.course_chapters.findIndex(ch => {
                                let chapterName;
                                if (Array.isArray(ch)) {
                                  chapterName = ch[0];
                                } else if (typeof ch === 'string') {
                                  chapterName = ch;
                                } else {
                                  chapterName = ch.chapter_name || ch.name || '';
                                }
                                return chapterName === currentChapter;
                              })
                            : -1;
                          
                          return (
                            <React.Fragment key={individual_content_info?.id}>
                              {showChapterHeader && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                                  id={chapterIndex >= 0 ? `chapter-${chapterIndex}` : undefined}
                                  style={{
                                    paddingTop: index === 0 ? "0px" : "20px",
                                    marginTop: index === 0 ? "0px" : "20px",
                                    paddingBottom: "10px",
                                    width: props.windowWidth <= 600 ? props.mobilePreview === true ? '350px' : "100vw" : "600px",
                                    maxWidth: "600px",
                                    minWidth: props.windowWidth > 1500 ? "600px" : "auto",
                                    display: "block",
                                    margin: "0px auto",
                                    paddingLeft: "0px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "18px",
                                      fontWeight: 600,
                                      color: "#1D1D1D",
                                      paddingBottom: "8px",
                                      borderBottom: "2px solid #E4EBF6",
                                    }}
                                  >
                                    {currentChapter}
                                  </Typography>
                                </Grid>
                              )}
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              style={{
                                paddingTop: "0px",
                                marginTop: "0px",
                                paddingBottom: props.selected_tab === "urls" ? "0px" : "30px",
                                width: props.windowWidth <= 600 ? props.mobilePreview === true ? '350px' : "100vw" : "600px",
                                maxWidth: "600px",
                                minWidth: props.windowWidth > 1500 ? "600px" : "auto",
                                display: "block",
                                margin: "0px auto",
                                paddingLeft: "0px",
                              }}
                            >
                              {individual_content_info?.content_type === 'url' || individual_content_info?.content_type === 'urc' || individual_content_info?.content_type === 'urw' || individual_content_info?.content_type === 'dm_url' || individual_content_info?.type === 'url' ? (
                                <URLCard
                                  item={individual_content_info}
                                  windowWidth={props.windowWidth}
                                  openBuyNowCheckout={props.openBuyNowCheckout}
                                  openURLProductView={props.openURLProductView}
                                  influencer={props.influencer}
                                  currency={props.currency}
                                  current_user={props.current_user}
                                  mobilePreview={props.mobilePreview}
                                />
                              ) : (
                                <CreatorContentCard
                                setState={props.setState}
                                unlockFreeContent={props.unlockFreeContent}
                                display_name={props.display_name}
                                handleContentModalOpen={props.handleContentModalOpen}
                                handleContentModalClose={props.handleContentModalClose}
                                is_me={props.is_me}
                                windowWidth={props.windowWidth}
                                view_type={props.view_type}
                                handleRemoveSavedContent={props.handleRemoveSavedContent}
                                handleSavedContent={props.handleSavedContent}
                                currency={props.currency}
                                like_button_click_post={props.like_button_click_post}
                                share_button_click={props.share_button_click}
                                bookmark_button_post={props.bookmark_button_post}
                                bookmark_button_click={props.bookmark_button_click}
                                pinned_post_process={props.pinned_post_process}
                                like_button_click={props.like_button_click}
                                setShareId={setShareId}
                                setShareInfluencer={setShareInfluencer}
                                setShareName={setShareName}
                                setShareOpen={setShareOpen}
                                django_data_func={props.get_and_post_data_skeleton}
                                openTippingCheckout={props.openTippingCheckout}
                                current_user={props.current_user}
                                current_user_icon={props.current_user_icon}
                                username={props.current_user}
                                influencer={props.influencer}
                                setCommentCount={props.setCommentCount}
                                OpenSubscribePopup={props.OpenSubscribePopup}
                                openBuyNowCheckout={props.openBuyNowCheckout}
                                openBuyCollectionCheckout={props.openBuyCollectionCheckout}
                                set_comment_snackbar={set_comment_snackbar}
                                set_comment_snackbar_message={set_comment_snackbar_message}
                                set_comment_snackbar_type={set_comment_snackbar_type}
                                set_comment_snackbar_background={set_comment_snackbar_background}
                                handleBuyNowCheckoutData={props.handleBuyNowCheckoutData}
                                buyNowThumbnailUrl={props.buyNowThumbnailUrl}
                                buyNowTitle={props.buyNowTitle}
                                buyNowContentType={props.buyNowContentType}
                                buyNowContentId={props.buyNowContentId}
                                {...props}
                                {...individual_content_info}
                              compare_at_price={individual_content_info.compare_at_price || buyCollectionCompareAtPrice}
                              onToggleComplete={Object.keys(chapterCompletion).length > 0 ? handleToggleComplete : undefined}
                              content_completion_stats={contentCompletion}
                              total_enrolled={totalEnrolled}
                                affiliate_enabled={
                                  (props.selected_tab === "paid_collections" || props.selected_tab === "collections" || props.selected_tab === "courses") &&
                                  collectionData[collectionIndex] != null
                                    ? collectionData[collectionIndex].affiliate_enabled
                                    : (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products")
                                    ? individual_content_info?.affiliate_enabled
                                    : undefined
                                }
                                inlineShareEarnConfig={classicTabsInlineDigitalShareConfigOriginal}
                              />
                              )}
                            </Grid>
                            </React.Fragment>
                          );
                        })
                      )}
                    </Grid>
                    {nPages > 1 && props.update_inf_scroll === false && props.isCollectionContentReorder !== true ? (
                      <Grid
                        container
                        xs={12}
                        alignItems={"center"}
                        justifyContent={"center"}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        <StyledPagination
                          count={nPages}
                          page={props.page_n}
                          onChange={(event, page) => {
                            setTimeout(() => {
                              try {
                                var container = document.getElementById("main_div");
                                var containerRect = container.getBoundingClientRect();
                                var child = document.getElementById("top_pages");
                                var childRect = child.getBoundingClientRect();
                                var localTop = childRect.top - containerRect.top;
                                window.scrollTo(50, localTop - window.innerHeight / 2);
                                props.setPageN(page);
                              } catch (error) {}
                            }, 1000);
                          }}
                        />
                      </Grid>
                    ) : null}
                  </InfiniteScroll>
                )
              ) : // all feed when < 4
              contentData.length < 4 ? (
                <>
                  {contentData.map((individual_content_info, index) => {
                    const currentChapter = individual_content_info?.chapter || '';
                    const previousChapter = index > 0 ? (contentData[index - 1]?.chapter || '') : '';
                    const showChapterHeader = props.selected_tab === "paid_collections" && 
                      (index === 0 || currentChapter !== previousChapter) && 
                      currentChapter !== '';
                    
                    // Find chapter index for ID
                    const chapterIndex = props.course_chapters && props.course_chapters.length > 0
                      ? props.course_chapters.findIndex(ch => {
                          let chapterName;
                          if (Array.isArray(ch)) {
                            chapterName = ch[0];
                          } else if (typeof ch === 'string') {
                            chapterName = ch;
                          } else {
                            chapterName = ch.chapter_name || ch.name || '';
                          }
                          return chapterName === currentChapter;
                        })
                      : -1;
                    
                    return (
                      <React.Fragment key={individual_content_info?.id}>
                        {showChapterHeader && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                            id={chapterIndex >= 0 ? `chapter-${chapterIndex}` : undefined}
                            style={{
                              paddingTop: index === 0 ? "0px" : "20px",
                              marginTop: index === 0 ? "0px" : "20px",
                              paddingBottom: "10px",
                              width: "100%",
                              display: "block",
                              margin: "0px auto",
                              paddingLeft: "0px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "18px",
                                fontWeight: 600,
                                color: "#1D1D1D",
                                paddingBottom: "8px",
                                borderBottom: "2px solid #E4EBF6",
                              }}
                            >
                              {currentChapter}
                            </Typography>
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                        style={{
                          paddingTop: "0px",
                          marginTop: "0px",
                          paddingBottom: props.selected_tab === "urls" ? "0px" : "30px",
                          width: "100%",
                          display: "block",
                          margin: "0px auto",
                          paddingLeft: "0px",
                        }}
                      >
                           {
                            individual_content_info?.content_type === 'url' || individual_content_info?.content_type === 'urc' || individual_content_info?.content_type === 'urw' || individual_content_info?.content_type === 'dm_url' || individual_content_info?.type === 'url' ? (
                              <URLCard
                                  item={individual_content_info}
                                  windowWidth={props.windowWidth}
                                  openBuyNowCheckout={props.openBuyNowCheckout}
                                  openURLProductView={props.openURLProductView}
                                  influencer={props.influencer}
                                  currency={props.currency}
                                  current_user={props.current_user}
                                  mobilePreview={props.mobilePreview}
                                />
                            ) : (
                        <CreatorContentCard
                          setState={props.setState}
                          unlockFreeContent={props.unlockFreeContent}
                          display_name={props.display_name}
                          handleContentModalOpen={props.handleContentModalOpen}
                          handleContentModalClose={props.handleContentModalClose}
                          is_me={props.is_me}
                          windowWidth={props.windowWidth}
                          view_type={props.view_type}
                          handleRemoveSavedContent={props.handleRemoveSavedContent}
                          handleSavedContent={props.handleSavedContent}
                          currency={props.currency}
                          like_button_click_post={props.like_button_click_post}
                          share_button_click={props.share_button_click}
                          bookmark_button_post={props.bookmark_button_post}
                          bookmark_button_click={props.bookmark_button_click}
                          pinned_post_process={props.pinned_post_process}
                          like_button_click={props.like_button_click}
                          setShareId={setShareId}
                          setShareInfluencer={setShareInfluencer}
                          setShareName={setShareName}
                          setShareOpen={setShareOpen}
                          django_data_func={props.get_and_post_data_skeleton}
                          openTippingCheckout={props.openTippingCheckout}
                          current_user={props.current_user}
                          current_user_icon={props.current_user_icon}
                          username={props.current_user}
                          influencer={props.influencer}
                          setCommentCount={props.setCommentCount}
                          OpenSubscribePopup={props.OpenSubscribePopup}
                          openBuyNowCheckout={props.openBuyNowCheckout}
                          openBuyCollectionCheckout={props.openBuyCollectionCheckout}
                          set_comment_snackbar={set_comment_snackbar}
                          set_comment_snackbar_message={set_comment_snackbar_message}
                          set_comment_snackbar_type={set_comment_snackbar_type}
                          set_comment_snackbar_background={set_comment_snackbar_background}
                          handleBuyNowCheckoutData={props.handleBuyNowCheckoutData}
                          buyNowThumbnailUrl={props.buyNowThumbnailUrl}
                          buyNowTitle={props.buyNowTitle}
                          buyNowContentType={props.buyNowContentType}
                          buyNowContentId={props.buyNowContentId}
                          {...props}
                          {...individual_content_info}
                          compare_at_price={individual_content_info.compare_at_price || buyCollectionCompareAtPrice}
                          affiliate_enabled={
                            (props.selected_tab === "paid_collections" || props.selected_tab === "collections" || props.selected_tab === "courses") &&
                            collectionData[collectionIndex] != null
                              ? collectionData[collectionIndex].affiliate_enabled
                              : (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products")
                              ? individual_content_info?.affiliate_enabled
                              : undefined
                          }
                          inlineShareEarnConfig={classicTabsInlineDigitalShareConfigOriginal}
                        />
                          )}
                      </Grid>
                      </React.Fragment>
                    );
                  })}
                  {nPages > 1 && props.update_inf_scroll === false && props.isCollectionContentReorder !== true ? (
                    <Grid
                      container
                      xs={12}
                      alignItems={"center"}
                      justifyContent={"center"}
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <StyledPagination
                        count={nPages}
                        page={props.page_n}
                        onChange={(event, page) => {
                          setTimeout(() => {
                            try {
                              var container = document.getElementById("main_div");
                              var containerRect = container.getBoundingClientRect();
                              var child = document.getElementById("top_pages");
                              var childRect = child.getBoundingClientRect();
                              var localTop = childRect.top - containerRect.top;
                              window.scrollTo(50, localTop - window.innerHeight / 2);
                              props.setPageN(page);
                            } catch (error) {}
                          }, 1000);
                        }}
                      />
                    </Grid>
                  ) : null}
                </>
              ) : (
                // all feed when >= 4
                <InfiniteScroll
                  dataLength={contentData.length} //This is important field to render the next data
                  next={props.handleObserver}
                  hasMore={props.update_inf_scroll}
                  loader={
                    <Box sx={{ display: "flex", width: "100%" }}>
                      {contentData.length === 0 ? (
                        <CircularProgress sx={{ margin: "auto auto auto auto", color: "var(--brand-color)" }} />
                      ) : (
                        <CircularProgress sx={{ margin: "auto", color: "var(--brand-color)" }} />
                      )}
                    </Box>
                  }
                  endMessage={""}
                  style={{
                    top: "0px",
                    overflow: "visible",
                    backgroundColor: "var(--rebranding-background-color)",
                  }}
                  scrollableTarget={
                    (props.pageLayoutType === 'app' || props.pageLayoutTypeUpdated === 'app') 
                      ? "mobile-frame-scroll-container" 
                      : undefined
                  }
                >
                  <Grid
                    container
                    xs={12}
                    lg={12}
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    {contentData.map((individual_content_info, index) => {
                      const currentChapter = individual_content_info?.chapter || '';
                      const previousChapter = index > 0 ? (contentData[index - 1]?.chapter || '') : '';
                      const showChapterHeader = props.selected_tab === "paid_collections" && 
                        (index === 0 || currentChapter !== previousChapter) && 
                        currentChapter !== '';
                      
                      // Find chapter index for ID
                      const chapterIndex = props.course_chapters && props.course_chapters.length > 0
                        ? props.course_chapters.findIndex(ch => {
                            let chapterName;
                            if (Array.isArray(ch)) {
                              chapterName = ch[0];
                            } else if (typeof ch === 'string') {
                              chapterName = ch;
                            } else {
                              chapterName = ch.chapter_name || ch.name || '';
                            }
                            return chapterName === currentChapter;
                          })
                        : -1;
                      
                      return (
                        <React.Fragment key={individual_content_info?.id}>
                          {showChapterHeader && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                              id={chapterIndex >= 0 ? `chapter-${chapterIndex}` : undefined}
                              style={{
                                paddingTop: index === 0 ? "0px" : "20px",
                                marginTop: index === 0 ? "0px" : "20px",
                                paddingBottom: "10px",
                                display: "block",
                                margin: "0px auto",
                                paddingLeft: "0px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "#1D1D1D",
                                  paddingBottom: "8px",
                                  borderBottom: "2px solid #E4EBF6",
                                }}
                              >
                                {currentChapter}
                              </Typography>
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                          style={{
                            paddingTop: "0px",
                            marginTop: "0px",
                            paddingBottom: props.selected_tab === "urls" ? "0px" : "30px",
                            display: "block",
                            margin: "0px auto",
                            paddingLeft: "0px",
                          }}
                        >
                          {
                            individual_content_info?.content_type === 'url' || individual_content_info?.content_type === 'urc' || individual_content_info?.content_type === 'urw' || individual_content_info?.content_type === 'dm_url' || individual_content_info?.type === 'url' ? (
                              // URL Card Component
                              <URLCard
                                  item={individual_content_info}
                                  windowWidth={props.windowWidth}
                                  openBuyNowCheckout={props.openBuyNowCheckout}
                                  openURLProductView={props.openURLProductView}
                                  influencer={props.influencer}
                                  currency={props.currency}
                                  current_user={props.current_user}
                                  mobilePreview={props.mobilePreview}
                                />
                            ) : (
                              <CreatorContentCard
                              setState={props.setState}
                              unlockFreeContent={props.unlockFreeContent}
                            display_name={props.display_name}
                            handleContentModalOpen={props.handleContentModalOpen}
                            handleContentModalClose={props.handleContentModalClose}
                            is_me={props.is_me}
                            windowWidth={props.windowWidth}
                            view_type={props.view_type}
                            handleRemoveSavedContent={props.handleRemoveSavedContent}
                            handleSavedContent={props.handleSavedContent}
                            currency={props.currency}
                            like_button_click_post={props.like_button_click_post}
                            share_button_click={props.share_button_click}
                            bookmark_button_post={props.bookmark_button_post}
                            bookmark_button_click={props.bookmark_button_click}
                            pinned_post_process={props.pinned_post_process}
                            like_button_click={props.like_button_click}
                            setShareId={setShareId}
                            setShareInfluencer={setShareInfluencer}
                            setShareName={setShareName}
                            setShareOpen={setShareOpen}
                            django_data_func={props.get_and_post_data_skeleton}
                            openTippingCheckout={props.openTippingCheckout}
                            current_user={props.current_user}
                            current_user_icon={props.current_user_icon}
                            username={props.current_user}
                            influencer={props.influencer}
                            setCommentCount={props.setCommentCount}
                            OpenSubscribePopup={props.OpenSubscribePopup}
                            openBuyNowCheckout={props.openBuyNowCheckout}
                            openBuyCollectionCheckout={props.openBuyCollectionCheckout}
                            set_comment_snackbar={set_comment_snackbar}
                            set_comment_snackbar_message={set_comment_snackbar_message}
                            set_comment_snackbar_type={set_comment_snackbar_type}
                            set_comment_snackbar_background={set_comment_snackbar_background}
                            handleBuyNowCheckoutData={props.handleBuyNowCheckoutData}
                            buyNowThumbnailUrl={props.buyNowThumbnailUrl}
                            buyNowTitle={props.buyNowTitle}
                            buyNowContentType={props.buyNowContentType}
                            buyNowContentId={props.buyNowContentId}
                            {...props}
                            {...individual_content_info}
                            compare_at_price={individual_content_info.compare_at_price || buyCollectionCompareAtPrice}
                            affiliate_enabled={
                              (props.selected_tab === "paid_collections" || props.selected_tab === "collections" || props.selected_tab === "courses") &&
                              collectionData[collectionIndex] != null
                                ? collectionData[collectionIndex].affiliate_enabled
                                : (props.selected_tab === "paid_posts" || props.selected_tab === "digital_products")
                                ? individual_content_info?.affiliate_enabled
                                : undefined
                            }
                            inlineShareEarnConfig={classicTabsInlineDigitalShareConfigOriginal}
                          />
                            )}
                        </Grid>
                        </React.Fragment>
                      );
                    })}
                  </Grid>
                  {nPages > 1 && props.update_inf_scroll === false && props.isCollectionContentReorder !== true ? (
                    <Grid
                      container
                      xs={12}
                      alignItems={"center"}
                      justifyContent={"center"}
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <StyledPagination
                        count={nPages}
                        page={props.page_n}
                        onChange={(event, page) => {
                          setTimeout(() => {
                            try {
                              var container = document.getElementById("main_div");
                              var containerRect = container.getBoundingClientRect();
                              var child = document.getElementById("top_pages");
                              var childRect = child.getBoundingClientRect();
                              var localTop = childRect.top - containerRect.top;
                              window.scrollTo(50, localTop - window.innerHeight / 2);
                              props.setPageN(page);
                            } catch (error) {}
                          }, 1000);
                        }}
                      />
                    </Grid>
                  ) : null}
                </InfiniteScroll>
              )}
            </>
          ) : null}
        </>
      )}
    </Grid>
  );

  return (
    <>
      {/*// SPACE BETWEEN TABS & contentData IS 62PX -> EQUAL TO THE HEIGHT OF THE TAB FILTERS ON LIBRARY*/}
      {/* { contentData 
         && contentData.length > 0 || collectionData && collectionData.length > 0 ? */}
      {(props.my_platform_page !== "add_content" && props.my_platform_page !== "edit_content" && props.my_platform_page !== "add_course" && props.my_platform_page !== "edit_course") &&<div
        style={{
          width: props.windowWidth >= 1280 ? "" : "100%",
          margin: props.windowWidth >= 1280 ? "0px 40px" : "0px 0px 0px 0px",
          backgroundColor: 'var(--rebranding-background-color)',
        }}
      >

        {/* Mobile Chapter Bar - collapsible (non-course collections only, courses handled below) */}
        {props.selected_tab === "paid_collections" &&
          props.selected_tab !== "courses" &&
          !props.is_me &&
          props.single_view_collection !== "" &&
          props.courseLibraryTab !== 'library' &&
          props.course_chapters &&
          props.course_chapters.length > 0 &&
          ((props.is_me === true && (props.windowWidth <= 1100 || (props.windowWidth >= 1280 && props.windowWidth <= 1424)))
          || (props.is_me === false && props.windowWidth <= 1100)) &&
          props.isCollectionContentReorder !== true &&
          !isDripOrStatsMode &&
          !(collectionData && collectionData[collectionIndex] && isCollectionAccessBlocked(collectionData[collectionIndex], true)) &&
          (() => {
            const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
            const hasOnlyOther = regularChapters.length === 0 && otherChapter !== null;
            return !hasOnlyOther;
          })() && (
            <Box
              sx={{
                width: '100%',
                maxWidth: '600px',
                margin: '0 auto 20px auto',
                padding: { xs: '0 12px', sm: '0 20px' },
                minWidth: '0',
                boxSizing: 'border-box',
              }}
            >
              <Box sx={{
                backgroundColor: '#fff',
                borderRadius: mobileChaptersExpanded ? '14px' : '30px',
                border: '1px solid #E4EBF6',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'border-radius 0.2s',
              }}>
                {/* Collapsed bar */}
                <Box
                  onClick={() => setMobileChaptersExpanded(!mobileChaptersExpanded)}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    padding: '14px 18px', cursor: 'pointer',
                    '&:hover': { backgroundColor: '#F8F9FB' },
                  }}
                >
                  <TbChevronRight style={{
                    fontSize: '18px', color: '#6E89AF',
                    transform: mobileChaptersExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#6E89AF', letterSpacing: '1px', textTransform: 'uppercase' }}>
                    {t('influencer.headers.chapters')}
                  </Typography>
                  {(() => {
                    if (props.selected_chapter && props.selected_chapter !== '' && props.selected_chapter !== '_-_-other_-_-') {
                      return (
                        <Typography sx={{ fontSize: '13px', color: '#1D1D1D', fontWeight: 500 }}>
                          · {formatChapterName(props.selected_chapter)}
                        </Typography>
                      );
                    }
                    if (showCourseExamples && exampleChapters[selectedExampleChapter]) {
                      return (
                        <Typography sx={{ fontSize: '13px', color: '#1D1D1D', fontWeight: 500 }}>
                          · {exampleChapters[selectedExampleChapter].name}
                        </Typography>
                      );
                    }
                    return null;
                  })()}
                  <Box sx={{ flex: 1 }} />
                </Box>

                {/* Expanded chapter list */}
                {mobileChaptersExpanded && (
                  <Box sx={{ padding: '0 16px 16px 16px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {(() => {
                        const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
                        const allChapters = [...regularChapters];
                        if (otherChapter && regularChapters.length > 0) allChapters.push(otherChapter);
                        return allChapters.map((chapter, index) => {
                          const chapterName = Array.isArray(chapter) ? chapter[0] : chapter;
                          const displayName = formatChapterName(chapterName);
                          const isSelected = props.selected_chapter === chapterName || (props.selected_chapter === 'Other' && chapterName === '_-_-other_-_-');
                          const isOther = chapterName === '_-_-other_-_-';
                          const chapterNumber = isOther ? null : index + 1;
                          return (
                            <Box
                              key={index}
                              onClick={() => {
                                props.handleCollectionTabChange(null, props.single_view_collection, props.selected_tab, null, null, null, chapterName);
                              }}
                              sx={{
                                padding: '8px 12px', borderRadius: '12px', cursor: 'pointer',
                                transition: 'all 0.15s ease',
                                backgroundColor: isSelected ? '#FAFBFF' : '#fff',
                                border: isSelected ? '1.5px solid var(--brand-color)' : '1.5px solid #E4EBF6',
                                '&:hover': { backgroundColor: '#F8F9FB' },
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {chapterNumber && (
                                <Box sx={{
                                  width: 24, height: 24, borderRadius: '50%',
                                  backgroundColor: isSelected ? '#DDE4F8' : '#EDF0F7',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                }}>
                                  <Typography sx={{ fontSize: '12px', fontWeight: 700, color: isSelected ? 'var(--brand-color)' : '#6E89AF' }}>
                                    {chapterNumber}
                                  </Typography>
                                </Box>
                              )}
                              <Typography sx={{
                                fontSize: '13px', fontWeight: isSelected ? 600 : 500, color: '#1D1D1D',
                                flex: 1, textTransform: 'capitalize', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {displayName}
                              </Typography>
                              </Box>
                              {(() => {
                                const chId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                const isOtherCh = chapterName === '_-_-other_-_-';
                                const cc = isOtherCh ? chapterCompletion['other'] : (chId ? chapterCompletion[String(chId)] : null);
                                if (Object.keys(chapterCompletion).length === 0) return null;
                                const rate = cc?.completion_rate ?? 0;
                                const completed = cc?.completed ?? 0;
                                const total = cc?.total ?? 0;
                                const enrolled = cc?.enrolled ?? totalEnrolled ?? 0;
                                const pct = props.is_me ? rate : (total > 0 ? Math.round((completed / total) * 100) : 0);
                                return (
                                  <Box sx={{ px: '2px', pb: '2px', pt: '6px' }}>
                                    <Box sx={{ height: '3px', backgroundColor: '#E8ECF3', borderRadius: '2px', overflow: 'hidden', width: '100%' }}>
                                      <Box sx={{ width: `${pct}%`, height: '100%', backgroundColor: pct === 100 ? '#43A047' : 'var(--brand-color)', borderRadius: '2px', transition: 'width 0.3s ease', minWidth: pct > 0 ? '3px' : '0px' }} />
                                    </Box>
                                    <Typography sx={{ fontSize: '9px', color: '#B0B8C9', mt: '2px', textAlign: 'right', fontWeight: 500 }}>
                                      {props.is_me ? t('progress.usersCompleted', { completions: completed, enrolled }) : t('progress.lessonsComplete', { completed, total })}
                                    </Typography>
                                  </Box>
                                );
                              })()}
                            </Box>
                          );
                        });
                      })()}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}

        {/* Add Chapter Modal */}
        <Modal
          open={addChapterModalOpen}
          onClose={() => { setAddChapterModalOpen(false); setNewChapterName(''); }}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={{ backgroundColor: '#fff', borderRadius: '8px', padding: '24px', width: '90%', maxWidth: '500px', outline: 'none' }}>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, marginBottom: '20px', color: '#1D1D1D' }}>
              {t('influencer.actions.addNewChapter')}
            </Typography>
            <TextField
              fullWidth
              label={t('influencer.chapter.nameLabel')}
              value={newChapterName}
              onChange={(e) => { if (e.target.value.length <= 200) setNewChapterName(e.target.value); }}
              inputProps={{ maxLength: 200 }}
              helperText={t('influencer.chapter.charactersCounter', { current: newChapterName.length, max: 200 })}
              sx={{ marginBottom: '12px' }}
              onKeyPress={async (e) => {
                if (e.key === 'Enter' && newChapterName.trim()) {
                  const chapterName = newChapterName.trim();
                  const currentCollection = Array.isArray(collectionData) && collectionData.length > 0
                    ? collectionData.find(c => c.course_name === props.single_view_collection || c.id === props.single_view_collection)
                    : null;
                  if (currentCollection) {
                    const form_data = new FormData();
                    form_data.append('course_name', currentCollection.course_name);
                    form_data.append('chapter_name', chapterName);
                    const res = await axios.post(paths.BACKEND_URL + 'api/influencer/community/create_new_chapter', form_data, { withCredentials: true });
                    if (res.data.success) {
                      props.setState({ course_chapters: [...(props.course_chapters || []), [chapterName, res.data.chapter_id]] });
                      setAddChapterModalOpen(false);
                      setNewChapterName('');
                    }
                  }
                }
              }}
            />
            <Typography sx={{ fontSize: '14px', color: '#666', marginBottom: '20px', fontStyle: 'italic' }}>
              {t('influencer.chapter.enterChapterName', 'Enter a name for your new chapter.')}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button onClick={() => { setAddChapterModalOpen(false); setNewChapterName(''); }} sx={{ color: '#6E89AF' }}>
                {t('influencer.actions.cancel')}
              </Button>
              <Button
                onClick={async () => {
                  if (newChapterName.trim()) {
                    const chapterName = newChapterName.trim();
                    const currentCollection = Array.isArray(collectionData) && collectionData.length > 0
                      ? collectionData.find(c => c.course_name === props.single_view_collection || c.id === props.single_view_collection)
                      : null;
                    if (currentCollection) {
                      const form_data = new FormData();
                      form_data.append('course_name', currentCollection.course_name);
                      form_data.append('chapter_name', chapterName);
                      const res = await axios.post(paths.BACKEND_URL + 'api/influencer/community/create_new_chapter', form_data, { withCredentials: true });
                      if (res.data.success) {
                        props.setState({ course_chapters: [...(props.course_chapters || []), [chapterName, res.data.chapter_id]] });
                        setAddChapterModalOpen(false);
                        setNewChapterName('');
                      }
                    }
                  }
                }}
                disabled={!newChapterName.trim()}
                variant="contained"
                sx={{ backgroundColor: 'var(--brand-color)', '&:hover': { backgroundColor: 'var(--brand-color)' }, '&:disabled': { backgroundColor: '#9CA3AF' } }}
              >
                {t('influencer.actions.addChapter', 'Add Chapter')}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Reorder Modal */}
        <Dialog
          open={mobileReorderModalOpen}
          onClose={() => {
            setMobileReorderModalOpen(false);
            setReorderedChapters([]);
            setDragIdx(null);
          }}
          maxWidth="sm"
          fullWidth={props.windowWidth <= 900}
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: '12px',
              maxHeight: '80vh',
              ...(props.windowWidth > 900 && {
                maxWidth: '500px',
                width: '500px',
                margin: 'auto',
              }),
            },
          }}
        >
          <DialogTitle
            sx={{
              fontSize: { xs: '16px', sm: '18px' },
              fontWeight: 600,
              padding: { xs: '16px', sm: '20px' },
              paddingBottom: { xs: '12px', sm: '16px' },
              borderBottom: '1px solid #E4EBF6',
            }}
          >
            Reorder Chapters
          </DialogTitle>
          <DialogContent sx={{ padding: { xs: '16px', sm: '20px' } }}>
            <ReactSortable
              list={(() => {
                // Filter out "other" chapter for reordering
                const { regularChapters } = processChapters(props.course_chapters || []);
                const baseList = reorderedChapters.length > 0 ? reorderedChapters : regularChapters.map(ch => Array.isArray(ch) ? [...ch] : ch);
                // Additional safety filter to ensure "Other" is never in the list
                return baseList.filter((chapter) => {
                  const chapterName = Array.isArray(chapter) ? chapter[0] : (chapter.chapter_name || chapter.name || chapter);
                  return chapterName !== '_-_-other_-_-';
                });
              })()}
              setList={(newList) => {
                // Filter out "Other" when setting the list
                const filtered = newList.filter((chapter) => {
                  const chapterName = Array.isArray(chapter) ? chapter[0] : (chapter.chapter_name || chapter.name || chapter);
                  return chapterName !== '_-_-other_-_-';
                });
                setReorderedChapters(filtered);
              }}
              animation={200}
              ghostClass="sortable-ghost"
              chosenClass="sortable-chosen"
              handle=".drag-handle"
              forceFallback={false}
              fallbackOnBody={true}
              swapThreshold={0.65}
              delayOnTouchStart={true}
              delay={0}
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              {(reorderedChapters.length > 0 ? reorderedChapters : (() => {
                const { regularChapters } = processChapters(props.course_chapters || []);
                return regularChapters.map(ch => Array.isArray(ch) ? [...ch] : ch);
              })()).filter((chapter) => {
                // Additional safety filter to ensure "Other" is never shown
                const chapterName = Array.isArray(chapter) ? chapter[0] : (chapter.chapter_name || chapter.name || chapter);
                return chapterName !== '_-_-other_-_-';
              }).map((chapter, idx) => {
                const chapterName = Array.isArray(chapter) ? chapter[0] : chapter;
                const chapterId = Array.isArray(chapter) ? (chapter[1] || idx) : idx;
                const displayName = formatChapterName(chapterName);
                const chapterNumber = idx + 1;
                
                return (
                  <Box
                    key={`${chapterId || idx}-${chapterName}`}
                    sx={{
                      padding: { xs: '12px', sm: '14px' },
                      borderRadius: '8px',
                      cursor: 'grab',
                      transition: 'all 0.2s ease',
                      backgroundColor: 'transparent',
                      border: '1px solid #E4EBF6',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      touchAction: 'none',
                      '&:hover': {
                        backgroundColor: '#F4F6FB',
                      },
                      '&.sortable-ghost': {
                        opacity: 0.4,
                        backgroundColor: '#E6EDFB',
                      },
                      '&.sortable-chosen': {
                        cursor: 'grabbing',
                        backgroundColor: '#E6EDFB',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      },
                    }}
                  >
                    <Box
                      className="drag-handle"
                      sx={{
                        cursor: 'grab',
                        touchAction: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        pointerEvents: 'auto',
                      }}
                    >
                      <MdDragIndicator 
                        className="drag-handle"
                        style={{ 
                          color: '#6E89AF', 
                          fontSize: '20px', 
                          cursor: 'grab',
                          pointerEvents: 'none',
                        }} 
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', sm: '15px' },
                        fontWeight: 600,
                        color: '#6E89AF',
                        minWidth: '24px',
                      }}
                    >
                      {chapterNumber}.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', sm: '15px' },
                        fontWeight: 500,
                        color: '#1D1D1D',
                        flex: 1,
                      }}
                    >
                      {displayName}
                    </Typography>
                  </Box>
                );
              })}
            </ReactSortable>
          </DialogContent>
          <DialogActions
            sx={{
              padding: { xs: '12px 16px', sm: '16px 20px' },
              borderTop: '1px solid #E4EBF6',
              gap: '8px',
            }}
          >
            <Button
              onClick={() => {
                setMobileReorderModalOpen(false);
                setReorderedChapters([]);
                setDragIdx(null);
              }}
              sx={{
                textTransform: 'none',
                fontSize: { xs: '13px', sm: '14px' },
                fontWeight: 600,
                color: '#FD2B2B',
                padding: { xs: '6px 16px', sm: '8px 20px' },
                '&:hover': {
                  backgroundColor: '#FFF5F5',
                },
              }}
            >
              <FaRegCircleXmark style={{ fontSize: '12px', marginRight: '6px' }} />
              Cancel
            </Button>
            <Button
              onClick={async () => {
                setIsSavingChapterOrder(true);
                const form_data = new FormData();
                form_data.append('course_name', props.single_view_collection);
                const chapterIds = (reorderedChapters.length > 0 ? reorderedChapters : (props.course_chapters || []))
                  .map(ch => {
                    if (Array.isArray(ch)) {
                      return ch[1];
                    }
                    return ch.id || ch.chapter_id || null;
                  })
                  .filter(id => id !== null);
                
                form_data.append('chapter_ids', JSON.stringify(chapterIds));
                
                try {
                  const response = await axios({
                    method: 'post',
                    url: paths.BACKEND_URL + 'api/influencer/community/reorder_course_chapters',
                    data: form_data,
                    headers: {
                      'Content-type': 'application/json',
                    },
                    withCredentials: true,
                  });
                  
                  if (!response.data.error) {
                    setMobileReorderModalOpen(false);
                    setDragIdx(null);
                    const { otherChapter } = processChapters(props.course_chapters || []);
                    let finalChapters = reorderedChapters.length > 0 ? [...reorderedChapters] : (() => {
                      const { regularChapters } = processChapters(props.course_chapters || []);
                      return regularChapters;
                    })();
                    
                    if (otherChapter) {
                      finalChapters.push(otherChapter);
                    }
                    
                    props.setState({ course_chapters: finalChapters });
                    setReorderedChapters([]);
                  }
                } catch (error) {
                  console.error('Error reordering chapters:', error);
                } finally {
                  setIsSavingChapterOrder(false);
                }
              }}
              disabled={isSavingChapterOrder}
              sx={{
                textTransform: 'none',
                fontSize: { xs: '13px', sm: '14px' },
                fontWeight: 600,
                color: isSavingChapterOrder ? '#ccc' : 'var(--brand-color)',
                padding: { xs: '6px 16px', sm: '8px 20px' },
                '&:hover': {
                  backgroundColor: isSavingChapterOrder ? 'transparent' : '#F4F6FB',
                },
              }}
            >
              <FaRegCircleCheck style={{ fontSize: '12px', marginRight: '6px' }} />
              {isSavingChapterOrder ? t('common.saving') : t('common.save')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Chapter Name Modal */}
        <Modal
          open={editChapterModalOpen}
          onClose={() => {
            if (!isUpdatingChapterName) {
              setEditChapterModalOpen(false);
              setEditingChapterId(null);
              setEditingChapterName('');
              setEditingChapterIndex(null);
            }
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              padding: '24px',
              width: '90%',
              maxWidth: '500px',
              outline: 'none',
            }}
          >
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                marginBottom: '20px',
                color: '#1D1D1D',
              }}
            >
              {t('course.chapter.editTitle')}
            </Typography>
            
            <TextField
              fullWidth
              label={t('course.chapter.label')}
              value={editingChapterName}
              onChange={(e) => {
                if (e.target.value.length <= 200) {
                  setEditingChapterName(e.target.value);
                }
              }}
              inputProps={{ maxLength: 200 }}
              helperText={`${editingChapterName.length}/200 characters`}
              disabled={isUpdatingChapterName}
              sx={{ marginBottom: '20px' }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !isUpdatingChapterName && editingChapterName.trim()) {
                  handleUpdateChapterName();
                }
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button
                onClick={() => {
                  if (!isUpdatingChapterName) {
                    setEditChapterModalOpen(false);
                    setEditingChapterId(null);
                    setEditingChapterName('');
                    setEditingChapterIndex(null);
                  }
                }}
                disabled={isUpdatingChapterName}
                sx={{ color: '#6E89AF' }}
              >
                {t('common.cancel')}
              </Button>
              <Button
                onClick={handleUpdateChapterName}
                disabled={isUpdatingChapterName || !editingChapterName.trim()}
                variant="contained"
                sx={{
                  backgroundColor: 'var(--brand-color)',
                  '&:hover': {
                    backgroundColor: 'var(--brand-color)',
                  },
                  '&:disabled': {
                    backgroundColor: '#9CA3AF',
                  },
                }}
              >
                {isUpdatingChapterName ? <CircularProgress size={20} /> : t('common.save')}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Delete Chapter Modal */}
        <Modal
          open={deleteChapterModalOpen}
          onClose={() => {
            if (!isDeletingChapter) {
              setDeleteChapterModalOpen(false);
              setDeletingChapterId(null);
              setDeletingChapterName('');
            }
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              padding: '24px',
              width: '90%',
              maxWidth: '400px',
              outline: 'none',
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px', color: '#1D1D1D' }}>
              {t('influencer.chapter.deleteChapter', 'Delete Chapter')}
            </Typography>
            <Typography sx={{ fontSize: '14px', color: '#6E89AF', marginBottom: '20px' }}>
              {t('influencer.chapter.deleteChapterConfirm', 'Are you sure you want to delete "{{name}}"? Content in this chapter will be moved to Other.', { name: deletingChapterName })}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button
                onClick={() => {
                  setDeleteChapterModalOpen(false);
                  setDeletingChapterId(null);
                  setDeletingChapterName('');
                }}
                disabled={isDeletingChapter}
                sx={{ color: '#6E89AF' }}
              >
                {t('common.cancel')}
              </Button>
              <Button
                onClick={async () => {
                  if (!deletingChapterId) return;
                  setIsDeletingChapter(true);
                  try {
                    const form_data = new FormData();
                    form_data.append('chapter_id', deletingChapterId);
                    form_data.append('course_name', props.single_view_collection);
                    await axios.post(paths.BACKEND_URL + 'api/influencer/community/delete_course_chapter', form_data, { withCredentials: true });
                    const updatedChapters = (props.course_chapters || []).filter(ch => {
                      const chId = Array.isArray(ch) ? ch[1] : (ch.id || ch.chapter_id || null);
                      return String(chId) !== String(deletingChapterId);
                    });
                    const { regularChapters: remainingRegular, otherChapter: remainingOther } = processChapters(updatedChapters);
                    const nextChapter = remainingRegular.length > 0
                      ? (Array.isArray(remainingRegular[0]) ? remainingRegular[0][0] : remainingRegular[0])
                      : (remainingOther ? '_-_-other_-_-' : '');
                    props.setState && props.setState({ course_chapters: updatedChapters, selected_chapter: nextChapter });
                    // Reload content to reflect chapter changes
                    if (props.newContentSubmit) props.newContentSubmit(null, nextChapter);
                  } catch (error) {
                    console.error('Error deleting chapter:', error);
                  } finally {
                    setIsDeletingChapter(false);
                    setDeleteChapterModalOpen(false);
                    setDeletingChapterId(null);
                    setDeletingChapterName('');
                  }
                }}
                disabled={isDeletingChapter}
                variant="contained"
                sx={{
                  backgroundColor: '#EF4444',
                  '&:hover': { backgroundColor: '#DC2626' },
                  '&:disabled': { backgroundColor: '#9CA3AF' },
                }}
              >
                {isDeletingChapter ? <CircularProgress size={20} /> : t('common.delete', 'Delete')}
              </Button>
            </Box>
          </Box>
        </Modal>

          {/* Mobile Chapter Dropdown - creator course view on mobile */}
          {props.is_me &&
            (props.selected_tab === 'paid_collections' || props.selected_tab === 'courses') &&
            props.single_view_collection !== '' &&
            props.courseLibraryTab !== 'library' &&
            props.isCollectionContentReorder !== true &&
            ((props.windowWidth <= 1100) || (props.windowWidth >= 1280 && props.windowWidth <= 1424)) && (
            <Box
              sx={{
                width: '100%',
                maxWidth: '600px',
                margin: '0 auto 20px auto',
                padding: { xs: '0 12px', sm: '0 20px' },
                minWidth: '0',
                boxSizing: 'border-box',
                marginTop: '0px',
              }}
            >
              <Box sx={{
                backgroundColor: '#fff',
                borderRadius: mobileChaptersExpanded ? '14px' : '30px',
                border: '1px solid #E4EBF6',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                transition: 'border-radius 0.2s',
              }}>
                {/* Collapsed bar */}
                <Box
                  onClick={() => setMobileChaptersExpanded(!mobileChaptersExpanded)}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    padding: '14px 18px', cursor: 'pointer',
                    '&:hover': { backgroundColor: '#F8F9FB' },
                  }}
                >
                  <TbChevronRight style={{
                    fontSize: '18px', color: '#6E89AF',
                    transform: mobileChaptersExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#6E89AF', letterSpacing: '1px', textTransform: 'uppercase' }}>
                    {t('influencer.headers.chapters')}
                  </Typography>
                  {(() => {
                    if (props.selected_chapter && props.selected_chapter !== '' && props.selected_chapter !== '_-_-other_-_-') {
                      return (
                        <Typography sx={{ fontSize: '13px', color: '#1D1D1D', fontWeight: 500 }}>
                          · {formatChapterName(props.selected_chapter)}
                        </Typography>
                      );
                    }
                    if (showCourseExamples && exampleChapters[selectedExampleChapter]) {
                      return (
                        <Typography sx={{ fontSize: '13px', color: '#1D1D1D', fontWeight: 500 }}>
                          · {exampleChapters[selectedExampleChapter].name}
                        </Typography>
                      );
                    }
                    return null;
                  })()}
                  <Box sx={{ flex: 1 }} />
                  <Button
                    size="small"
                    onClick={(e) => { e.stopPropagation(); setAddChapterModalOpen(true); }}
                    sx={{
                      textTransform: 'none', fontSize: '12px', fontWeight: 600, color: 'var(--brand-color)',
                      minWidth: 'auto', padding: '4px 10px', borderRadius: '6px',
                      backgroundColor: '#EDF0F7',
                      '&:hover': { backgroundColor: '#DDE4F8' },
                    }}
                  >
                    <TbPlus style={{ fontSize: '14px', marginRight: '4px' }} />
                    {t('influencer.actions.chapter', 'Chapter')}
                  </Button>
                </Box>

                {/* Expanded chapter list */}
                {mobileChaptersExpanded && (
                  <Box sx={{ padding: '0 16px 16px 16px' }}>
                    {(() => {
                      const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
                      if (regularChapters.length === 0 && !otherChapter) {
                        if (showCourseExamples) {
                          return (
                            <ReactSortable
                              list={exampleChapters}
                              setList={setExampleChapters}
                              animation={150}
                              handle=".example-chapter-drag-mob-orig"
                              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                            >
                              {exampleChapters.map((ch, idx) => (
                                <Box
                                  key={ch.id}
                                  onClick={() => setSelectedExampleChapterId(ch.id)}
                                  sx={{
                                    padding: '4px 12px', borderRadius: '16px', cursor: 'pointer',
                                    transition: 'all 0.15s ease',
                                    backgroundColor: '#fff',
                                    border: selectedExampleChapter === idx ? '1.5px solid var(--brand-color)' : '1.5px solid #E4EBF6',
                                    '&:hover': { backgroundColor: '#F8F9FB' },
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Box className="example-chapter-drag-mob-orig" sx={{
                                      cursor: 'grab', display: 'flex', alignItems: 'center',
                                    }}>
                                      <MdDragIndicator style={{ color: '#9CA3AF', fontSize: '16px' }} />
                                    </Box>
                                    <Box sx={{
                                      width: 24, height: 24, borderRadius: '50%',
                                      backgroundColor: selectedExampleChapter === idx ? '#DDE4F8' : '#EDF0F7',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                      <Typography sx={{ fontSize: '12px', fontWeight: 700, color: selectedExampleChapter === idx ? 'var(--brand-color)' : '#6E89AF' }}>
                                        {idx + 1}
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: '13px', fontWeight: selectedExampleChapter === idx ? 600 : 500, color: '#1D1D1D', flex: 1 }}>
                                      {ch.name}
                                    </Typography>
                                    <span style={{
                                      fontSize: '9px', fontWeight: 700, color: '#fff', backgroundColor: '#F59E0B',
                                      padding: '1px 6px', borderRadius: '4px', textTransform: 'uppercase', flexShrink: 0,
                                    }}>
                                      {t('community.library.exampleBadge', 'EXAMPLE')}
                                    </span>
                                  </Box>
                                  {(() => {
                                    const cc = chapterCompletion[ch.id];
                                    if (!cc) return null;
                                    const rate = cc.completion_rate ?? 0;
                                    const completed = cc.completed ?? 0;
                                    const enrolled = cc.enrolled ?? totalEnrolled ?? 0;
                                    return (
                                      <Box sx={{ px: '4px', pb: '6px', pt: '4px' }}>
                                        <Box sx={{ height: '5px', backgroundColor: '#E4EBF6', borderRadius: '3px', overflow: 'hidden', width: '100%' }}>
                                          <Box sx={{ width: `${rate}%`, height: '100%', backgroundColor: rate === 100 ? '#43A047' : 'var(--brand-color)', borderRadius: '3px', transition: 'width 0.3s ease', minWidth: rate > 0 ? '4px' : '0px' }} />
                                        </Box>
                                        <Typography sx={{ fontSize: '10px', color: '#9CA3AF', mt: '3px', textAlign: 'center' }}>
                                          {t('progress.usersCompleted', { completions: completed, enrolled })}
                                        </Typography>
                                      </Box>
                                    );
                                  })()}
                                </Box>
                              ))}
                            </ReactSortable>
                          );
                        }
                        return (
                          <Typography sx={{ fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', textAlign: 'center', padding: '8px 0' }}>
                            {t('influencer.chapters.notVisibleToUsers', 'Chapters are not visible to your customers until you add one.')}
                          </Typography>
                        );
                      }

                      const renderMobileChapterItem = (chapter, index, { isDraggable = false } = {}) => {
                        const chapterName = Array.isArray(chapter) ? chapter[0] : chapter;
                        const displayName = formatChapterName(chapterName);
                        const isSelected = props.selected_chapter === chapterName || (props.selected_chapter === 'Other' && chapterName === '_-_-other_-_-');
                        const isOther = chapterName === '_-_-other_-_-';
                        const chapterNumber = isOther ? null : index + 1;
                        return (
                          <Box
                            key={chapterName + '-mob-' + index}
                            onClick={() => {
                              props.handleCollectionTabChange(null, props.single_view_collection, props.selected_tab, null, null, null, chapterName);
                            }}
                            sx={{
                              padding: '6px 12px',
                              borderRadius: '16px',
                              cursor: 'pointer',
                              transition: 'all 0.15s ease',
                              backgroundColor: '#fff',
                              border: isSelected ? '1.5px solid var(--brand-color)' : '1.5px solid #E4EBF6',
                              '&:hover': { backgroundColor: '#F8F9FB' },
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {isDraggable && props.is_me && !isOther && (
                              <Box className="chapter-drag-handle-mobile" sx={{ cursor: 'grab', display: 'flex', alignItems: 'center', flexShrink: 0, color: '#C4C9D4', '&:hover': { color: '#6E89AF' } }}>
                                <MdDragIndicator style={{ fontSize: '18px' }} />
                              </Box>
                            )}
                            {chapterNumber && (
                              <Box sx={{
                                width: 32, height: 32, borderRadius: '50%',
                                backgroundColor: isSelected ? '#DDE4F8' : '#EDF0F7',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                              }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: 700, color: isSelected ? 'var(--brand-color)' : '#6E89AF' }}>
                                  {chapterNumber}
                                </Typography>
                              </Box>
                            )}
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography sx={{
                                fontSize: '14px', fontWeight: isSelected ? 600 : 500, color: '#1D1D1D',
                                textTransform: 'capitalize', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              }}>
                                {displayName}
                              </Typography>
                            </Box>
                            {props.is_me && !isOther && (<>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const chapterId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                  setEditChapterModalOpen(true);
                                  setEditingChapterId(chapterId);
                                  setEditingChapterName(chapterName);
                                  const fullChapterList = props.course_chapters || [];
                                  const chapterIdx = fullChapterList.findIndex(ch => {
                                    const chName = Array.isArray(ch) ? ch[0] : (typeof ch === 'string' ? ch : (ch.chapter_name || ch.name || ''));
                                    return chName === chapterName;
                                  });
                                  setEditingChapterIndex(chapterIdx >= 0 ? chapterIdx : index);
                                }}
                                sx={{ color: '#9CA3AF', padding: '3px', '&:hover': { backgroundColor: '#E4EBF6', color: '#6E89AF' } }}
                                size="small"
                              >
                                <TbPencil style={{ fontSize: "14px" }} />
                              </IconButton>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const chapterId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                  if (!chapterId) return;
                                  setDeletingChapterId(chapterId);
                                  setDeletingChapterName(chapterName);
                                  setDeleteChapterModalOpen(true);
                                }}
                                sx={{ color: '#9CA3AF', padding: '3px', '&:hover': { backgroundColor: '#FEE2E2', color: '#EF4444' } }}
                                size="small"
                              >
                                <TbTrash style={{ fontSize: "14px" }} />
                              </IconButton>
                            </>)}
                            </Box>
                            {(() => {
                              const chId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                              const isOtherCh = chapterName === '_-_-other_-_-';
                              const cc = isOtherCh ? chapterCompletion['other'] : (chId ? chapterCompletion[String(chId)] : null);
                              if (Object.keys(chapterCompletion).length === 0 || !cc) return null;
                              const rate = cc?.completion_rate ?? 0;
                              const completed = cc?.completed ?? 0;
                              const total = cc?.total ?? 0;
                              const enrolled = cc?.enrolled ?? totalEnrolled ?? 0;
                              const pct = props.is_me ? rate : (total > 0 ? Math.round((completed / total) * 100) : 0);
                              return (
                                <Box sx={{ px: '4px', pb: '4px', pt: '2px' }}>
                                  <Box sx={{ height: '4px', backgroundColor: '#E4EBF6', borderRadius: '2px', overflow: 'hidden', width: '100%' }}>
                                    <Box sx={{ width: `${pct}%`, height: '100%', backgroundColor: pct === 100 ? '#43A047' : 'var(--brand-color)', borderRadius: '2px', transition: 'width 0.3s ease', minWidth: pct > 0 ? '4px' : '0px' }} />
                                  </Box>
                                  <Typography sx={{ fontSize: '10px', color: '#9CA3AF', mt: '2px', textAlign: 'center' }}>
                                    {props.is_me ? t('progress.usersCompleted', { completions: completed, enrolled }) : t('progress.lessonsComplete', { completed, total })}
                                  </Typography>
                                </Box>
                              );
                            })()}
                          </Box>
                        );
                      };

                      // Draggable for creator
                      if (props.is_me && regularChapters.length > 0) {
                        return (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <ReactSortable
                              list={regularChapters.map((ch, i) => ({ id: 'ch-' + (Array.isArray(ch) ? ch[1] : (ch.id || ch.chapter_id || i)), chapter: ch }))}
                              setList={(newList) => {
                                const reordered = newList.map(item => item.chapter);
                                const oldNames = regularChapters.map(ch => Array.isArray(ch) ? ch[0] : (ch.chapter_name || ch.name || '')).join('||');
                                const newNames = reordered.map(ch => Array.isArray(ch) ? ch[0] : (ch.chapter_name || ch.name || '')).join('||');
                                if (oldNames === newNames) return;
                                const { otherChapter: oc } = processChapters(props.course_chapters || []);
                                const prevChapters = [...props.course_chapters];
                                props.setState({ course_chapters: oc ? [...reordered, oc] : [...reordered] });
                                const chapterIds = reordered.map(ch => Array.isArray(ch) ? ch[1] : (ch.id || ch.chapter_id || null)).filter(Boolean);
                                const form_data = new FormData();
                                form_data.append('course_name', props.single_view_collection);
                                form_data.append('chapter_ids', JSON.stringify(chapterIds));
                                axios.post(paths.BACKEND_URL + 'api/influencer/community/reorder_course_chapters', form_data, { withCredentials: true })
                                  .then(res => {
                                    if (res.data.error) {
                                      props.setState({ course_chapters: prevChapters });
                                    }
                                  }).catch(() => {
                                    props.setState({ course_chapters: prevChapters });
                                  });
                              }}
                              animation={150}
                              handle=".chapter-drag-handle-mobile"
                              style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                            >
                              {regularChapters.map((chapter, index) => renderMobileChapterItem(chapter, index, { isDraggable: true }))}
                            </ReactSortable>
                            {otherChapter && renderMobileChapterItem(otherChapter, regularChapters.length)}
                          </Box>
                        );
                      }

                      // Non-creator: static list
                      const allMobileChapters = [...regularChapters];
                      if (otherChapter && regularChapters.length > 0) allMobileChapters.push(otherChapter);
                      return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          {allMobileChapters.map((chapter, index) => renderMobileChapterItem(chapter, index))}
                        </Box>
                      );
                    })()}
                    {/* Add chapter dashed button - mobile */}
                    <Box
                      onClick={() => { setAddChapterModalOpen(true); }}
                      sx={{
                        marginTop: '8px', padding: '12px', borderRadius: '30px',
                        border: '2px dashed #D1D5DB', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                        cursor: 'pointer', transition: 'all 0.15s',
                        '&:hover': { borderColor: 'var(--brand-color)', backgroundColor: '#F8F9FF' },
                      }}
                    >
                      <TbPlus style={{ fontSize: '16px', color: '#6E89AF' }} />
                      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#6E89AF' }}>
                        {t('influencer.actions.addChapter', 'Add chapter')}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {/* Mobile Add Lesson + Reorder Lessons - below chapter bar */}
          {props.is_me &&
            (props.selected_tab === 'paid_collections' || props.selected_tab === 'courses') &&
            props.single_view_collection !== '' &&
            props.courseLibraryTab !== 'library' &&
            !props.isCollectionContentReorder &&
            ((props.windowWidth <= 1100) || (props.windowWidth >= 1280 && props.windowWidth <= 1424)) && (
            <Box sx={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '8px', sm: '12px' }, flexWrap: 'wrap',
              maxWidth: '600px', margin: '0 auto 16px auto', padding: { xs: '0 12px', sm: '0 20px' },
            }}>
              {!props.isCollectionContentReorder && (
                <Button
                  variant="contained"
                  size="small"
                  disableElevation
                  onClick={() => {
                    const currentCollection = collectionData?.[collectionIndex];
                    if (!currentCollection) return;
                    const form_data = new FormData();
                    form_data.append('course_id', currentCollection.id);
                    axios({
                      method: 'post',
                      url: getBackendUrl() + 'api/influencer/load_course_chapters',
                      data: form_data,
                      headers: { 'Content-type': 'application/json' },
                      withCredentials: true
                    }).then(res => {
                      if (res.data.error) return;
                      props.setState({
                        open_content_upload: true,
                        content_type: 0,
                        uploadContentProductType: 'course',
                        new_chapter_list: res.data.course_chapters,
                        chapter_content_counts: res.data.chapter_content_counts || {},
                        editCourseContentId: '',
                        selectedCourse: [[0, (props.influencer_content_list?.length || 0) + 1, currentCollection.id]],
                        selected_chapter: props.selected_chapter,
                      });
                    });
                  }}
                  sx={{
                    textTransform: 'none', fontSize: '13px', fontWeight: 600, borderRadius: '10px',
                    padding: '8px 16px', backgroundColor: 'var(--brand-color)', height: '38px',
                    '&:hover': { backgroundColor: 'var(--brand-color-hover)' },
                    display: 'flex', alignItems: 'center', gap: 1,
                  }}
                >
                  <TbPlus style={{ fontSize: '16px' }} />
                  <span>{t('collections.noContent.button.course', 'Add Lesson')}</span>
                </Button>
              )}
              {props.isCollectionContentReorder ? (
                <>
                  <Typography
                    onClick={() => {
                      props.setState({ isCollectionContentReorder: false });
                    }}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: '5px',
                      cursor: 'pointer', color: 'var(--brand-color)',
                      textTransform: 'none', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    <FaRegCircleCheck style={{ fontSize: '12px' }} color="var(--brand-color)" />
                    {t('common.save', 'Save')}
                  </Typography>
                  <Typography
                    onClick={() => {
                      props.setState({ isCollectionContentReorder: false });
                    }}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: '5px',
                      cursor: 'pointer', color: '#FD2B2B',
                      textTransform: 'none', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    <FaRegCircleXmark style={{ fontSize: '12px' }} color="#FD2B2B" />
                    {t('common.cancel', 'Cancel')}
                  </Typography>
                </>
              ) : (
                <Typography
                  onClick={() => {
                    props.setState({ isCollectionContentReorder: true });
                  }}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: '5px',
                    cursor: 'pointer', color: '#6E89AF',
                    textTransform: 'none', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  <TbArrowsCross style={{ fontSize: '12px' }} />
                  {t('dashboard.collections.reorderLessons', 'Reorder Lessons')}
                </Typography>
              )}
              {/* Drip Feed button - mobile */}
              {!props.isCollectionContentReorder && (
                <Typography
                  onClick={() => props.setState({ isDripFeedMode: !props.isDripFeedMode, isProgressStatsMode: false, isCollectionContentReorder: false })}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer',
                    color: props.isDripFeedMode ? 'var(--brand-color)' : '#6E89AF',
                    fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  <TbClock style={{ fontSize: '13px' }} />
                  {t('drip.setDripSchedule', 'Drip Feed')}
                </Typography>
              )}
            </Box>
          )}

          {/* Mobile: Example course content */}
          {showCourseExamples &&
            ((props.windowWidth <= 1100) || (props.windowWidth >= 1280 && props.windowWidth <= 1424)) && (
            props.isCollectionContentReorder ? (
            <Box sx={{ maxWidth: '600px', margin: '0 auto', padding: { xs: '0 12px', sm: '0 20px' } }}>
              <ReactSortable
                list={exampleChapters[selectedExampleChapter]?.lessons || []}
                setList={(newLessons) => {
                  setExampleChapters(prev => prev.map((ch, i) =>
                    i === selectedExampleChapter ? { ...ch, lessons: newLessons } : ch
                  ));
                }}
                animation={150}
                style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}
              >
                {(exampleChapters[selectedExampleChapter]?.lessons || []).map((lesson, index) => (
                  <Box
                    key={lesson.id}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: '15px', padding: '14px 16px',
                      backgroundColor: '#fff', border: '1px solid #E4EBF6',
                      borderRadius: '10px', cursor: 'grab',
                      marginBottom: '10px', marginTop: index === 0 ? '10px' : '0px',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px', width: '90%' }}>
                      <Box sx={{
                        width: '28px', height: '28px', borderRadius: '50%',
                        backgroundColor: '#F5F7FA', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', color: '#6E89AF', fontSize: '14px', fontWeight: 600,
                      }}>
                        {index + 1}
                      </Box>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
                        <p style={{ fontSize: '16px', fontWeight: 600, margin: 0 }}>{lesson.name}</p>
                        <span style={{
                          fontSize: '9px', fontWeight: 700, color: '#fff', backgroundColor: '#F59E0B',
                          padding: '1px 6px', borderRadius: '4px', textTransform: 'uppercase',
                        }}>
                          {t('community.library.exampleBadge', 'EXAMPLE')}
                        </span>
                      </Box>
                    </Box>
                    <div style={{ cursor: 'grab', height: '100%', display: 'flex', alignItems: 'center' }}>
                      <MdDragIndicator style={{ color: '#6E89AF', fontSize: '20px' }} />
                    </div>
                  </Box>
                ))}
              </ReactSortable>
            </Box>
            ) : (
            <Box sx={{ maxWidth: '600px', margin: '0 auto', padding: { xs: '0 12px', sm: '0 20px' }, display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  onClick={dismissCourseExamples}
                  size="small"
                  sx={{
                    textTransform: 'none', fontSize: '12px', fontWeight: 500, color: '#9CA3AF',
                    border: '1px dashed #D1D5DB', borderRadius: '8px', padding: '4px 14px',
                    '&:hover': { backgroundColor: '#F9FAFB', borderColor: '#9CA3AF' },
                  }}
                >
                  <IoClose style={{ fontSize: '14px', marginRight: '4px' }} />
                  {t('course.examples.clearAll', 'Clear all examples')}
                </Button>
              </Box>
              {(exampleChapters[selectedExampleChapter]?.lessons || []).map((lesson, idx) => (
                <Box key={lesson.id} sx={{ position: 'relative' }}>
                  <Box sx={{
                    position: 'absolute', top: '10px', right: '10px', zIndex: 10,
                    backgroundColor: '#F59E0B', color: '#fff', fontSize: '10px', fontWeight: 700,
                    padding: '2px 8px', borderRadius: '4px', textTransform: 'uppercase',
                  }}>
                    {t('community.library.exampleBadge', 'EXAMPLE')}
                  </Box>
                  <Box sx={{ border: '2px dashed #D1D5DB', borderRadius: '12px', overflow: 'hidden' }}>
                    <CreatorContentCard
                      {...lesson}
                      fileUrl={lesson.fileUrl || lesson.file}
                      thumbnailUrl={lesson.thumbnail}
                      time={lesson.added}
                      display_name={exampleDisplayName}
                      username={exampleInfluencerName}
                      user_icon={props.influencer_icon || ''}
                      current_user={props.current_user}
                      current_user_icon={props.current_user_icon}
                      is_me={true}
                      windowWidth={props.windowWidth}
                      currency={props.currency}
                      setState={props.setState}
                      designProperties={props.designProperties}
                      content_completion_stats={contentCompletion}
                      total_enrolled={totalEnrolled}
                      progress_tracking_enabled={true}
                      loadFileUrl={() => {}}
                      loadPreviewFileUrl={() => {}}
                      setFileUrl={() => {}}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
            )
          )}

        {(props.windowWidth >= 900 ||
          (isViewingSpecificCourseOriginal &&
            (props.selected_tab === "courses" ||
              props.selected_tab === "paid_collections" ||
              props.selected_tab === "collections") &&
            props.single_view_collection !== "" &&
            collectionData.length > 0 &&
            !props.contentIsLoading)) ? (
          // COLLECTIONS ABOVE 900PX (or course content on mobile)
          <Grid
            id="content_container"
            container
            sx={{ minHeight: '50vh', display: props.courseLibraryTab === 'library' ? 'none' : undefined }}
          >
            {props.selected_tab === "scheduled" ||
            props.selected_tab === "saved" ||
            props.selected_tab === "saved_sub_posts" ||
            props.selected_tab === "saved_paid_posts" ||
            props.selected_tab === "live now" ||
            (props.selected_tab === "sub_collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "sub_collections" && props.is_me === false) ||
            (props.selected_tab === "sub_collections" &&
              collectionData.length > 0 &&
              props.contentIsLoading === false) ||
            (props.selected_tab === "paid_collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "paid_collections" && props.is_me === false) ||
            (props.selected_tab === "paid_collections" &&
              collectionData.length > 0 &&
              props.contentIsLoading === false) ||
            (props.selected_tab === "collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "collections" && props.is_me === false) ||
            (props.selected_tab === "collections" && collectionData.length > 0 && props.contentIsLoading === false) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && props.is_me === false) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && collectionData.length > 0 && props.contentIsLoading === false) ||
            (props.selected_tab === "sub_posts" && contentData.length > 0) ||
            (props.selected_tab === "sub_posts" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "sub_posts" && contentData.length === 0 && contentFiltered) ||
            (props.selected_tab === "paid_posts" && contentData.length > 0) ||
            (props.selected_tab === "paid_posts" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "paid_posts" && contentData.length === 0 && contentFiltered) ||
            (props.selected_tab === "digital_products" && contentData.length > 0) ||
            (props.selected_tab === "digital_products" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "urls" && contentData.length > 0)
            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length > 0) ||
            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length === 0 && props.is_me === false) ||
            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length === 0 && contentFiltered) 
            ? (
              <Grid xs={12} container justifyContent={"center"} alignItems={(props.selected_tab === "urls" || props.selected_tab === "courses" || props.selected_tab === "paid_collections") ? "baseline" : "center"} sx={{
                marginTop: (() => {
                  // Check if mobile chapter bar is active for users
                  const mobileChapterBarActive = props.selected_tab === "paid_collections" &&
                    props.single_view_collection !== "" &&
                    props.course_chapters &&
                    props.course_chapters.length > 0 &&
                    props.is_me === false &&
                    props.windowWidth <= 1100 &&
                    props.isCollectionContentReorder !== true &&
                    !(collectionData && collectionData[collectionIndex] && isCollectionAccessBlocked(collectionData[collectionIndex], true)) &&
                    (() => {
                      const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
                      const hasOnlyOther = regularChapters.length === 0 && otherChapter !== null;
                      return !hasOnlyOther;
                    })();
                  
                  // If mobile chapter bar is active, remove the margin
                  if (mobileChapterBarActive) {
                    return '0px';
                  }
                  
                  // Otherwise, apply the original logic
                  return (props.pageLayoutType === 'storefront' && (props.is_me === false || props.current_page_view === 'preview')) ? '100px' : '0px';
                })(),
              }}>
                {(props.single_view_collection !== "" &&
                  (props.selected_tab === "sub_collections" ||
                    props.selected_tab === "paid_collections" ||
                    props.selected_tab === "collections")) ||
                props.selected_tab === "sub_posts" ||
                props.selected_tab === "paid_posts" ||
                props.selected_tab === "digital_products" ||
                ((props.selected_tab === "paid_collections" ||
                  props.selected_tab === "collections" ||
                  props.selected_tab === "courses") &&
                  props.single_view_collection !== "") ||
                props.selected_tab === "urls" ? (
                  (props.selected_tab === "paid_collections" || props.selected_tab === "courses") &&
                  props.single_view_collection !== "" &&
                  ((props.course_chapters &&
                  props.course_chapters.length > 0) ||
                  (props.is_me && (props.selected_tab === "paid_collections" || props.selected_tab === "courses"))) &&
                  props.windowWidth > 900 &&
                  // Don't show chapter sidebar if content reordering, drip feed, or progress stats is active
                  props.isCollectionContentReorder !== true &&
                  !isDripOrStatsMode &&
                  // Don't show chapter sidebar if locked CoursePreview is showing
                  !(collectionData && collectionData[collectionIndex] && isCollectionAccessBlocked(collectionData[collectionIndex], true)) &&
                  (() => {
                    // Don't show chapter list if there are only "Other" chapters (unless creator)
                    const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
                    const hasOnlyOther = regularChapters.length === 0 && otherChapter !== null;
                    return !hasOnlyOther || props.is_me;
                  })() ? (
                    <Box sx={{ position: 'relative', width: '100%' }}>
                      {/* Chapter List Sidebar - Positioned absolutely to not affect content centering */}
                      <Box
                        sx={{
                          display: ((props.is_me === true && (props.windowWidth <= 1100 || (props.windowWidth >= 1280 && props.windowWidth <= 1424)))
                          || (props.is_me === false && props.windowWidth <= 1100)) ? 'none' : 'block',
                          position: 'absolute',
                          left: '0',
                          top: '0px',
                          width: '25%',
                          maxWidth: '320px',
                          height: 'fit-content',
                          maxHeight: 'calc(100vh - 100px)',
                          overflowY: 'auto',
                          paddingRight: '20px',
                          zIndex: 1,
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: '#fff',
                            borderRadius: '14px',
                            border: '1px solid #E4EBF6',
                            padding: '24px 20px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            position: 'sticky',
                            top: '80px',
                          }}
                        >
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#6E89AF', letterSpacing: '1px', textTransform: 'uppercase' }}>
                              {t('influencer.headers.chapters')}
                            </Typography>
                            {props.is_me && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setAddChapterModalOpen(true)}
                                sx={{
                                  minWidth: 0, padding: '2px 10px', fontSize: '12px', fontWeight: 600,
                                  borderRadius: '8px', textTransform: 'none',
                                  color: 'var(--brand-color)', borderColor: 'var(--brand-color)',
                                  '&:hover': { backgroundColor: '#F4F6FB', borderColor: 'var(--brand-color)' },
                                }}
                              >
                                <TbPlus style={{ fontSize: '14px', marginRight: '4px' }} />
                                {t('influencer.actions.chapter', 'Chapter')}
                              </Button>
                            )}
                          </Box>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {(() => {
                              const { regularChapters, otherChapter } = processChapters(props.course_chapters || []);
                              const allChapters = [...regularChapters];
                              if (otherChapter) allChapters.push(otherChapter);

                              if (allChapters.length === 0 && props.is_me) {
                                if (showCourseExamples) {
                                  return (
                                    <ReactSortable
                                      list={exampleChapters}
                                      setList={setExampleChapters}
                                      animation={150}
                                      handle=".example-chapter-drag"
                                      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                                    >
                                    {exampleChapters.map((ch, idx) => (
                                    <Box
                                      key={ch.id}
                                      onClick={() => setSelectedExampleChapterId(ch.id)}
                                      sx={{
                                        padding: '4px 12px', borderRadius: '16px', cursor: 'pointer',
                                        transition: 'all 0.15s ease',
                                        backgroundColor: '#fff',
                                        border: selectedExampleChapter === idx ? '1.5px solid var(--brand-color)' : '1.5px solid #E4EBF6',
                                        '&:hover': { backgroundColor: '#F8F9FB' },
                                      }}
                                    >
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <Box className="example-chapter-drag" sx={{
                                          cursor: 'grab', display: 'flex', alignItems: 'center',
                                        }}>
                                          <MdDragIndicator style={{ color: '#9CA3AF', fontSize: '16px' }} />
                                        </Box>
                                        <Box sx={{
                                          width: 24, height: 24, borderRadius: '50%',
                                          backgroundColor: selectedExampleChapter === idx ? '#DDE4F8' : '#EDF0F7',
                                          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                        }}>
                                          <Typography sx={{ fontSize: '12px', fontWeight: 700, color: selectedExampleChapter === idx ? 'var(--brand-color)' : '#6E89AF' }}>
                                            {idx + 1}
                                          </Typography>
                                        </Box>
                                        <Typography sx={{ fontSize: '13px', fontWeight: selectedExampleChapter === idx ? 600 : 500, color: '#1D1D1D', flex: 1 }}>
                                          {ch.name}
                                        </Typography>
                                        <span style={{
                                          fontSize: '9px', fontWeight: 700, color: '#fff', backgroundColor: '#F59E0B',
                                          padding: '1px 6px', borderRadius: '4px', textTransform: 'uppercase', flexShrink: 0,
                                        }}>
                                          {t('community.library.exampleBadge', 'EXAMPLE')}
                                        </span>
                                      </Box>
                                      {(() => {
                                        const cc = chapterCompletion[ch.id];
                                        if (!cc) return null;
                                        const rate = cc.completion_rate ?? 0;
                                        const completed = cc.completed ?? 0;
                                        const enrolled = cc.enrolled ?? totalEnrolled ?? 0;
                                        return (
                                          <Box sx={{ px: '4px', pb: '6px', pt: '4px' }}>
                                            <Box sx={{ height: '5px', backgroundColor: '#E4EBF6', borderRadius: '3px', overflow: 'hidden', width: '100%' }}>
                                              <Box sx={{ width: `${rate}%`, height: '100%', backgroundColor: rate === 100 ? '#43A047' : 'var(--brand-color)', borderRadius: '3px', transition: 'width 0.3s ease', minWidth: rate > 0 ? '4px' : '0px' }} />
                                            </Box>
                                            <Typography sx={{ fontSize: '10px', color: '#9CA3AF', mt: '3px', textAlign: 'center' }}>
                                              {t('progress.usersCompleted', { completions: completed, enrolled })}
                                            </Typography>
                                          </Box>
                                        );
                                      })()}
                                    </Box>
                                    ))}
                                    </ReactSortable>
                                  );
                                }
                                return (
                                  <Typography sx={{ fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', textAlign: 'center', padding: '8px 0' }}>
                                    {t('influencer.chapters.notVisibleToUsers', 'Chapters are not visible to your customers until you add one.')}
                                  </Typography>
                                );
                              }

                              const renderChapterCard = (chapter, index) => {
                                const chapterName = Array.isArray(chapter) ? chapter[0] : chapter;
                                const displayName = formatChapterName(chapterName);
                                const isSelected = props.selected_chapter === chapterName || (props.selected_chapter === 'Other' && chapterName === '_-_-other_-_-');
                                const isOther = chapterName === '_-_-other_-_-';
                                const chapterNumber = isOther ? null : index + 1;

                                return (
                                  <Box
                                    key={`chapter-${Array.isArray(chapter) ? chapter[1] : index}-${chapterName}`}
                                    onClick={() => {
                                      props.handleCollectionTabChange(null, props.single_view_collection, props.selected_tab, null, null, null, chapterName);
                                    }}
                                    sx={{
                                      padding: '8px 12px',
                                      borderRadius: '12px',
                                      cursor: 'pointer',
                                      transition: 'all 0.15s ease',
                                      backgroundColor: isSelected ? '#FAFBFF' : '#fff',
                                      border: isSelected ? '1.5px solid var(--brand-color)' : '1.5px solid #E4EBF6',
                                      '&:hover': { backgroundColor: '#F8F9FB' },
                                      '&.sortable-ghost': { opacity: 0.4, backgroundColor: '#E6EDFB' },
                                      '&.sortable-chosen': { cursor: 'grabbing', backgroundColor: '#E6EDFB', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {props.is_me && !isOther && (
                                      <Box className="chapter-sidebar-drag" sx={{ cursor: 'grab', display: 'flex', alignItems: 'center', flexShrink: 0, touchAction: 'none' }}>
                                        <MdDragIndicator style={{ color: '#9CA3AF', fontSize: '16px', pointerEvents: 'none' }} />
                                      </Box>
                                    )}
                                    {chapterNumber && (
                                      <Box sx={{
                                        width: 24, height: 24, borderRadius: '50%',
                                        backgroundColor: isSelected ? '#DDE4F8' : '#EDF0F7',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                      }}>
                                        <Typography sx={{ fontSize: '12px', fontWeight: 700, color: isSelected ? 'var(--brand-color)' : '#6E89AF' }}>
                                          {chapterNumber}
                                        </Typography>
                                      </Box>
                                    )}
                                    <Typography
                                      sx={{
                                        fontSize: '13px',
                                        fontWeight: isSelected ? 600 : 500,
                                        color: '#1D1D1D',
                                        flex: 1,
                                        textTransform: 'capitalize',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {displayName}
                                    </Typography>
                                    {props.is_me && !isOther && (<>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const chapterId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                          setEditChapterModalOpen(true);
                                          setEditingChapterId(chapterId);
                                          setEditingChapterName(chapterName);
                                          const fullChapterList = props.course_chapters || [];
                                          const chapterIdx = fullChapterList.findIndex(ch => {
                                            const chName = Array.isArray(ch) ? ch[0] : (typeof ch === 'string' ? ch : (ch.chapter_name || ch.name || ''));
                                            return chName === chapterName;
                                          });
                                          setEditingChapterIndex(chapterIdx >= 0 ? chapterIdx : index);
                                        }}
                                        sx={{ color: '#9CA3AF', padding: '3px', '&:hover': { backgroundColor: '#E4EBF6', color: '#6E89AF' } }}
                                        size="small"
                                      >
                                        <TbPencil style={{ fontSize: "14px" }} />
                                      </IconButton>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const chapterId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                          if (!chapterId) return;
                                          setDeletingChapterId(chapterId);
                                          setDeletingChapterName(chapterName);
                                          setDeleteChapterModalOpen(true);
                                        }}
                                        sx={{ color: '#9CA3AF', padding: '3px', '&:hover': { backgroundColor: '#FEE2E2', color: '#EF4444' } }}
                                        size="small"
                                      >
                                        <TbTrash style={{ fontSize: "14px" }} />
                                      </IconButton>
                                    </>)}
                                    </Box>
                                    {(() => {
                                      const chId = Array.isArray(chapter) ? chapter[1] : (chapter.id || chapter.chapter_id || null);
                                      const isOtherCh = chapterName === '_-_-other_-_-';
                                      const cc = isOtherCh ? chapterCompletion['other'] : (chId ? chapterCompletion[String(chId)] : null);
                                      if (Object.keys(chapterCompletion).length === 0) return null;
                                      const rate = cc?.completion_rate ?? 0;
                                      const completed = cc?.completed ?? 0;
                                      const total = cc?.total ?? 0;
                                      const enrolled = cc?.enrolled ?? totalEnrolled ?? 0;
                                      const pct = props.is_me ? rate : (total > 0 ? Math.round((completed / total) * 100) : 0);
                                      return (
                                        <Box sx={{ px: '2px', pb: '2px', pt: '6px' }}>
                                          <Box sx={{ height: '3px', backgroundColor: '#E8ECF3', borderRadius: '2px', overflow: 'hidden', width: '100%' }}>
                                            <Box sx={{ width: `${pct}%`, height: '100%', backgroundColor: pct === 100 ? '#43A047' : 'var(--brand-color)', borderRadius: '2px', transition: 'width 0.3s ease', minWidth: pct > 0 ? '3px' : '0px' }} />
                                          </Box>
                                          <Typography sx={{ fontSize: '9px', color: '#B0B8C9', mt: '2px', textAlign: 'right', fontWeight: 500 }}>
                                            {props.is_me ? t('progress.usersCompleted', { completions: completed, enrolled }) : t('progress.lessonsComplete', { completed, total })}
                                          </Typography>
                                        </Box>
                                      );
                                    })()}
                                  </Box>
                                );
                              };

                              if (props.is_me && regularChapters.length > 0) {
                                return (
                                  <>
                                    <ReactSortable
                                      list={regularChapters.map((ch, i) => ({ id: 'ch-' + (Array.isArray(ch) ? ch[1] : (ch.id || ch.chapter_id || i)), chapter: ch }))}
                                      setList={(newList) => {
                                        const reordered = newList.map(item => item.chapter);
                                        const oldNames = regularChapters.map(ch => Array.isArray(ch) ? ch[0] : (ch.chapter_name || ch.name || '')).join('||');
                                        const newNames = reordered.map(ch => Array.isArray(ch) ? ch[0] : (ch.chapter_name || ch.name || '')).join('||');
                                        if (oldNames === newNames) return;
                                        const { otherChapter: oc } = processChapters(props.course_chapters || []);
                                        const prevChapters = [...props.course_chapters];
                                        props.setState({ course_chapters: oc ? [...reordered, oc] : [...reordered] });
                                        const chapterIds = reordered.map(ch => Array.isArray(ch) ? ch[1] : (ch.id || ch.chapter_id || null)).filter(Boolean);
                                        const form_data = new FormData();
                                        form_data.append('course_name', props.single_view_collection);
                                        form_data.append('chapter_ids', JSON.stringify(chapterIds));
                                        axios.post(paths.BACKEND_URL + 'api/influencer/community/reorder_course_chapters', form_data, { withCredentials: true })
                                          .then(res => {
                                            if (res.data.error) {
                                              props.setState({ course_chapters: prevChapters });
                                            }
                                          }).catch(() => {
                                            props.setState({ course_chapters: prevChapters });
                                          });
                                      }}
                                      animation={150}
                                      handle=".chapter-sidebar-drag"
                                      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                                    >
                                      {regularChapters.map((chapter, index) => renderChapterCard(chapter, index))}
                                    </ReactSortable>
                                    {otherChapter && renderChapterCard(otherChapter, regularChapters.length)}
                                  </>
                                );
                              }

                              return allChapters.map((chapter, index) => renderChapterCard(chapter, index));
                            })()}
                          </Box>
                          {props.is_me && (
                            <Box
                              onClick={() => setAddChapterModalOpen(true)}
                              sx={{
                                marginTop: '12px', padding: '10px', borderRadius: '30px',
                                border: '2px dashed #D1D5DB', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                                cursor: 'pointer', transition: 'all 0.15s',
                                '&:hover': { borderColor: 'var(--brand-color)', backgroundColor: '#F8F9FF' },
                              }}
                            >
                              <TbPlus style={{ fontSize: '14px', color: '#6E89AF' }} />
                              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#6E89AF' }}>
                                {t('influencer.actions.addChapter', 'Add Chapter')}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>

                      {/* Main Content Area - Offset to avoid sidebar overlap (creator only) */}
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '100%',
                          paddingLeft: '0px',
                          ...(props.is_me && props.selected_tab === 'paid_collections' && (!props.influencer_content_list || props.influencer_content_list.length === 0) ? { alignSelf: 'stretch' } : {}),
                        }}
                      >
                        {showCourseExamples && props.is_me && (!props.influencer_content_list || props.influencer_content_list.length === 0) && (!props.selected_chapter || props.selected_chapter === '') ? (
                          props.isCollectionContentReorder ? (
                            /* Reorder mode for example lessons */
                            <Box sx={{ width: '100%', maxWidth: '600px' }}>
                              <ReactSortable
                                list={exampleChapters[selectedExampleChapter]?.lessons || []}
                                setList={(newLessons) => {
                                  setExampleChapters(prev => prev.map((ch, i) =>
                                    i === selectedExampleChapter ? { ...ch, lessons: newLessons } : ch
                                  ));
                                }}
                                animation={150}
                                style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}
                              >
                                {(exampleChapters[selectedExampleChapter]?.lessons || []).map((lesson, index) => (
                                  <Box
                                    key={lesson.id}
                                    sx={{
                                      display: 'flex', alignItems: 'center', gap: '15px', padding: '14px 16px',
                                      backgroundColor: '#fff', border: '1px solid #E4EBF6',
                                      borderRadius: '10px', cursor: 'grab',
                                      marginBottom: '10px', marginTop: index === 0 ? '10px' : '0px',
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px', width: '90%' }}>
                                      <Box sx={{
                                        width: '28px', height: '28px', borderRadius: '50%',
                                        backgroundColor: '#F5F7FA', display: 'flex', alignItems: 'center',
                                        justifyContent: 'center', color: '#6E89AF', fontSize: '14px', fontWeight: 600,
                                      }}>
                                        {index + 1}
                                      </Box>
                                      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
                                        <p style={{ fontSize: '16px', fontWeight: 600, margin: 0 }}>{lesson.name}</p>
                                        <span style={{
                                          fontSize: '9px', fontWeight: 700, color: '#fff', backgroundColor: '#F59E0B',
                                          padding: '1px 6px', borderRadius: '4px', textTransform: 'uppercase',
                                        }}>
                                          {t('community.library.exampleBadge', 'EXAMPLE')}
                                        </span>
                                      </Box>
                                    </Box>
                                    <div className="drag-handle" style={{ cursor: 'grab', height: '100%', display: 'flex', alignItems: 'center' }}>
                                      <MdDragIndicator style={{ color: '#6E89AF', fontSize: '20px' }} />
                                    </div>
                                  </Box>
                                ))}
                              </ReactSortable>
                            </Box>
                          ) : (
                          /* Example course content - rendered through CreatorContentCard */
                          <Box sx={{ width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {/* Clear examples button */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                              <Button
                                onClick={dismissCourseExamples}
                                size="small"
                                sx={{
                                  textTransform: 'none', fontSize: '12px', fontWeight: 500, color: '#9CA3AF',
                                  border: '1px dashed #D1D5DB', borderRadius: '8px', padding: '4px 14px',
                                  '&:hover': { backgroundColor: '#F9FAFB', borderColor: '#9CA3AF' },
                                }}
                              >
                                <IoClose style={{ fontSize: '14px', marginRight: '4px' }} />
                                {t('course.examples.clearAll', 'Clear all examples')}
                              </Button>
                            </Box>
                            {(exampleChapters[selectedExampleChapter]?.lessons || []).map((lesson, idx) => (
                              <Grid
                                key={lesson.id}
                                item xs={12}
                                style={{
                                  width: props.windowWidth <= 600 ? '100vw' : '600px',
                                  maxWidth: '600px',
                                  display: 'block',
                                  margin: '0px auto',
                                  position: 'relative',
                                }}
                              >
                                <Box sx={{
                                  position: 'absolute', top: '10px', right: '10px', zIndex: 10,
                                  backgroundColor: '#F59E0B', color: '#fff', fontSize: '10px', fontWeight: 700,
                                  padding: '2px 8px', borderRadius: '4px', textTransform: 'uppercase',
                                }}>
                                  {t('community.library.exampleBadge', 'EXAMPLE')}
                                </Box>
                                <Box sx={{ border: '2px dashed #D1D5DB', borderRadius: '12px', overflow: 'hidden' }}>
                                  <CreatorContentCard
                                    {...lesson}
                                    fileUrl={lesson.fileUrl || lesson.file}
                                    thumbnailUrl={lesson.thumbnail}
                                    time={lesson.added}
                                    display_name={exampleDisplayName}
                                    username={exampleInfluencerName}
                                    user_icon={props.influencer_icon || ''}
                                    current_user={props.current_user}
                                    current_user_icon={props.current_user_icon}
                                    is_me={true}
                                    windowWidth={props.windowWidth}
                                    currency={props.currency}
                                    setState={props.setState}
                                    designProperties={props.designProperties}
                                    content_completion_stats={contentCompletion}
                                    total_enrolled={totalEnrolled}
                                    progress_tracking_enabled={true}
                                    loadFileUrl={() => {}}
                                    loadPreviewFileUrl={() => {}}
                                    setFileUrl={() => {}}
                                  />
                                </Box>
                              </Grid>
                            ))}
                          </Box>
                          )
                        ) : (
                          props.is_me && (props.selected_tab === 'paid_collections' || props.selected_tab === 'courses') && (!props.influencer_content_list || props.influencer_content_list.length === 0) && !props.contentIsLoading ? (
                            <Box sx={{ width: '100%', maxWidth: '600px', margin: '20px auto', textAlign: 'center', padding: '40px 20px' }}>
                              <Typography sx={{ fontSize: '14px', color: '#9CA3AF', fontWeight: 500 }}>
                                {props.selected_chapter && props.selected_chapter !== ''
                                  ? t('collections.noContent.emptyChapter', 'This chapter has no content yet. Add lessons to get started.')
                                  : t('collections.noContent.emptyCourse', 'This course has no content yet. Add lessons to get started.')}
                              </Typography>
                            </Box>
                          ) : isDripOrStatsMode ? null : content_block
                        )}
                      </Box>
                      {/* Right column: Add Lesson / Reorder (desktop only, creator only) */}
                      {props.is_me && (props.selected_tab === 'paid_collections' || props.selected_tab === 'courses') && (
                        <Box
                          sx={{
                            display: ((props.is_me === true && (props.windowWidth <= 1100 || (props.windowWidth >= 1280 && props.windowWidth <= 1424)))
                            || (props.is_me === false && props.windowWidth <= 1100) || !props.is_me) ? 'none' : 'flex',
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            zIndex: 1,
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {!props.isCollectionContentReorder && (
                            <Button
                              variant="contained"
                              size="small"
                              disableElevation
                              onClick={() => {
                                const currentCollection = collectionData?.[collectionIndex];
                                if (!currentCollection) return;
                                const form_data = new FormData();
                                form_data.append('course_id', currentCollection.id);
                                axios({
                                  method: 'post',
                                  url: getBackendUrl() + 'api/influencer/load_course_chapters',
                                  data: form_data,
                                  headers: { 'Content-type': 'application/json' },
                                  withCredentials: true
                                }).then(res => {
                                  if (res.data.error) return;
                                  props.setState({
                                    open_content_upload: true,
                                    content_type: 0,
                                    uploadContentProductType: 'course',
                                    new_chapter_list: res.data.course_chapters,
                                    chapter_content_counts: res.data.chapter_content_counts || {},
                                    editCourseContentId: '',
                                    selectedCourse: [[0, (props.influencer_content_list?.length || 0) + 1, currentCollection.id]],
                                    selected_chapter: props.selected_chapter,
                                  });
                                });
                              }}
                              sx={{
                                textTransform: 'none', fontSize: '13px', fontWeight: 600, borderRadius: '10px',
                                padding: '8px 20px', backgroundColor: 'var(--brand-color)', height: '38px',
                                '&:hover': { backgroundColor: 'var(--brand-color-hover)' },
                                display: 'flex', alignItems: 'center', gap: 1,
                              }}
                            >
                              <TbPlus style={{ fontSize: '16px' }} />
                              <span>{t('collections.noContent.button.course', 'Add Lesson')}</span>
                            </Button>
                          )}
                          {props.isCollectionContentReorder ? (
                            <>
                              <Typography
                                onClick={() => props.setState({ isCollectionContentReorder: false })}
                                sx={{
                                  display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer',
                                  color: 'var(--brand-color)', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                                  '&:hover': { textDecoration: 'underline' },
                                }}
                              >
                                <FaRegCircleCheck style={{ fontSize: '12px' }} color="var(--brand-color)" />
                                {t('common.save', 'Save')}
                              </Typography>
                              <Typography
                                onClick={() => props.setState({ isCollectionContentReorder: false })}
                                sx={{
                                  display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer',
                                  color: '#FD2B2B', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                                  '&:hover': { textDecoration: 'underline' },
                                }}
                              >
                                <FaRegCircleXmark style={{ fontSize: '12px' }} color="#FD2B2B" />
                                {t('common.cancel', 'Cancel')}
                              </Typography>
                            </>
                          ) : (
                            <Typography
                              onClick={() => props.setState({ isCollectionContentReorder: true })}
                              sx={{
                                display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer',
                                color: '#6E89AF', fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                                '&:hover': { textDecoration: 'underline' },
                              }}
                            >
                              <TbArrowsCross style={{ fontSize: '12px' }} />
                              {t('dashboard.collections.reorderLessons', 'Reorder Lessons')}
                            </Typography>
                          )}
                          {/* Drip Feed button - desktop */}
                          {!props.isCollectionContentReorder && (
                            <Typography
                              onClick={() => props.setState({ isDripFeedMode: !props.isDripFeedMode, isProgressStatsMode: false, isCollectionContentReorder: false })}
                              sx={{
                                display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer',
                                color: props.isDripFeedMode ? 'var(--brand-color)' : '#6E89AF',
                                fontSize: '13px', fontFamily: 'Roboto', fontWeight: 500,
                                '&:hover': { textDecoration: 'underline' },
                              }}
                            >
                              <TbClock style={{ fontSize: '13px' }} />
                              {t('drip.setDripSchedule', 'Drip Feed')}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Box>
                  ) : (
                  <>
                    {!isLockedCoursePreview && showClassicPostsShareLayoutOriginal && classicPostsShareConfigOriginal?.influencer ? (
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "1360px",
                          margin: "0 auto",
                          position: "relative",
                          // Inside the shell's 720px column there's no room beside the
                          // feed for the absolutely-positioned card below - stack it
                          // underneath instead (outside the shell, unchanged).
                          ...(isShellActive ? { display: "flex", flexDirection: "column", gap: "16px" } : {}),
                        }}
                      >
                        <Box sx={{ display: isDripOrStatsMode ? 'none' : "flex", justifyContent: "center", width: "100%" }}>
                          {content_block}
                        </Box>
                        <Box
                          sx={{
                            position: isShellActive ? "static" : "absolute",
                            top: 0,
                            right: "20px",
                            width: isShellActive ? "100%" : "300px",
                            zIndex: 1,
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            className={props.windowWidth < 1280 ? "content_island_mobile" : "content_island"}
                            style={{
                              backgroundColor: "var(--rebranding-content-background-color)",
                              height: "auto",
                              margin: "0px 0px 25px 0px",
                              padding: "0px 0px 10px 0px",
                            }}
                          >
                            <div style={{ padding: "10px 16px", boxSizing: "border-box" }}>
                              <p style={{ fontSize: "16px" }}><strong>{t('affiliate.shareAndEarn')}</strong></p>
                              <p
                                style={{
                                  width: "100%",
                                  margin: "0px 0px 15px 0px",
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  color: "#6E89AF",
                                }}
                              >
                                Share your affiliate link and earn commission when someone joins.
                              </p>
                              <div style={{ display: "flex" }}>
                                <ShareEarnButton
                                  productType={classicPostsShareConfigOriginal.productType}
                                  productId={classicPostsShareConfigOriginal.productId}
                                  productName={classicPostsShareConfigOriginal.productName}
                                  influencer={classicPostsShareConfigOriginal.influencer}
                                  hasAccess={true}
                                  buttonVariant="full"
                                  size="small"
                                />
                              </div>
                            </div>
                          </Grid>
                        </Box>
                      </Box>
                    ) : (
                      showCourseExamples && props.isCollectionContentReorder && props.windowWidth > 1100 && !(props.windowWidth >= 1280 && props.windowWidth <= 1424) ? (
                        <Box sx={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>
                          <ReactSortable
                            list={exampleChapters[selectedExampleChapter]?.lessons || []}
                            setList={(newLessons) => {
                              setExampleChapters(prev => prev.map((ch, i) =>
                                i === selectedExampleChapter ? { ...ch, lessons: newLessons } : ch
                              ));
                            }}
                            animation={150}
                            style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}
                          >
                            {(exampleChapters[selectedExampleChapter]?.lessons || []).map((lesson, index) => (
                              <Box
                                key={lesson.id}
                                sx={{
                                  display: 'flex', alignItems: 'center', gap: '15px', padding: '14px 16px',
                                  backgroundColor: '#fff', border: '1px solid #E4EBF6',
                                  borderRadius: '10px', cursor: 'grab',
                                  marginBottom: '10px', marginTop: index === 0 ? '10px' : '0px',
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px', width: '90%' }}>
                                  <Box sx={{
                                    width: '28px', height: '28px', borderRadius: '50%',
                                    backgroundColor: '#F5F7FA', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', color: '#6E89AF', fontSize: '14px', fontWeight: 600,
                                  }}>
                                    {index + 1}
                                  </Box>
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
                                    <p style={{ fontSize: '16px', fontWeight: 600, margin: 0 }}>{lesson.name}</p>
                                    <span style={{
                                      fontSize: '9px', fontWeight: 700, color: '#fff', backgroundColor: '#F59E0B',
                                      padding: '1px 6px', borderRadius: '4px', textTransform: 'uppercase',
                                    }}>
                                      {t('community.library.exampleBadge', 'EXAMPLE')}
                                    </span>
                                  </Box>
                                </Box>
                                <div style={{ cursor: 'grab', height: '100%', display: 'flex', alignItems: 'center' }}>
                                  <MdDragIndicator style={{ color: '#6E89AF', fontSize: '20px' }} />
                                </div>
                              </Box>
                            ))}
                          </ReactSortable>
                        </Box>
                      ) : (
                        <>{isDripOrStatsMode ? null : content_block}</>
                      )
                    )}
                  </>
                  )
                ) : null}

                {((((props.selected_tab === 'sub_posts') || (props.selected_tab === 'paid_posts')) && (props.category_filter !== 'all' || props.sort_filter !== 'latest' || props.content_filter !== 'all' || props.tier_filter !== -1)) || (props.category_filter !== "all" ||
                  props.sort_filter !== "latest" ||
                  props.content_filter !== "all")) &&
                !props.contentIsLoading &&
                props.update_inf_scroll === false ? (
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      textAlign: "center",
                      width: "100%",
                      margin: "100px auto 100px auto",
                      color: "#6E89AF",
                    }}
                  >
                    {/* {props.influencer_content_list.length === 0 && props. ? (
                      null
                    ) : ( */}
                      <>
                      <p>{t('content.noMoreContent')}</p>
             
                    <span
                      style={{
                        color: "var(--brand-color)",
                        textDecoration: "underline",
                        cursor: "pointer",
                        marginLeft: "4px",
                      }}
                      onClick={() => {
                        props.setState({
                          category_filter: "all",
                          sort_filter: "latest",
                          content_filter: "all",
                          // ⚠️ NOT -1 while a membership is open. The request below already
                          // sends props.tier_filter, so the page looked right - but blanking
                          // the STATE meant the next infinite-scroll page, which reads
                          // state.tier_filter, appended every tier's posts. State and request
                          // have to agree. On the all-memberships feed the tier IS a filter,
                          // so it still resets there.
                          tier_filter: props.membershipBannerVisible ? props.tier_filter : -1,
                          contentIsLoading: true,
                          inf_scroll_loading: true,
                          influencer_content_list: [],
                        });
                        const form_data = new FormData();
                        form_data.append("influencer_str", props.influencer_info.influencer);
                        form_data.append("category", "all");
                        form_data.append("sort", "latest");
                        form_data.append("content_type", "all");
                        form_data.append("tab", props.selected_tab);
                        form_data.append(
                          "collection",
                          props.single_view_collection === "" ? "" : collectionData[collectionData[collectionIndex]]
                        );
                        form_data.append("post_id", null);
                        form_data.append("page_n", 1);
                        form_data.append("currency", props.currency);
                        // props.tier_filter, not -1 - see the same fix in InfluencerContent:
                        // the tier is the membership being viewed, not a filter to
                        // clear, so blanking it reopened the page to every tier.
                        form_data.append('tier', props.selected_tab === 'sub_posts' ? props.tier_filter : props.selected_tab === 'all' ? props.tier_filter : -1)
                        let backend_url = getBackendUrl();
                        axios({
                          method: "post",
                          url: backend_url + "api/influencer_content_data_tab_change_v8",
                          headers: {
                            "content-type": "application/json",
                          },
                          data: form_data,
                          withCredentials: true,
                        }).then((res) => {
                          let new_influencer_content_list = [...res.data.content_list];
                          if (props.dashboard === true && props.view_type === "user") {
                            if (
                              !(
                                props.single_view_collection === "" &&
                                (props.selected_tab === "sub_collections" ||
                                  props.selected_tab === "paid_collections" ||
                                  props.selected_tab === "collections")
                              )
                            ) {
                              res.data.content_list.map((influencer_content_split, index) => {
                                new_influencer_content_list[index]["current_tier"] = -1;
                              });
                            } else {
                              res.data.content_list.map((influencer_content_split, index) => {
                                influencer_content_split.data.map((influencer_content_split_inner, index2) => {
                                  new_influencer_content_list[index]["data"][index2]["current_tier"] = -1;
                                });
                              });
                            }
                            props.setState({ subpopup_tier_overwrite: -1 });
                            props.setState({ subpopup_tier_async_overwrite: false });
                          } else if (props.dashboard === true && props.view_type === "user-subscribed") {
                            let sub_tier = 0;
                            let sub_async_tier = false;
                            if (
                              (props.subscribe_popup_bronze_active === true) &
                              (props.subscribe_popup_silver_active === true) &
                              (props.subscribe_popup_gold_active === true) &
                              (props.subscribe_popup_async_active === true)
                            ) {
                              sub_tier = 2;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_silver_active &
                              props.subscribe_popup_gold_active
                            ) {
                              sub_tier = 2;
                              sub_async_tier = false;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_silver_active &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 2;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_gold_active &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 3;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_silver_active === true) &
                              props.subscribe_popup_gold_active &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 3;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_silver_active
                            ) {
                              sub_tier = 1;
                              sub_async_tier = false;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_gold_active
                            ) {
                              sub_tier = 1;
                              sub_async_tier = false;
                            } else if (
                              (props.subscribe_popup_silver_active === true) &
                              props.subscribe_popup_gold_active
                            ) {
                              sub_tier = 2;
                              sub_async_tier = false;
                            } else if (
                              (props.subscribe_popup_silver_active === true) &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 2;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_bronze_active === true) &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 1;
                              sub_async_tier = true;
                            } else if (
                              (props.subscribe_popup_gold_active === true) &
                              props.subscribe_popup_async_active
                            ) {
                              sub_tier = 3;
                              sub_async_tier = true;
                            } else if (props.subscribe_popup_bronze_active === true) {
                              sub_tier = 1;
                              sub_async_tier = false;
                            } else if (props.subscribe_popup_silver_active === true) {
                              sub_tier = 2;
                              sub_async_tier = false;
                            } else if (props.subscribe_popup_gold_active === true) {
                              sub_tier = 3;
                              sub_async_tier = false;
                            } else if (props.subscribe_popup_async_active === true) {
                              sub_tier = -1;
                              sub_async_tier = true;
                            }
                            if (
                              !(
                                props.single_view_collection === "" &&
                                (props.selected_tab === "sub_collections" ||
                                  props.selected_tab === "paid_collections" ||
                                  props.selected_tab === "collections")
                              )
                            ) {
                              res.data.content_list.map((influencer_content_split, index) => {
                                new_influencer_content_list[index]["current_tier"] = sub_tier;
                              });
                            } else {
                              res.data.content_list.map((influencer_content_split, index) => {
                                influencer_content_split.data.map((influencer_content_split_inner, index2) => {
                                  new_influencer_content_list[index]["data"][index2]["current_tier"] = sub_tier;
                                });
                              });
                            }
                            props.setState({ subpopup_tier_overwrite: sub_tier });
                            props.setState({ subpopup_tier_async_overwrite: sub_async_tier });
                          }
                          props.setState({
                            refreshing_content_data: false,
                            influencer_content_list: res.data.content_list,
                            contentIsLoading: false,
                            inf_scroll_loading: false,
                            content_list_length: res.data.content_list_length,
                            page_position: res.data.content_list.length,
                            page_n: 1,
                          });
                          if (res.data.content_list.length >= res.data.content_list_length) {
                            props.setState({
                              update_inf_scroll: false,
                            });
                          } else {
                            props.setState({
                              update_inf_scroll: true,
                            });
                          }
                        });
                      }}
                    >
                      Clear Filters
                    </span>
                    </>
                    {/* )
          } */}
                  </p>
                ) : null}
              </Grid>
            ) : (
              <div style={{ zIndex: "10", width: "100%"}}>
                {(props.selected_tab === "sub_posts") && !props.contentIsLoading && !props.refreshing_content_data && (
                  <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px" }}>
                    {/* LIBRARY - DESKTOP */}
                    {props.is_me && (props.my_platform_page !== 'add_content' || props.my_platform_page !== 'edit_content' || props.my_platform_page !== 'add_course' || props.my_platform_page !== 'edit_course') ? (
                      <NoPosts
                        setState={props.setState}
                        my_platform_page={props.my_platform_page}
                        content_type={props.content_type}
                        disabled={false}
                        late_payment={props.late_payment}
                        windowWidth={props.windowWidth}
                        buttonAction={() => {
                          if (props.late_payment) { goToBilling(); return; }
                          props.setState({
                            content_type: 0,
                            my_platform_page: "add_content",
                            from_subscriptions: props.current_page_view === 'subscriptions'
                          });
                          window.scrollTo({ top: 0, behavior: 'instant' });
                        }}
                      />
                    ) : null}
                  </div>
                )}

                {(props.selected_tab === "sub_collections" ||
                  props.selected_tab === "paid_collections" ||
                  props.selected_tab === "collections") &&
                  !props.contentIsLoading &&
                  collectionData.length === 0 &&
                  props.is_me && (
                    <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px" }}>
                      {/* COLLECTIONS - DESKTOP */}
                      <NoCollections
                        setState={props.setState}
                        my_platform_page={props.my_platform_page}
                        content_type={props.content_type}
                        disabled={false}
                        late_payment={props.late_payment}
                        windowWidth={props.windowWidth}
                        buttonAction={() => {
                          if (props.late_payment) { goToBilling(); return; }
                          props.setState({ newPlaylistModal: true })
                        }}
                      />
                    </div>
                  )}

                {props.selected_tab === "membership" && props.is_me && (
                  <div style={{ margin: "0px auto", boxSizing: "border-box" }}>
                    <MembershipOffering
                      setNewTierModal={setNewTierModal}
                      trialLength={props.trialLength}
                      setTrialLength={props.setTrialLength}
                      updateTrialLength={updateTrialLength}
                      openAddNewTier={openAddNewTier}
                      setOfferingError={setOfferingError}
                      offeringError={offeringError}
                      setEditOffering={setEditOffering}
                      setShowInitialSlide={setShowInitialSlide}
                      showInitialSlide={showInitialSlide}
                      editOffering={editOffering}
                      setTiersModal={(value) => {
                        props.setState({ tiersModal: value });
                      }}
                      tiersModal={props.tiersModal}
                      updateFreeActive={updateFreeActive}
                      freeActive={freeActive}
                      bronzeActive={bronzeActive}
                      silverActive={silverActive}
                      goldActive={goldActive}
                      asyncActive={asyncActive}
                      bronzeAnnualActive={bronzeAnnualActive}
                      bronzeMonthlyActive={bronzeMonthlyActive}
                      bronzeTierName={bronzeTierName}
                      bronzePerksText={bronzePerksText}
                      bronzeMonthlyPrice={bronzeMonthlyPrice}
                      bronzeYearlyPrice={bronzeYearlyPrice}
                      silverAnnualActive={silverAnnualActive}
                      silverMonthlyActive={silverMonthlyActive}
                      silverTierName={silverTierName}
                      silverPerksText={silverPerksText}
                      silverMonthlyPrice={silverMonthlyPrice}
                      silverYearlyPrice={silverYearlyPrice}
                      goldAnnualActive={goldAnnualActive}
                      goldMonthlyActive={goldMonthlyActive}
                      goldTierName={goldTierName}
                      goldPerksText={goldPerksText}
                      goldMonthlyPrice={goldMonthlyPrice}
                      goldYearlyPrice={goldYearlyPrice}
                      asyncAnnualActive={asyncAnnualActive}
                      asyncMonthlyActive={asyncMonthlyActive}
                      asyncTierHidden={asyncTierHidden}
                      asyncTierApply={asyncTierApply}
                      asyncTierName={asyncTierName}
                      asyncPerksText={asyncPerksText}
                      asyncMonthlyPrice={asyncMonthlyPrice}
                      asyncYearlyPrice={asyncYearlyPrice}
                      currency={currency}
                      currencySymbol={currencySymbol}
                      currencySymbolPost={currencySymbolPost}
                      openEditTier={openEditTier}
                      handleCloseTiers={props.handleCloseTiers}
                      setOpenOfferingWhatsThis={props.setOpenOfferingWhatsThis}
                      openOfferingWhatsThis={props.openOfferingWhatsThis}
                      asyncTier={asyncTier}
                      setAsyncTier={setAsyncTier}
                      influencerUsername={props.influencerUsername}
                      asyncPrice2Rebill={asyncPrice2Rebill}
                      asyncPrice2Time={asyncPrice2Time}
                      loadTierInfo={loadTierInfo}
                      openPaidDMs={() => setupPaidDMs()}
                    />
                  </div>
                )}

                {props.selected_tab === "membership" || props.selected_tab === "async" ? (
                  <>
                    <Modal
                      open={newTierModal}
                      onClose={() => setNewTierModal(false)}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      disableAutoFocus={true}
                      sx={{
                        // margin: 'auto',
                        backgroundColor: "rgba(0,0,0,0.47)",
                        outline: "0",
                        borderRadius: "5px",
                        overflow: "hidden",
                        // minWidth: '50vw',
                        display: "flex",
                        zIndex: "9999",
                        lineHeight: "25px",
                        width: "100%",
                        minHeight: "100vh",
                        maxHeight: "100vh",
                      }}
                    >
                      <Grid
                        container
                        justifyContent="center"
                        sx={{
                          minHeight: "100vh",
                          display: "flex",
                          width: "100%",
                          margin: "auto",
                          maxHeight: "500px",
                          outline: "none",
                        }}
                      >
                        <SelfServe6AYourOfferingModal
                          current_user={props.current_user}
                          setNewTierModal={setNewTierModal}
                          updatedTierNameInput={updatedTierNameInput}
                          showSlider={showSlider}
                          setUpdatedTierNameInput={setUpdatedTierNameInput}
                          updatedMonthlyInput={updatedMonthlyInput}
                          setUpdatedMonthlyInput={setUpdatedMonthlyInput}
                          setShowInitialSlide={setShowInitialSlide}
                          updatedAnnualInput={updatedAnnualInput}
                          setUpdatedAnnualInput={setUpdatedAnnualInput}
                          setOpenOfferingWhatsThis={props.setOpenOfferingWhatsThis}
                          openOfferingWhatsThis={props.openOfferingWhatsThis}
                          editOffering={editOffering}
                          windowWidth={props.windowWidth}
                          setOfferingError={setOfferingError}
                          currency={currency}
                          currencySymbol={currencySymbol}
                          currencySymbolPost={currencySymbolPost}
                          setTiersModal={(value) => {
                            props.setState({ tiersModal: value });
                          }}
                          tierNum={tierNum}
                          tierName={tierName}
                          setTierName={setTierName}
                          perksText={perksText}
                          perksTextNum={perksTextNum}
                          monthlyPrice={monthlyPrice}
                          yearlyPrice={yearlyPrice}
                          annualActive={annualActive}
                          setMonthlyActive={setMonthlyActive}
                          setAnnualActive={setAnnualActive}
                          monthlyActive={monthlyActive}
                          monthlyPriceStr={monthlyPriceStr}
                          yearlyPriceStr={yearlyPriceStr}
                          setMonthlyPriceError={setMonthlyPriceError}
                          monthlyPriceError={monthlyPriceError}
                          setAnnualPriceError={setYearlyPriceError}
                          yearlyPriceError={yearlyPriceError}
                          setMonthlyPriceStr={setMonthlyPriceStr}
                          setAnnualPriceStr={setYearlyPriceStr}
                          updatePerks={updatePerks}
                          updatePerksRemove={updatePerksRemove}
                          updateTier={updateTier}
                          setMonthlyPrice={setMonthlyPrice}
                          setAnnualPrice={setYearlyPrice}
                          newTierBenefitsModal={newTierBenefitsModal}
                          setNewTierBenefitsModal={setNewTierBenefitsModal}
                          deleteTierModal={deleteTierModal}
                          setDeleteTierModal={setDeleteTierModal}
                          setWhatsThisModal={props.setWhatsThisModal}
                          deleteTier={deleteTier}
                          asyncTier={asyncTier}
                          setAsyncTier={setAsyncTier}
                          price2Rebill={price2Rebill}
                          price2Time={price2Time}
                          setPrice2Rebill={setPrice2Rebill}
                          setPrice2Time={setPrice2Time}
                          tierHidden={tierHidden}
                          tierApply={tierApply}
                          setTierHidden={setTierHidden}
                          setTierApply={setTierApply}
                          bronzeTierName={bronzeTierName}
                          silverTierName={silverTierName}
                          goldTierName={goldTierName}
                          asyncTierName={asyncTierName}
                          nMessages={nMessages}
                          setNMessages={setNMessages}
                        />
                      </Grid>
                    </Modal>

                    <Modal
                      open={props.whatsThisModal}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      disableAutoFocus={true}
                      sx={{
                        // margin: 'auto',
                        backgroundColor: "rgba(0,0,0,0.47)",
                        borderRadius: "5px",
                        overflow: "hidden",
                        minWidth: "50vw",
                        outline: "0",
                        display: "flex",
                        zIndex: "9999",
                        lineHeight: "25px",
                      }}
                    >
                      <Grid
                        container
                        justifyContent="center"
                        sx={{ borderRadius: "5px", margin: "auto", maxWidth: "1400px" }}
                      >
                        <Grid
                          style={{
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "30%",
                            minWidth: "350px",
                            backgroundColor: "white",
                            borderRadius: "10px",
                            height: "40vh",
                            minHeight: "500px",
                          }}
                        >
                          <Grid
                            container
                            sx={{ direction: "row", justifyContent: "center", alignItems: "center", display: "flex" }}
                          >
                            <Grid
                              md={12}
                              xs={12}
                              sx={{
                                marginTop: "10px",
                                direction: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                backgroundColor: "green",
                              }}
                            >
                              Image
                            </Grid>
                            <Grid
                              md={12}
                              xs={12}
                              sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}
                            >
                              <div style={{ textAlign: "center", paddingTop: "0px", marginTop: "0px" }}>
                                <h2>{t('selfServe.examplePopupTip')}</h2>
                              </div>
                            </Grid>
                            <Grid
                              md={12}
                              xs={12}
                              sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}
                            >
                              <div style={{ textAlign: "center", paddingTop: "0px", marginTop: "0px" }}>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus ac velit in odio
                                  suscipit semper. Ut ac cursus nunc.
                                </p>
                              </div>
                            </Grid>

                            <Grid container sx={{ width: "100%", justifyContent: "center", paddingTop: "20px" }}>
                              <BlueButton
                                style={{ paddingLeft: "70px", paddingRight: "70px" }}
                                onClick={() => {
                                  props.setState({ whatsThisModal: false });
                                }}
                              >
                                OK,Got it
                              </BlueButton>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Modal>
                  </>
                ) : null}

                {paidDMsModal ? (
                  <SetupPaidDMs
                    paidDMsModal={true}
                    setPaidDMsModal={setPaidDMsModal}
                    paidDMsActive={paidDMsActive}
                    setPaidDMsActive={setPaidDMsActive}
                    remainingPaidDMsCount={remainingPaidDMsCount}
                    setRemainingPaidDMsCount={setRemainingPaidDMsCount}
                    paidDMsOrderCount={paidDMsOrderCount}
                    setPaidDMsOrderCount={setPaidDMsOrderCount}
                    paidDMsMaximumMessageLength={paidDMsMaximumMessageLength}
                    paidDMsMinimumPrice={paidDMsMinimumPrice}
                    paidDMsMinimumPriceStr={paidDMsMinimumPriceStr}
                    paidDMsActiveSettings={paidDMsActiveSettings}
                    setPaidDMsMaximumMessageLength={setPaidDMsMaximumMessageLength}
                    setPaidDMsMinimumPrice={setPaidDMsMinimumPrice}
                    setPaidDMsMinimumPriceStr={setPaidDMsMinimumPriceStr}
                    setPaidDMsActiveSettings={setPaidDMsActiveSettings}
                    priceOfDMsError={priceOfDMsError}
                    setPriceOfDMsError={setPriceOfDMsError}
                    currency={currency}
                    currencySymbol={currencySymbol}
                    currencySymbolPost={currencySymbolPost}
                    setMaxMessageLength={props.setMaxMessageLength}
                    setState={props.setState}
                    handleTabNavigation={props.handleTabNavigation}
                    current_page_view={props.current_page_view}
                    windowWidth={props.windowWidth}
                    {...props}
                  />
                ) : null}

                {props.selected_tab === "sign_up" && (
                  <div style={{ marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "40px" }}>
                    <LeadCapture
                      activeProductData={props.activeProductData}
                      showLeadCaptureSnackbar={props.showLeadCaptureSnackbar}
                      {...props}
                    />
                  </div>
                )}

                {props.selected_tab === "community" ? (
                  <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px"}}>
                    {props.is_me ? (
                      <>
                        {props.community_is_active ||
                        (props.influencer_bool === true &&
                          (props.view_type === "user-subscribed" ||
                            props.view_type === "user-waitlist" ||
                            props.view_type === "user")) ? (
                          <Community
                            display_name={props.display_name}
                            current_user={props.current_user}
                            current_user_icon={props.current_user_icon}
                            username={props.current_user}
                            influencer_icon={props.influencer_icon}
                            is_me={props.is_me}
                            influencer={props.influencer}
                            influencer_name={props.influencer_name}
                            influencer_tiers={tiers}
                            active_influencer_tiers={activeTiersNoAsync}
                            influencer_info={props.influencer_info}
                            OpenSubscribePopup={props.OpenSubscribePopup}
                            OpenWaitingListPopup={props.OpenWaitingListPopup}
                            CloseSubscribePopup={props.CloseSubscribePopup}
                            CloseWaitingListPopup={props.CloseWaitingListPopup}
                            currency={props.currency}
                            current_tier={props.subscribe_popup_current_tier}
                            post_id={props.post_id}
                            tab_id={props.tab_id}
                            updateCommunityActive={props.updateCommunityActive}
                            view_type={props.view_type}
                            n_page_views={props.n_page_views}
                            connected_stripe_account_id={props.connected_stripe_account_id}
                            setState={props.setState}
                            mobilePreview={props.mobilePreview}
                            {...props}
                          />
                        ) : (
                          // Change to turn on / off
                          <SectionPlaceholder
                            windowWidth={props.windowWidth}
                            title={t('community.welcomeTitle')}
                            tooltipLink={null}
                            description={t('community.welcomeDescription')}
                            buttonText={props.community_is_active ? t('community.disableButton') : t('community.activateButton')}
                            buttonAction={() => {
                              props.handleOpenHiddenTabModal();
                              // props.handleProfileTabChange({},'dashboard')
                            }}
                            buttonTextSecondary={t('common.learnMore')}
                            buttonActionSecondary={() => {
                              window.open(
                                "https://help.withme.so/en/articles/6922173-marketing-101-community-board-best-practices",
                                "_blank"
                              );
                            }}
                            videoSrc={"https://openaccessimages.s3.eu-west-2.amazonaws.com/COMMUNITY+VIDEO+LIV.mp4"}
                            titleicon1={"🤝"}
                            titleicon2={"💬"}
                            titleicon3={"🤗"}
                            title1={t('community.benefit1Title')}
                            title2={t('community.benefit2Title')}
                            title3={t('community.benefit3Title')}
                            description1={t('community.benefit1Description')}
                            description2={t('community.benefit2Description')}
                            description3={t('community.benefit3Description')}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {props.community_is_active ? (
                          <Community
                            display_name={props.display_name}
                            current_user={props.current_user}
                            current_user_icon={props.current_user_icon}
                            influencer_icon={props.influencer_icon}
                            username={props.current_user}
                            influencer_name={props.influencer_name}
                            is_me={props.is_me}
                            influencer={props.influencer}
                            influencer_tiers={tiers}
                            active_influencer_tiers={activeTiers}
                            influencer_info={props.influencer_info}
                            OpenSubscribePopup={props.OpenSubscribePopup}
                            OpenWaitingListPopup={props.OpenWaitingListPopup}
                            CloseSubscribePopup={props.CloseSubscribePopup}
                            CloseWaitingListPopup={props.CloseWaitingListPopup}
                            currency={props.currency}
                            current_tier={props.subscribe_popup_current_tier}
                            post_id={props.post_id}
                            tab_id={props.tab_id}
                            updateCommunityActive={props.updateCommunityActive}
                            view_type={props.view_type}
                            n_page_views={props.n_page_views}
                            connected_stripe_account_id={props.connected_stripe_account_id}
                            setState={props.setState}
                            mobilePreview={props.mobilePreview}
                            {...props}
                          />
                        ) : null}
                      </>
                    )}
                  </div>
                ) : null}

                {props.selected_tab === "async" && props.current_page_view !== 'subscriptions' ? (
                  <div>
                    <Async
                      display_name={props.display_name}
                      current_user={props.current_user}
                      current_user_icon={props.current_user_icon}
                      username={props.current_user}
                      is_me={props.is_me}
                      influencer={props.influencer}
                      asyncActive={props.subscribe_popup_async_active}
                      influencer_tiers={tiers}
                      active_influencer_tiers={activeTiers}
                      influencer_info={props.influencer_info}
                      OpenSubscribePopup={props.OpenSubscribePopup}
                      OpenWaitingListPopup={props.OpenWaitingListPopup}
                      CloseSubscribePopup={props.CloseSubscribePopup}
                      CloseWaitingListPopup={props.CloseWaitingListPopup}
                      currency={props.currency}
                      current_tier={props.subscribe_popup_current_tier}
                      post_id={props.post_id}
                      async_tier_access={props.async_tier_access}
                      selectedMemberTabOverwrite={props.selectedMemberTabOverwrite}
                      top_padding={TOP_CONTENT_PADDING}
                      handleProfileTabChange={props.handleProfileTabChange}
                      asyncAnnualActive={asyncAnnualActive}
                      asyncMonthlyActive={asyncMonthlyActive}
                      asyncTierHidden={asyncTierHidden}
                      asyncTierApply={asyncTierApply}
                      asyncTierName={asyncTierName}
                      asyncPerksText={asyncPerksText}
                      asyncMonthlyPrice={asyncMonthlyPrice}
                      asyncYearlyPrice={asyncYearlyPrice}
                      asyncTier={asyncTier}
                      setAsyncTier={setAsyncTier}
                      loadTierInfo={loadTierInfo}
                      influencerUsername={props.influencerUsername}
                      asyncPrice2Rebill={asyncPrice2Rebill}
                      asyncPrice2Time={asyncPrice2Time}
                      setTiersModal={(value) => {
                        props.setState({ tiersModal: value });
                      }}
                      openAddNewTier={openAddNewTier}
                      openEditTier={openEditTier}
                      async_apply={props.async_apply}
                      setState={props.setState}
                      scroll={props.open_coaching}
                      windowWidth={props.windowWidth}
                      {...props}
                    />
                  </div>
                ) : null}

                {props.selected_tab === "paidDMs" ? (
                  <>
                    <div>
                      <PaidDMs
                        influencer_bool={props.influencer_bool}
                        current_user={props.current_user}
                        display_name={props.display_name}
                        current_user_icon={props.current_user_icon}
                        username={props.current_user}
                        is_me={props.is_me}
                        influencer={props.influencer}
                        influencer_info={props.influencer_info}
                        currency={props.currency}
                        post_id={props.post_id}
                        dm_active={props.dm_active}
                        selectedMemberTabOverwrite={props.selectedMemberTabOverwrite}
                        top_padding={TOP_CONTENT_PADDING}
                        handleProfileTabChange={props.handleProfileTabChange}
                        openPaidDMs={() => setupPaidDMs()}
                        openDMCheckout={props.openDMCheckout}
                        openGiftExtraMessageModal={props.openGiftExtraMessageModal}
                        paidDMsActiveSettings={paidDMsActiveSettings}
                        openCloseUserMessagingModal={props.openCloseUserMessagingModal}
                        updateHasMessage={props.updateHasMessage}
                        paidDMsModal={paidDMsModal}
                        paidDMs_show={props.paidDMs_show}
                        maxMessageLength={props.maxMessageLength}
                        setMaxMessageLength={props.setMaxMessageLength}
                        scroll={props.open_messages}
                        paidDMs_has_message={props.paidDMs_has_message}
                        dmAffiliateEnabled={props.dmAffiliateEnabled}
                        dmSettingsId={props.dmSettingsId}
                        windowWidth={props.windowWidth}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            )}
          </Grid>
        ) : (
          // 0px 20px 0px 6px
          // COLLECTION TITLES BELOW 900PX
          <Grid id="content_container" sx={{ minHeight: '50vh', display: props.courseLibraryTab === 'library' ? 'none' : undefined }} container>
            {props.selected_tab === "scheduled" ||
            props.selected_tab === "saved" ||
            props.selected_tab === "saved_sub_posts" ||
            props.selected_tab === "saved_paid_posts" ||
            props.selected_tab === "live now" ||
            (props.selected_tab === "sub_collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "sub_collections" && props.is_me === false) ||
            (props.selected_tab === "sub_collections" &&
              collectionData.length > 0 &&
              props.contentIsLoading === false) ||
            (props.selected_tab === "paid_collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "paid_collections" && props.is_me === false) ||
            (props.selected_tab === "paid_collections" &&
              collectionData.length > 0 &&
              props.contentIsLoading === false) ||
            (props.selected_tab === "collections" && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "collections" && props.is_me === false) ||
            (props.selected_tab === "collections" && collectionData.length > 0 && props.contentIsLoading === false) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && props.contentIsLoading === true && props.is_me) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && props.is_me === false) ||
            (props.selected_tab === "courses" && isViewingSpecificCourseOriginal && collectionData.length > 0 && props.contentIsLoading === false) ||
            (props.selected_tab === "sub_posts" && contentData.length > 0) ||
            (props.selected_tab === "sub_posts" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "sub_posts" && contentData.length === 0 && contentFiltered) ||
            (props.selected_tab === "paid_posts" && contentData.length > 0) ||
            (props.selected_tab === "paid_posts" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "paid_posts" && contentData.length === 0 && contentFiltered) ||
            (props.selected_tab === "digital_products" && contentData.length > 0) ||
            (props.selected_tab === "digital_products" && contentData.length === 0 && props.is_me === false) ||
            (props.selected_tab === "urls" && contentData.length > 0)

            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length > 0) ||
            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length === 0 && props.is_me === false) ||
            // ((props.selected_tab === "all" || props.selected_tab === "paid_posts") && contentData.length === 0 && contentFiltered) 
            ? (
              <Grid xs={12} container justifyContent={"center"} alignItems={props.selected_tab === "urls" ? "baseline" : "center"}>
                {(props.single_view_collection !== "" &&
                  (props.selected_tab === "sub_collections" ||
                    props.selected_tab === "paid_collections" ||
                    props.selected_tab === "collections")) ||
                props.selected_tab === "sub_posts" ||
                props.selected_tab === "paid_posts" ||
                props.selected_tab === "digital_products" ||
                ((props.selected_tab === "paid_collections" ||
                  props.selected_tab === "collections" ||
                  props.selected_tab === "courses") &&
                  props.single_view_collection !== "") ||
                props.selected_tab === "urls" ? (
                  <>{isDripOrStatsMode ? null : content_block}</>
                ) : null}

                {((((props.selected_tab === 'sub_posts') || (props.selected_tab === 'paid_posts')) && (props.category_filter !== 'all' || props.sort_filter !== 'latest' || props.content_filter !== 'all' || props.tier_filter !== -1)) || (props.category_filter !== "all" ||
                  props.sort_filter !== "latest" ||
                  props.content_filter !== "all")) &&
                !props.contentIsLoading &&
                props.update_inf_scroll === false ? (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: "50px auto 100px auto",
                      textAlign: "center",
                      width: "100%",
                      color: "#6E89AF",
                      display: "flex",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <p
                      style={{
                        width: "90%",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#6E89AF",
                        textAlign: "center",
                        margin: "auto",
                      }}
                    >
                      {/* {props.influencer_content_list.length === 0 ? (
                        null
                      ) : ( */}
                        <>
                        <p>{t('content.noMoreContent')}</p>
                        <span
                        style={{
                          color: "var(--brand-color)",
                          textDecoration: "underline",
                          cursor: "pointer",
                          marginLeft: "4px",
                        }}
                        onClick={() => {
                          props.setState({
                            category_filter: "all",
                            sort_filter: "latest",
                            content_filter: "all",
                            // ⚠️ NOT -1 while a membership is open. The request below already
                          // sends props.tier_filter, so the page looked right - but blanking
                          // the STATE meant the next infinite-scroll page, which reads
                          // state.tier_filter, appended every tier's posts. State and request
                          // have to agree. On the all-memberships feed the tier IS a filter,
                          // so it still resets there.
                          tier_filter: props.membershipBannerVisible ? props.tier_filter : -1,
                            contentIsLoading: true,
                            inf_scroll_loading: true,
                            influencer_content_list: [],
                          });
                          const form_data = new FormData();
                          form_data.append("influencer_str", props.influencer_info.influencer);
                          form_data.append("category", "all");
                          form_data.append("sort", "latest");
                          form_data.append("content_type", "all");
                          form_data.append("tab", props.selected_tab);
                          form_data.append(
                            "collection",
                            props.single_view_collection === "" ? "" : collectionData[collectionIndex]
                          );
                          form_data.append("post_id", null);
                          form_data.append("page_n", 1);
                          form_data.append("currency", props.currency);
                          // props.tier_filter, not -1 - see the same fix in InfluencerContent:
                        // the tier is the membership being viewed, not a filter to
                        // clear, so blanking it reopened the page to every tier.
                        form_data.append('tier', props.selected_tab === 'sub_posts' ? props.tier_filter : props.selected_tab === 'all' ? props.tier_filter : -1)
                          let backend_url = getBackendUrl();
                          axios({
                            method: "post",
                            url: backend_url + "api/influencer_content_data_tab_change_v8",
                            headers: {
                              "content-type": "application/json",
                            },
                            data: form_data,
                            withCredentials: true,
                          }).then((res) => {
                            let new_influencer_content_list = [...res.data.content_list];
                            if (props.dashboard === true && props.view_type === "user") {
                              if (
                                !(
                                  props.single_view_collection === "" &&
                                  (props.selected_tab === "sub_collections" ||
                                    props.selected_tab === "paid_collections" ||
                                    props.selected_tab === "collections")
                                )
                              ) {
                                res.data.content_list.map((influencer_content_split, index) => {
                                  new_influencer_content_list[index]["current_tier"] = -1;
                                });
                              } else {
                                res.data.content_list.map((influencer_content_split, index) => {
                                  influencer_content_split.data.map((influencer_content_split_inner, index2) => {
                                    new_influencer_content_list[index]["data"][index2]["current_tier"] = -1;
                                  });
                                });
                              }
                              props.setState({ subpopup_tier_overwrite: -1 });
                              props.setState({ subpopup_tier_async_overwrite: false });
                            } else if (props.dashboard === true && props.view_type === "user-subscribed") {
                              let sub_tier = 0;
                              let sub_async_tier = false;
                              if (
                                (props.subscribe_popup_bronze_active === true) &
                                (props.subscribe_popup_silver_active === true) &
                                (props.subscribe_popup_gold_active === true) &
                                (props.subscribe_popup_async_active === true)
                              ) {
                                sub_tier = 2;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_silver_active &
                                props.subscribe_popup_gold_active
                              ) {
                                sub_tier = 2;
                                sub_async_tier = false;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_silver_active &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 2;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_gold_active &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 3;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_silver_active === true) &
                                props.subscribe_popup_gold_active &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 3;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_silver_active
                              ) {
                                sub_tier = 1;
                                sub_async_tier = false;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_gold_active
                              ) {
                                sub_tier = 1;
                                sub_async_tier = false;
                              } else if (
                                (props.subscribe_popup_silver_active === true) &
                                props.subscribe_popup_gold_active
                              ) {
                                sub_tier = 2;
                                sub_async_tier = false;
                              } else if (
                                (props.subscribe_popup_silver_active === true) &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 2;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_bronze_active === true) &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 1;
                                sub_async_tier = true;
                              } else if (
                                (props.subscribe_popup_gold_active === true) &
                                props.subscribe_popup_async_active
                              ) {
                                sub_tier = 3;
                                sub_async_tier = true;
                              } else if (props.subscribe_popup_bronze_active === true) {
                                sub_tier = 1;
                                sub_async_tier = false;
                              } else if (props.subscribe_popup_silver_active === true) {
                                sub_tier = 2;
                                sub_async_tier = false;
                              } else if (props.subscribe_popup_gold_active === true) {
                                sub_tier = 3;
                                sub_async_tier = false;
                              } else if (props.subscribe_popup_async_active === true) {
                                sub_tier = -1;
                                sub_async_tier = true;
                              }
                              if (
                                !(
                                  props.single_view_collection === "" &&
                                  (props.selected_tab === "sub_collections" ||
                                    props.selected_tab === "paid_collections" ||
                                    props.selected_tab === "collections")
                                )
                              ) {
                                res.data.content_list.map((influencer_content_split, index) => {
                                  new_influencer_content_list[index]["current_tier"] = sub_tier;
                                });
                              } else {
                                res.data.content_list.map((influencer_content_split, index) => {
                                  influencer_content_split.data.map((influencer_content_split_inner, index2) => {
                                    new_influencer_content_list[index]["data"][index2]["current_tier"] = sub_tier;
                                  });
                                });
                              }
                              props.setState({ subpopup_tier_overwrite: sub_tier });
                              props.setState({ subpopup_tier_async_overwrite: sub_async_tier });
                            }
                            props.setState({
                              refreshing_content_data: false,
                              influencer_content_list: res.data.content_list,
                              contentIsLoading: false,
                              inf_scroll_loading: false,
                              content_list_length: res.data.content_list_length,
                              page_position: res.data.content_list.length,
                              page_n: 1,
                            });
                            if (res.data.content_list.length >= res.data.content_list_length) {
                              props.setState({
                                update_inf_scroll: false,
                              });
                            } else {
                              props.setState({
                                update_inf_scroll: true,
                              });
                            }
                          });
                        }}
                      >
                        Clear Filters
                      </span>
                      </>
                      {/* )} */}
                 
                    </p>
                  </div>
                ) : null}
              </Grid>
            ) : (
              <div
                style={{
                  marginTop: props.selected_tab === "community" && props.windowWidth > 900 ? "30px" : "0px",
                  backgroundColor: 'var(--rebranding-background-color)',
                  zIndex: "10",
                  width: "100%",
                }}
              >
                {(props.selected_tab === "sub_posts" || props.selected_tab === "paid_posts" || props.selected_tab === "urls") && !props.contentIsLoading && (
                  <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px" }}>
                    {/* LIBRARY - DESKTOP */}

                    {props.is_me && (props.my_platform_page != 'add_content' || props.my_platform_page != 'edit_content' || props.my_platform_page != 'add_course' || props.my_platform_page != 'edit_course') ? (
                               <NoPosts
                               setState={props.setState}
                               my_platform_page={props.my_platform_page}
                               content_type={props.content_type}
                               disabled={false}
                               late_payment={props.late_payment}
                               windowWidth={props.windowWidth}
                               buttonAction={() => {
                                 if (props.late_payment) { goToBilling(); return; }
                                 props.setState({
                                   content_type: 0,
                                   my_platform_page: "add_content",
                                   from_subscriptions: props.current_page_view === 'subscriptions'
                                 });
                                 window.scrollTo({ top: 0, behavior: 'instant' });
                               }}
                             />
                      
                    ) : null}
                  </div>
                )}

                {(props.selected_tab === "sub_collections" ||
                  props.selected_tab === "paid_collections" ||
                  props.selected_tab === "collections") &&
                  !props.contentIsLoading &&
                  contentData.length === 0 &&
                  props.is_me && (
                    <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px" }}>
                      {/* COLLECTIONS - DESKTOP */}
                      <NoCollections
                        setState={props.setState}
                        my_platform_page={props.my_platform_page}
                        content_type={props.content_type}
                        disabled={false}
                        late_payment={props.late_payment}
                        windowWidth={props.windowWidth}
                        buttonAction={() => {
                          if (props.late_payment) { goToBilling(); return; }
                          // props.setState({ content_type: 0, my_platform_page: "add_content" });
                          // window.scrollTo({ top: 0, behavior: 'instant' });
                          props.setState({ newPlaylistModal: true })
                        }}
                      />
                     
                    </div>
                  )}

                {props.selected_tab === "membership" && (
                  <>
                    <MembershipOffering
                      setNewTierModal={setNewTierModal}
                      trialLength={props.trialLength}
                      setTrialLength={props.setTrialLength}
                      updateTrialLength={updateTrialLength}
                      openAddNewTier={openAddNewTier}
                      setOfferingError={setOfferingError}
                      offeringError={offeringError}
                      setEditOffering={setEditOffering}
                      setShowInitialSlide={setShowInitialSlide}
                      showInitialSlide={showInitialSlide}
                      editOffering={editOffering}
                      setTiersModal={(value) => {
                        props.setState({ tiersModal: value });
                      }}
                      tiersModal={props.tiersModal}
                      updateFreeActive={updateFreeActive}
                      freeActive={freeActive}
                      bronzeActive={bronzeActive}
                      silverActive={silverActive}
                      goldActive={goldActive}
                      asyncActive={asyncActive}
                      bronzeAnnualActive={bronzeAnnualActive}
                      bronzeMonthlyActive={bronzeMonthlyActive}
                      bronzeTierName={bronzeTierName}
                      bronzePerksText={bronzePerksText}
                      bronzeMonthlyPrice={bronzeMonthlyPrice}
                      bronzeYearlyPrice={bronzeYearlyPrice}
                      silverAnnualActive={silverAnnualActive}
                      silverMonthlyActive={silverMonthlyActive}
                      silverTierName={silverTierName}
                      silverPerksText={silverPerksText}
                      silverMonthlyPrice={silverMonthlyPrice}
                      silverYearlyPrice={silverYearlyPrice}
                      goldAnnualActive={goldAnnualActive}
                      goldMonthlyActive={goldMonthlyActive}
                      goldTierName={goldTierName}
                      goldPerksText={goldPerksText}
                      goldMonthlyPrice={goldMonthlyPrice}
                      goldYearlyPrice={goldYearlyPrice}
                      asyncAnnualActive={asyncAnnualActive}
                      asyncMonthlyActive={asyncMonthlyActive}
                      asyncTierHidden={asyncTierHidden}
                      asyncTierApply={asyncTierApply}
                      asyncTierName={asyncTierName}
                      asyncPerksText={asyncPerksText}
                      asyncMonthlyPrice={asyncMonthlyPrice}
                      asyncYearlyPrice={asyncYearlyPrice}
                      currency={currency}
                      currencySymbol={currencySymbol}
                      currencySymbolPost={currencySymbolPost}
                      openEditTier={openEditTier}
                      handleCloseTiers={props.handleCloseTiers}
                      setOpenOfferingWhatsThis={props.setOpenOfferingWhatsThis}
                      openOfferingWhatsThis={props.openOfferingWhatsThis}
                      asyncTier={asyncTier}
                      setAsyncTier={setAsyncTier}
                      influencerUsername={props.influencerUsername}
                      asyncPrice2Rebill={asyncPrice2Rebill}
                      asyncPrice2Time={asyncPrice2Time}
                      loadTierInfo={loadTierInfo}
                      openPaidDMs={() => setupPaidDMs()}
                      {...props}
                    />

                   
                  </>
                )}

                {props.selected_tab === "membership" || props.selected_tab === "async" ? (
                  <>
                    <Modal
                      open={newTierModal}
                      onClose={() => setNewTierModal(false)}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      disableAutoFocus={true}
                      sx={{
                        // margin: 'auto',
                        backgroundColor: "rgba(0,0,0,0.47)",
                        outline: "0",
                        borderRadius: "5px",
                        overflow: "hidden",
                        // minWidth: '50vw',
                        display: "flex",
                        zIndex: "9999",
                        lineHeight: "25px",
                        width: "100%",
                        minHeight: "100vh",
                        maxHeight: "100vh",
                      }}
                    >
                      <Grid
                        container
                        justifyContent="center"
                        sx={{
                          minHeight: "100vh",
                          display: "flex",
                          width: "100%",
                          margin: "auto",
                          maxHeight: "500px",
                          outline: "none",
                        }}
                      >
                        <SelfServe6AYourOfferingModal
                          current_user={props.current_user}
                          setNewTierModal={setNewTierModal}
                          updatedTierNameInput={updatedTierNameInput}
                          showSlider={showSlider}
                          setUpdatedTierNameInput={setUpdatedTierNameInput}
                          updatedMonthlyInput={updatedMonthlyInput}
                          setUpdatedMonthlyInput={setUpdatedMonthlyInput}
                          setShowInitialSlide={setShowInitialSlide}
                          updatedAnnualInput={updatedAnnualInput}
                          setUpdatedAnnualInput={setUpdatedAnnualInput}
                          setOpenOfferingWhatsThis={props.setOpenOfferingWhatsThis}
                          openOfferingWhatsThis={props.openOfferingWhatsThis}
                          editOffering={editOffering}
                          windowWidth={props.windowWidth}
                          setOfferingError={setOfferingError}
                          currency={currency}
                          currencySymbol={currencySymbol}
                          currencySymbolPost={currencySymbolPost}
                          setTiersModal={(value) => {
                            props.setState({ tiersModal: value });
                          }}
                          tierNum={tierNum}
                          tierName={tierName}
                          setTierName={setTierName}
                          perksText={perksText}
                          perksTextNum={perksTextNum}
                          monthlyPrice={monthlyPrice}
                          yearlyPrice={yearlyPrice}
                          annualActive={annualActive}
                          setMonthlyActive={setMonthlyActive}
                          setAnnualActive={setAnnualActive}
                          monthlyActive={monthlyActive}
                          tierHidden={tierHidden}
                          setTierHidden={setTierHidden}
                          tierApply={tierApply}
                          setTierApply={setTierApply}
                          monthlyPriceStr={monthlyPriceStr}
                          yearlyPriceStr={yearlyPriceStr}
                          setMonthlyPriceError={setMonthlyPriceError}
                          monthlyPriceError={monthlyPriceError}
                          setAnnualPriceError={setYearlyPriceError}
                          yearlyPriceError={yearlyPriceError}
                          setMonthlyPriceStr={setMonthlyPriceStr}
                          setAnnualPriceStr={setYearlyPriceStr}
                          updatePerks={updatePerks}
                          updatePerksRemove={updatePerksRemove}
                          updateTier={updateTier}
                          setMonthlyPrice={setMonthlyPrice}
                          setAnnualPrice={setYearlyPrice}
                          newTierBenefitsModal={newTierBenefitsModal}
                          setNewTierBenefitsModal={setNewTierBenefitsModal}
                          deleteTierModal={deleteTierModal}
                          setDeleteTierModal={setDeleteTierModal}
                          setWhatsThisModal={props.setWhatsThisModal}
                          deleteTier={deleteTier}
                          asyncTier={asyncTier}
                          setAsyncTier={setAsyncTier}
                          price2Rebill={price2Rebill}
                          price2Time={price2Time}
                          setPrice2Rebill={setPrice2Rebill}
                          setPrice2Time={setPrice2Time}
                          bronzeTierName={bronzeTierName}
                          silverTierName={silverTierName}
                          goldTierName={goldTierName}
                          asyncTierName={asyncTierName}
                          nMessages={nMessages}
                          setNMessages={setNMessages}
                        />
                      </Grid>
                    </Modal>

                    <Modal
                      open={props.whatsThisModal}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      disableAutoFocus={true}
                      sx={{
                        // margin: 'auto',
                        backgroundColor: "rgba(0,0,0,0.47)",
                        borderRadius: "5px",
                        overflow: "hidden",
                        minWidth: "50vw",
                        outline: "0",
                        display: "flex",
                        zIndex: "9999",
                        lineHeight: "25px",
                      }}
                    >
                      <Grid
                        container
                        justifyContent="center"
                        sx={{ borderRadius: "5px", margin: "auto", maxWidth: "1400px" }}
                      >
                        <Grid
                          style={{
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "30%",
                            minWidth: "350px",
                            backgroundColor: "white",
                            borderRadius: "10px",
                            height: "40vh",
                            minHeight: "500px",
                          }}
                        >
                          <Grid
                            container
                            sx={{ direction: "row", justifyContent: "center", alignItems: "center", display: "flex" }}
                          >
                            <Grid
                              md={12}
                              xs={12}
                              sx={{
                                marginTop: "10px",
                                direction: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                backgroundColor: "green",
                              }}
                            >
                              Image
                            </Grid>
                            <Grid
                              md={12}
                              xs={12}
                              sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}
                            >
                              <div style={{ textAlign: "center", paddingTop: "0px", marginTop: "0px" }}>
                                <h2>{t('selfServe.examplePopupTip')}</h2>
                              </div>
                            </Grid>
                            <Grid
                              md={12}
                              xs={12}
                              sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}
                            >
                              <div style={{ textAlign: "center", paddingTop: "0px", marginTop: "0px" }}>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus ac velit in odio
                                  suscipit semper. Ut ac cursus nunc.
                                </p>
                              </div>
                            </Grid>

                            <Grid container sx={{ width: "100%", justifyContent: "center", paddingTop: "20px" }}>
                              <BlueButton
                                style={{ paddingLeft: "70px", paddingRight: "70px" }}
                                onClick={() => {
                                  props.setState({ whatsThisModal: false });
                                }}
                              >
                                OK,Got it
                              </BlueButton>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Modal>
                  </>
                ) : null}

                {paidDMsModal ? (
                  <SetupPaidDMs
                    paidDMsModal={true}
                    setPaidDMsModal={setPaidDMsModal}
                    paidDMsActive={paidDMsActive}
                    setPaidDMsActive={setPaidDMsActive}
                    remainingPaidDMsCount={remainingPaidDMsCount}
                    setRemainingPaidDMsCount={setRemainingPaidDMsCount}
                    paidDMsOrderCount={paidDMsOrderCount}
                    setPaidDMsOrderCount={setPaidDMsOrderCount}
                    paidDMsMaximumMessageLength={paidDMsMaximumMessageLength}
                    paidDMsMinimumPrice={paidDMsMinimumPrice}
                    paidDMsMinimumPriceStr={paidDMsMinimumPriceStr}
                    paidDMsActiveSettings={paidDMsActiveSettings}
                    setPaidDMsMaximumMessageLength={setPaidDMsMaximumMessageLength}
                    setPaidDMsMinimumPrice={setPaidDMsMinimumPrice}
                    setPaidDMsMinimumPriceStr={setPaidDMsMinimumPriceStr}
                    setPaidDMsActiveSettings={setPaidDMsActiveSettings}
                    priceOfDMsError={priceOfDMsError}
                    setPriceOfDMsError={setPriceOfDMsError}
                    currency={currency}
                    currencySymbol={currencySymbol}
                    currencySymbolPost={currencySymbolPost}
                    setMaxMessageLength={props.setMaxMessageLength}
                    setState={props.setState}
                    handleTabNavigation={props.handleTabNavigation}
                    current_page_view={props.current_page_view}
                    windowWidth={props.windowWidth}
                    {...props}
                  />
                ) : null}

                {props.selected_tab === "async" && props.current_page_view !== 'subscriptions' ? (
                  <Async
                    display_name={props.display_name}
                    current_user={props.current_user}
                    current_user_icon={props.current_user_icon}
                    username={props.current_user}
                    is_me={props.is_me}
                    asyncActive={props.subscribe_popup_async_active}
                    influencer={props.influencer}
                    influencer_tiers={tiers}
                    active_influencer_tiers={activeTiers}
                    influencer_info={props.influencer_info}
                    OpenSubscribePopup={props.OpenSubscribePopup}
                    OpenWaitingListPopup={props.OpenWaitingListPopup}
                    CloseSubscribePopup={props.CloseSubscribePopup}
                    CloseWaitingListPopup={props.CloseWaitingListPopup}
                    currency={props.currency}
                    current_tier={props.subscribe_popup_current_tier}
                    post_id={props.post_id}
                    async_tier_access={props.async_tier_access}
                    selectedMemberTabOverwrite={props.selectedMemberTabOverwrite}
                    top_padding={TOP_CONTENT_PADDING}
                    handleProfileTabChange={props.handleProfileTabChange}
                    asyncAnnualActive={asyncAnnualActive}
                    asyncMonthlyActive={asyncMonthlyActive}
                    asyncTierHidden={asyncTierHidden}
                    asyncTierApply={asyncTierApply}
                    asyncTierName={asyncTierName}
                    asyncPerksText={asyncPerksText}
                    asyncMonthlyPrice={asyncMonthlyPrice}
                    asyncYearlyPrice={asyncYearlyPrice}
                    asyncTier={asyncTier}
                    setAsyncTier={setAsyncTier}
                    loadTierInfo={loadTierInfo}
                    influencerUsername={props.influencerUsername}
                    asyncPrice2Rebill={asyncPrice2Rebill}
                    asyncPrice2Time={asyncPrice2Time}
                    setTiersModal={(value) => {
                      props.setState({ tiersModal: value });
                    }}
                    openAddNewTier={openAddNewTier}
                    openEditTier={openEditTier}
                    async_apply={props.async_apply}
                    setState={props.setState}
                    scroll={props.open_coaching}
                    windowWidth={props.windowWidth}
                    {...props}
                  />
                ) : // when there is no async tier or members we handle it inside the async component itself
                null}

                {props.selected_tab === "paidDMs" ? (
                  <div>
                    <PaidDMs
                      influencer_bool={props.influencer_bool}
                      current_user={props.current_user}
                      display_name={props.display_name}
                      current_user_icon={props.current_user_icon}
                      username={props.current_user}
                      is_me={props.is_me}
                      influencer={props.influencer}
                      influencer_info={props.influencer_info}
                      currency={props.currency}
                      post_id={props.post_id}
                      dm_active={props.dm_active}
                      selectedMemberTabOverwrite={props.selectedMemberTabOverwrite}
                      top_padding={TOP_CONTENT_PADDING}
                      handleProfileTabChange={props.handleProfileTabChange}
                      openPaidDMs={() => setupPaidDMs()}
                      openDMCheckout={props.openDMCheckout}
                      paidDMsActiveSettings={paidDMsActiveSettings}
                      paidDMsModal={paidDMsModal}
                      updateHasMessage={props.updateHasMessage}
                      paidDMs_show={props.paidDMs_show}
                      maxMessageLength={props.maxMessageLength}
                      setMaxMessageLength={props.setMaxMessageLength}
                      scroll={props.open_messages}
                      {...props}
                    />
                  </div>
                ) : null}

                {props.selected_tab === "sign_up" && (
                  <div style={{ marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "40px" }}>
                    <LeadCapture
                      activeProductData={props.activeProductData}
                      showLeadCaptureSnackbar={props.showLeadCaptureSnackbar}
                      {...props}
                    />
                  </div>
                )}

                {props.selected_tab === "community" ? (
                  <div style={{ width: "100%", marginTop: props.windowWidth > 900 ? TOP_CONTENT_PADDING : "0px" }}>
                    {props.is_me ? (
                      <>
                        {props.community_is_active ||
                        (props.influencer_bool === true &&
                          (props.view_type === "user-subscribed" ||
                            props.view_type === "user-waitlist" ||
                            props.view_type === "user")) ? (
                          <Community
                            display_name={props.display_name}
                            current_user={props.current_user}
                            current_user_icon={props.current_user_icon}
                            influencer_icon={props.influencer_icon}
                            influencer_name={props.influencer_name}
                            username={props.current_user}
                            is_me={props.is_me}
                            influencer={props.influencer}
                            influencer_tiers={tiers}
                            active_influencer_tiers={activeTiersNoAsync}
                            influencer_info={props.influencer_info}
                            OpenSubscribePopup={props.OpenSubscribePopup}
                            OpenWaitingListPopup={props.OpenWaitingListPopup}
                            CloseSubscribePopup={props.CloseSubscribePopup}
                            CloseWaitingListPopup={props.CloseWaitingListPopup}
                            currency={props.currency}
                            current_tier={props.subscribe_popup_current_tier}
                            post_id={props.post_id}
                            tab_id={props.tab_id}
                            updateCommunityActive={props.updateCommunityActive}
                            view_type={props.view_type}
                            n_page_views={props.n_page_views}
                            connected_stripe_account_id={props.connected_stripe_account_id}
                            setState={props.setState}
                            mobilePreview={props.mobilePreview}
                            {...props}
                          />
                        ) : (
                          // Change to turn on / off
                          <SectionPlaceholder
                            windowWidth={props.windowWidth}
                            title={t('community.welcomeTitle')}
                            tooltipLink={null}
                            description={t('community.welcomeDescription')}
                            buttonText={props.community_is_active ? t('community.disableButton') : t('community.activateButton')}
                            buttonAction={() => {
                              props.handleOpenHiddenTabModal();
                              // props.handleProfileTabChange({},'dashboard')
                            }}
                            buttonTextSecondary={t('common.learnMore')}
                            buttonActionSecondary={() => {
                              window.open(
                                "https://help.withme.so/en/articles/6922173-marketing-101-community-board-best-practices",
                                "_blank"
                              );
                            }}
                            videoSrc={"https://openaccessimages.s3.eu-west-2.amazonaws.com/COMMUNITY+VIDEO+LIV.mp4"}
                            titleicon1={"🤝"}
                            titleicon2={"💬"}
                            titleicon3={"🤗"}
                            title1={t('community.benefit1Title')}
                            title2={t('community.benefit2Title')}
                            title3={t('community.benefit3Title')}
                            description1={t('community.benefit1Description')}
                            description2={t('community.benefit2Description')}
                            description3={t('community.benefit3Description')}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {props.community_is_active ? (
                          <Community
                            display_name={props.display_name}
                            current_user={props.current_user}
                            current_user_icon={props.current_user_icon}
                            influencer_icon={props.influencer_icon}
                            username={props.current_user}
                            influencer_name={props.influencer_name}
                            is_me={props.is_me}
                            influencer={props.influencer}
                            influencer_tiers={tiers}
                            active_influencer_tiers={activeTiers}
                            influencer_info={props.influencer_info}
                            OpenSubscribePopup={props.OpenSubscribePopup}
                            OpenWaitingListPopup={props.OpenWaitingListPopup}
                            CloseSubscribePopup={props.CloseSubscribePopup}
                            CloseWaitingListPopup={props.CloseWaitingListPopup}
                            currency={props.currency}
                            current_tier={props.subscribe_popup_current_tier}
                            post_id={props.post_id}
                            tab_id={props.tab_id}
                            updateCommunityActive={props.updateCommunityActive}
                            view_type={props.view_type}
                            n_page_views={props.n_page_views}
                            connected_stripe_account_id={props.connected_stripe_account_id}
                            setState={props.setState}
                            mobilePreview={props.mobilePreview}
                            {...props}
                          />
                        ) : null}
                      </>
                    )}
                  </div>
                ) : null}
              </div>
            )}
          </Grid>
        )}
      </div>}

      <SnackbarAlert
        msg={comment_snackbar_message}
        open={comment_snackbar}
        severity={comment_snackbar_type}
        backgroundColor={comment_snackbar_background}
        autoHide={comment_snackbar_autohide}
        handleClose={handleCommentSnackBarClose}
      />
      <ShareModal
        shareId={shareId}
        shareInfluencer={shareInfluencer}
        shareName={shareName}
        shareOpen={shareOpen}
        setShareOpen={setShareOpen}
      />
    </>
  );
};

export default function ClassicInfluencerContent(props) {
  return <PreviewAudienceContent {...props} ClassicContent={InfluencerContentOriginal} />;
}
